import React from 'react';
import classnames from 'classnames/bind';
import styles from '../styling/style.css';
import Helmet from 'react-helmet';
import {
  Valsi,
  Vlavla,
  Url,
  Mupli,
  PrituPixra
} from './selfu/sutysisku.js';
const cx = classnames.bind(styles);

const Comp = () => (
  <div>
    <Helmet title="Lojban language has been liberated" meta={[{
        name: 'Lojban language',
        content: 'forum, resources, sutysisku, jbotcan, parser'
      }
    ]} link={[{
        rel: 'shortcut icon',
        href: 'https://raw.githubusercontent.com/La-Lojban/suho-pixra-pe-la-jbotcan/master/favicon.ico'
      }
    ]}/>
    <h1>Lojban language has been liberated.</h1>
    <div className={cx('content-panel', 'paragraph')}>
      <div>
      <p><div>Lojban language has long suffered from having root words each representing a mishmash of sounds from words with similar meaning in 6 major languages of the world. E.g. take&nbsp;<Valsi valsi='brife'/> meaning "wind". A computer algorithm created it by mixing Chinese "fen" and English "breeze". What is more <Valsi valsi='brife'/> can mean both "wind" and "breeze". In other words you get words that neither sound like words in the source languages, nor have the same meaning as in the source languages.</div></p>
      <p><div>Sooner or later Lojban community had to deal with this case. The solution, which enters into force today, has long been expected.</div></p>
      <p><div>The whole lexicon of Lojban is recreated by direct borrowing from root languages. If a word in the source language has the form that Lojban morphology allows for then the word is borrowed as it is pronounced without any magical tricks.</div></p>
      <p><div>E.g. from now on the Lojban word for "sticky" is ....&nbsp;<Vlavla valsi='stiki'/>. It sticks in one's mind almost immediately.</div></p>
      <p><div>Or take the new Lojban word for "work". It's&nbsp;<Vlavla valsi='trabaxa'/> and pronounced as Spanish <Vlavla valsi='trabajar'/> (just without the final "r"). You no longer have to work hard to memorize Lojban words. And <Vlavla valsi='asxola'/>? It means "asshole", you bastard.</div></p>
      <p><div>The word for "breeze" is now&nbsp;<Vlavla valsi='briza'/> and it means "breeze" only, not just any kind of wind.</div></p>
      <p><div>Hey, French speakers! In your language&nbsp;<Valsi valsi='glagla'/> means "very cold" whereas in Lojban it means "very hot". No more worries. Since now in Lojban <Valsi valsi='glagla'/> can mean both "hot" and "cold" depending on context.</div></p>
      <p><div>As you can see from the table below some core concepts have several candidate forms. And some concepts don't have new forms. Missing forms will be created by Lojban community during the following year. And you can help this process! Make your proposals now, and who knows maybe your proposal will win.</div></p>
      <p><div>So that's it. The whole lexicon of Lojban is set free. Take a gulp of fresh air that is now breezing through semantic space.</div></p>
      </div>
      <table style={{fontSize: 11}} dir="ltr" border={1} cellSpacing={1} cellPadding={2}><colgroup><col /><col /><col /><col /><col /><col /><col /><col /><col /></colgroup>
  <tbody>
    <tr>
      <td>Older words</td>
      <td>Chinese</td>
      <td>English</td>
      <td>Hindi</td>
      <td>Spanish</td>
      <td>Russian</td>
      <td>Arabic</td>
      <td>New candidate words</td>
      <td>Meaning</td>
    </tr>
    <tr>
      <td>jbama</td>
      <td>jadan</td>
      <td>bam</td>
      <td>bam</td>
      <td>bomb</td>
      <td>bomb</td>
      <td>kunbula</td>
      <td>bomba kunbula</td>
      <td>bomb</td>
    </tr>
    <tr>
      <td>balni</td>
      <td>iantai</td>
      <td>balkani</td>
      <td>baramda</td>
      <td>balkon</td>
      <td>balkon</td>
      <td>curfa</td>
      <td>balkani balkona curfa</td>
      <td>balcony</td>
    </tr>
    <tr>
      <td>bukpu</td>
      <td>bu</td>
      <td>klat</td>
      <td>kapna</td>
      <td>pan</td>
      <td>sukno</td>
      <td>kumac</td>
      <td>klata kapna sukno</td>
      <td>cloth</td>
    </tr>
    <tr>
      <td>cripu</td>
      <td>ciau</td>
      <td>brij</td>
      <td>pul</td>
      <td>pont</td>
      <td>most</td>
      <td>kubr</td>
      <td>brija ponta mosta kubra</td>
      <td>bridge</td>
    </tr>
    <tr>
      <td>dakfu</td>
      <td>dau</td>
      <td>naif</td>
      <td>caku</td>
      <td>kotcii</td>
      <td>noc</td>
      <td>sikin</td>
      <td>- to be proposed -</td>
      <td>knife</td>
    </tr>
    <tr>
      <td>dinko</td>
      <td>din</td>
      <td>neil</td>
      <td>kol</td>
      <td>klav</td>
      <td>gvost</td>
      <td>masmar</td>
      <td>klava</td>
      <td>nail</td>
    </tr>
    <tr>
      <td>forca</td>
      <td>ca</td>
      <td>fork</td>
      <td>kanta</td>
      <td>ork</td>
      <td>vilk</td>
      <td>cauka</td>
      <td>forka kanta orka vilka</td>
      <td>fork</td>
    </tr>
    <tr>
      <td>janbe</td>
      <td>jun</td>
      <td>bel</td>
      <td>ganta</td>
      <td>kampan</td>
      <td>zvanok</td>
      <td>jaras</td>
      <td>ganta kampana zvanoka</td>
      <td>bell</td>
    </tr>
    <tr>
      <td>jesni</td>
      <td>jen</td>
      <td>nidl</td>
      <td>sui</td>
      <td>agux</td>
      <td>igla</td>
      <td>ibra</td>
      <td>nidla igla ibra</td>
      <td>needle</td>
    </tr>
    <tr>
      <td>julne</td>
      <td>uan</td>
      <td>net</td>
      <td>jal</td>
      <td>red</td>
      <td>siet</td>
      <td>cabaka</td>
      <td>- to be proposed -</td>
      <td>net</td>
    </tr>
    <tr>
      <td>komcu</td>
      <td>cu</td>
      <td>kom</td>
      <td>kangi</td>
      <td>pein</td>
      <td>grieben</td>
      <td>muct</td>
      <td>kangi mucta</td>
      <td>comb</td>
    </tr>
    <tr>
      <td>linsi</td>
      <td>lian</td>
      <td>cein</td>
      <td>janjir</td>
      <td>kaden</td>
      <td>sip</td>
      <td>silsila</td>
      <td>janjira silsila</td>
      <td>chain</td>
    </tr>
    <tr>
      <td>molki</td>
      <td>mo</td>
      <td>mil</td>
      <td>caki</td>
      <td>molin</td>
      <td>mielnis</td>
      <td>taxun</td>
      <td>- to be proposed -</td>
      <td>mill</td>
    </tr>
    <tr>
      <td>murta</td>
      <td>mu</td>
      <td>krtn</td>
      <td>parda</td>
      <td>kortin</td>
      <td>zanaviesk</td>
      <td>sitar</td>
      <td>parda kortina</td>
      <td>curtain</td>
    </tr>
    <tr>
      <td>sacki</td>
      <td>xuecai</td>
      <td>mac</td>
      <td>salai</td>
      <td>fosfor</td>
      <td>spick</td>
      <td>kibrit</td>
      <td>- to be proposed -</td>
      <td>match</td>
    </tr>
    <tr>
      <td>skori</td>
      <td>suo</td>
      <td>kord</td>
      <td>nor</td>
      <td>kord</td>
      <td>veriofk</td>
      <td>xabl</td>
      <td>korda xabla</td>
      <td>cord</td>
    </tr>
    <tr>
      <td>smoka</td>
      <td>ua</td>
      <td>stokin</td>
      <td>moza</td>
      <td>kalsetin</td>
      <td>nasok</td>
      <td>jaurab</td>
      <td>stokina</td>
      <td>sock</td>
    </tr>
    <tr>
      <td>stela</td>
      <td>sue</td>
      <td>lak</td>
      <td>tala</td>
      <td>seradur</td>
      <td>zamok</td>
      <td>kufl</td>
      <td>kufla</td>
      <td>lock</td>
    </tr>
    <tr>
      <td>vorme</td>
      <td>men</td>
      <td>dor</td>
      <td>dvar</td>
      <td>port</td>
      <td>dvir</td>
      <td>bab</td>
      <td>porta</td>
      <td>door</td>
    </tr>
    <tr>
      <td>canpa</td>
      <td>can</td>
      <td>cavl</td>
      <td>pavra</td>
      <td>pal</td>
      <td>lapat</td>
      <td>mijrafa</td>
      <td>cavla pavra mijrafa</td>
      <td>shovel</td>
    </tr>
    <tr>
      <td>cuntu</td>
      <td>ciuu</td>
      <td>afer</td>
      <td>udiam</td>
      <td>asunt</td>
      <td>diel</td>
      <td>can</td>
      <td>- to be proposed -</td>
      <td>affair</td>
    </tr>
    <tr>
      <td>danfu</td>
      <td>dafu</td>
      <td>ansr</td>
      <td>utar</td>
      <td>respond</td>
      <td>atvec</td>
      <td>ajaba</td>
      <td>- to be proposed -</td>
      <td>answer</td>
    </tr>
    <tr>
      <td>danlu</td>
      <td>dunuu</td>
      <td>anaml</td>
      <td>jantu</td>
      <td>animal</td>
      <td>jivotna</td>
      <td>xaiauan</td>
      <td>jantu</td>
      <td>animal</td>
    </tr>
    <tr>
      <td>fengu</td>
      <td>fenu</td>
      <td>angri</td>
      <td>krudva</td>
      <td>enoxad</td>
      <td>serditi</td>
      <td>gadib</td>
      <td>serditi</td>
      <td>angry</td>
    </tr>
    <tr>
      <td>jadni</td>
      <td>juanci</td>
      <td>adorn</td>
      <td>saja</td>
      <td>adorn</td>
      <td>ukrac</td>
      <td>zaiana</td>
      <td>- to be proposed -</td>
      <td>adorn</td>
    </tr>
    <tr>
      <td>janta</td>
      <td>jan</td>
      <td>akaunt</td>
      <td>ganana</td>
      <td>kont</td>
      <td>sciot</td>
      <td>xisab</td>
      <td>konta</td>
      <td>account</td>
    </tr>
    <tr>
      <td>lamji</td>
      <td>linjin</td>
      <td>ajeisnt</td>
      <td>samip</td>
      <td>lad</td>
      <td>riadom</td>
      <td>mujauir</td>
      <td>linjina</td>
      <td>adjacent</td>
    </tr>
    <tr>
      <td>panje</td>
      <td>xaimian</td>
      <td>spanj</td>
      <td>spanj</td>
      <td>esponx</td>
      <td>gupk</td>
      <td>isfanj</td>
      <td>gupka</td>
      <td>sponge</td>
    </tr>
    <tr>
      <td>penbi</td>
      <td>bi</td>
      <td>pen</td>
      <td>lekani</td>
      <td>plum</td>
      <td>ruck</td>
      <td>rica</td>
      <td>pluma rucka</td>
      <td>pen</td>
    </tr>
    <tr>
      <td>pijne</td>
      <td>biejen</td>
      <td>pin</td>
      <td>alpin</td>
      <td>alfiler</td>
      <td>bulafk</td>
      <td>dabus</td>
      <td>alpina</td>
      <td>pin</td>
    </tr>
    <tr>
      <td>pinsi</td>
      <td>tcianbi</td>
      <td>pensl</td>
      <td>pensil</td>
      <td>lapis</td>
      <td>karandac</td>
      <td>kalam</td>
      <td>pensila</td>
      <td>pencil</td>
    </tr>
    <tr>
      <td>plixa</td>
      <td>li</td>
      <td>plau</td>
      <td>xal</td>
      <td>arad</td>
      <td>pluk</td>
      <td>mixrat</td>
      <td>pluka</td>
      <td>plow</td>
    </tr>
    <tr>
      <td>pruni</td>
      <td>tancin</td>
      <td>sprin</td>
      <td>kamani</td>
      <td>moi</td>
      <td>prujin</td>
      <td>nabid</td>
      <td>tancina prujina</td>
      <td>elastic</td>
    </tr>
    <tr>
      <td>ragve</td>
      <td>gue</td>
      <td>akras</td>
      <td>ageko</td>
      <td>traves</td>
      <td>cieris</td>
      <td>abra</td>
      <td>travesa abra</td>
      <td>across</td>
    </tr>
    <tr>
      <td>stika</td>
      <td>tiaujen</td>
      <td>ajast</td>
      <td>tik</td>
      <td>axust</td>
      <td>padgani</td>
      <td>sabata</td>
      <td>padgani</td>
      <td>adjust</td>
    </tr>
    <tr>
      <td>tsina</td>
      <td>uutai</td>
      <td>steij</td>
      <td>macana</td>
      <td>esen</td>
      <td>sien</td>
      <td>minad</td>
      <td>- to be proposed -</td>
      <td>stage</td>
    </tr>
    <tr>
      <td>tugni</td>
      <td>tunii</td>
      <td>agri</td>
      <td>ekmat</td>
      <td>konkord</td>
      <td>soglacat</td>
      <td>uafaka</td>
      <td>agri ekmata</td>
      <td>agree</td>
    </tr>
    <tr>
      <td>vacri</td>
      <td>daci</td>
      <td>er</td>
      <td>vaiu</td>
      <td>air</td>
      <td>vozdux</td>
      <td>jaua</td>
      <td>- to be proposed -</td>
      <td>air</td>
    </tr>
    <tr>
      <td>zdile</td>
      <td>iule</td>
      <td>amiuzd</td>
      <td>baxala</td>
      <td>divert</td>
      <td>razvlek</td>
      <td>salita</td>
      <td>- to be proposed -</td>
      <td>amusing</td>
    </tr>
    <tr>
      <td>zukte</td>
      <td>zue</td>
      <td>akt</td>
      <td>karni</td>
      <td>akt</td>
      <td>diestf</td>
      <td>amal</td>
      <td>akta karni</td>
      <td>act</td>
    </tr>
    <tr>
      <td>bargu</td>
      <td>gun</td>
      <td>arc</td>
      <td>mexarab</td>
      <td>arke</td>
      <td>vigibat</td>
      <td>kaus</td>
      <td>arca arke</td>
      <td>arch</td>
    </tr>
    <tr>
      <td>birka</td>
      <td>bi</td>
      <td>arm</td>
      <td>baxu</td>
      <td>bras</td>
      <td>ruka</td>
      <td>dira</td>
      <td>arma brasa</td>
      <td>arm</td>
    </tr>
    <tr>
      <td>cabra</td>
      <td>cebei</td>
      <td>aparatas</td>
      <td>iantra</td>
      <td>aparat</td>
      <td>aparat</td>
      <td>jixaz</td>
      <td>- to be proposed -</td>
      <td>apparatus</td>
    </tr>
    <tr>
      <td>darlu</td>
      <td>jenluen</td>
      <td>argiu</td>
      <td>tarkana</td>
      <td>argumant</td>
      <td>dakaziv</td>
      <td>xadal</td>
      <td>tarkana</td>
      <td>argue</td>
    </tr>
    <tr>
      <td>ganxo</td>
      <td>gan</td>
      <td>asxol</td>
      <td>apan</td>
      <td>an</td>
      <td>zadniiproxod</td>
      <td>carj</td>
      <td>asxola carja</td>
      <td>anus</td>
    </tr>
    <tr>
      <td>gunta</td>
      <td>gun</td>
      <td>atak</td>
      <td>akriman</td>
      <td>atak</td>
      <td>napad</td>
      <td>xajam</td>
      <td>- to be proposed -</td>
      <td>attack</td>
    </tr>
    <tr>
      <td>jenmi</td>
      <td>juen</td>
      <td>armi</td>
      <td>sena</td>
      <td>exercit</td>
      <td>armii</td>
      <td>jaic</td>
      <td>armi</td>
      <td>army</td>
    </tr>
    <tr>
      <td>jundi</td>
      <td>juii</td>
      <td>atend</td>
      <td>dianalagana</td>
      <td>atend</td>
      <td>vnimatiln</td>
      <td>asfai</td>
      <td>- to be proposed -</td>
      <td>attentive</td>
    </tr>
    <tr>
      <td>manti</td>
      <td>maii</td>
      <td>ant</td>
      <td>cinta</td>
      <td>ormig</td>
      <td>muravie</td>
      <td>namla</td>
      <td>anta cinta ormiga namla</td>
      <td>ant</td>
    </tr>
    <tr>
      <td>plise</td>
      <td>pingue</td>
      <td>apl</td>
      <td>seb</td>
      <td>mansan</td>
      <td>iablak</td>
      <td>tufaxa</td>
      <td>apla mansana</td>
      <td>apple</td>
    </tr>
    <tr>
      <td>sepli</td>
      <td>fenli</td>
      <td>separet</td>
      <td>pritaku</td>
      <td>seperad</td>
      <td>otdielni</td>
      <td>baid</td>
      <td>fenli pritaku</td>
      <td>apart</td>
    </tr>
    <tr>
      <td>zanru</td>
      <td>zantun</td>
      <td>apruv</td>
      <td>anumodan</td>
      <td>aprob</td>
      <td>odabri</td>
      <td>rasiia</td>
      <td>zantuna</td>
      <td>approve</td>
    </tr>
    <tr>
      <td>badna</td>
      <td>cianjiau</td>
      <td>banan</td>
      <td>kadali</td>
      <td>banan</td>
      <td>banan</td>
      <td>muz</td>
      <td>- to be proposed -</td>
      <td>banana</td>
    </tr>
    <tr>
      <td>banxa</td>
      <td>iinxan</td>
      <td>bank</td>
      <td>bank</td>
      <td>bank</td>
      <td>bank</td>
      <td>bank</td>
      <td>banka</td>
      <td>bank</td>
    </tr>
    <tr>
      <td>barja</td>
      <td>jieubajian</td>
      <td>bar</td>
      <td>saraia</td>
      <td>bar</td>
      <td>bar</td>
      <td>bar</td>
      <td>- to be proposed -</td>
      <td>bar</td>
    </tr>
    <tr>
      <td>bifce</td>
      <td>mifen</td>
      <td>bi</td>
      <td>bramar</td>
      <td>abex</td>
      <td>pcel</td>
      <td>naxla</td>
      <td>bramara naxla</td>
      <td>bee</td>
    </tr>
    <tr>
      <td>bolci</td>
      <td>cieu</td>
      <td>bal</td>
      <td>gola</td>
      <td>bol</td>
      <td>car</td>
      <td>kura</td>
      <td>- to be proposed -</td>
      <td>ball</td>
    </tr>
    <tr>
      <td>ckana</td>
      <td>cuan</td>
      <td>bed</td>
      <td>caia</td>
      <td>kam</td>
      <td>kravat</td>
      <td>sarir</td>
      <td>kravata</td>
      <td>bed</td>
    </tr>
    <tr>
      <td>jicmu</td>
      <td>jicu</td>
      <td>faundeicn</td>
      <td>mul</td>
      <td>bas</td>
      <td>asnov</td>
      <td>asas</td>
      <td>- to be proposed -</td>
      <td>basis</td>
    </tr>
    <tr>
      <td>lanka</td>
      <td>lan</td>
      <td>baskit</td>
      <td>tokari</td>
      <td>kanast</td>
      <td>karzin</td>
      <td>sala</td>
      <td>karzina</td>
      <td>basket</td>
    </tr>
    <tr>
      <td>lanxe</td>
      <td>pinxen</td>
      <td>balans</td>
      <td>samtolana</td>
      <td>balans</td>
      <td>ravnoxesi</td>
      <td>mizan</td>
      <td>pinxena</td>
      <td>balance</td>
    </tr>
    <tr>
      <td>melbi</td>
      <td>mei</td>
      <td>biutafl</td>
      <td>manoxara</td>
      <td>bel</td>
      <td>krasiv</td>
      <td>jamil</td>
      <td>krasiva</td>
      <td>beautiful</td>
    </tr>
    <tr>
      <td>zbani</td>
      <td>uan</td>
      <td>bei</td>
      <td>kari</td>
      <td>bai</td>
      <td>zalif</td>
      <td>carm</td>
      <td>carma</td>
      <td>bay</td>
    </tr>
    <tr>
      <td>zmiku</td>
      <td>zidun</td>
      <td>atamatik</td>
      <td>apaseap</td>
      <td>automatik</td>
      <td>aftamaticesk</td>
      <td>utumatiki</td>
      <td>- to be proposed -</td>
      <td>automatic</td>
    </tr>
    <tr>
      <td>jirna</td>
      <td>jiau</td>
      <td>xorn</td>
      <td>singa</td>
      <td>korn</td>
      <td>rak</td>
      <td>karn</td>
      <td>xorna singa korna karna</td>
      <td>horn</td>
    </tr>
    <tr>
      <td>junla</td>
      <td>jun</td>
      <td>klak</td>
      <td>gari</td>
      <td>relo</td>
      <td>casi</td>
      <td>saat</td>
      <td>klaka</td>
      <td>clock</td>
    </tr>
    <tr>
      <td>zbabu</td>
      <td>zau</td>
      <td>sop</td>
      <td>sabun</td>
      <td>xabon</td>
      <td>mil</td>
      <td>sabun</td>
      <td>- to be proposed -</td>
      <td>soap</td>
    </tr>
    <tr>
      <td>catni</td>
      <td>cuan</td>
      <td>atorati</td>
      <td>cakti</td>
      <td>autoriz</td>
      <td>vlastn</td>
      <td>sulta</td>
      <td>cakti sulta</td>
      <td>authority</td>
    </tr>
    <tr>
      <td>cikna</td>
      <td>cin</td>
      <td>aueik</td>
      <td>jagna</td>
      <td>despiert</td>
      <td>bodrstvav</td>
      <td>istaikada</td>
      <td>jagna</td>
      <td>awake</td>
    </tr>
    <tr>
      <td>ckeji</td>
      <td>kuei</td>
      <td>ceim</td>
      <td>lajit</td>
      <td>avergons</td>
      <td>stidn</td>
      <td>xajil</td>
      <td>- to be proposed -</td>
      <td>ashamed</td>
    </tr>
    <tr>
      <td>jganu</td>
      <td>jiau</td>
      <td>angl</td>
      <td>gana</td>
      <td>angul</td>
      <td>ugal</td>
      <td>zaui</td>
      <td>angula</td>
      <td>angle</td>
    </tr>
    <tr>
      <td>larcu</td>
      <td>iicu</td>
      <td>art</td>
      <td>kala</td>
      <td>art</td>
      <td>iskustv</td>
      <td>fan</td>
      <td>arta</td>
      <td>art</td>
    </tr>
    <tr>
      <td>trina</td>
      <td>iin</td>
      <td>atrakt</td>
      <td>akarc</td>
      <td>atra</td>
      <td>pritiagiv</td>
      <td>jadab</td>
      <td>atra</td>
      <td>attract</td>
    </tr>
    <tr>
      <td>burcu</td>
      <td>cua</td>
      <td>brac</td>
      <td>burus</td>
      <td>broc</td>
      <td>ciotka</td>
      <td>furca</td>
      <td>braca broca furca</td>
      <td>brush</td>
    </tr>
    <tr>
      <td>kacma</td>
      <td>jaucianji</td>
      <td>kamra</td>
      <td>kemra</td>
      <td>kamar</td>
      <td>kamira</td>
      <td>kamira</td>
      <td>kamra kemra</td>
      <td>camera</td>
    </tr>
    <tr>
      <td>pambe</td>
      <td>ben</td>
      <td>pamp</td>
      <td>pamp</td>
      <td>bomb</td>
      <td>pomp</td>
      <td>midax</td>
      <td>pampa bomba pompa</td>
      <td>pump</td>
    </tr>
    <tr>
      <td>snipa</td>
      <td>nian</td>
      <td>stiki</td>
      <td>cipak</td>
      <td>pegadiso</td>
      <td>lipki</td>
      <td>lizak</td>
      <td>stiki lipki</td>
      <td>sticky</td>
    </tr>
    <tr>
      <td>balre</td>
      <td>ren</td>
      <td>bleid</td>
      <td>pal</td>
      <td>ox</td>
      <td>liezvi</td>
      <td>cafr</td>
      <td>cafra</td>
      <td>blade</td>
    </tr>
    <tr>
      <td>barda</td>
      <td>da</td>
      <td>larj</td>
      <td>bar</td>
      <td>grand</td>
      <td>balcoi</td>
      <td>kabir</td>
      <td>larja</td>
      <td>big</td>
    </tr>
    <tr>
      <td>batci</td>
      <td>ci</td>
      <td>bait</td>
      <td>kat</td>
      <td>mord</td>
      <td>kus</td>
      <td>kasam</td>
      <td>morda</td>
      <td>bite</td>
    </tr>
    <tr>
      <td>betfu</td>
      <td>fu</td>
      <td>beli</td>
      <td>pet</td>
      <td>vientr</td>
      <td>jivot</td>
      <td>batn</td>
      <td>batna</td>
      <td>abdomen</td>
    </tr>
    <tr>
      <td>birje</td>
      <td>pijieu</td>
      <td>bir</td>
      <td>biiar</td>
      <td>serves</td>
      <td>piv</td>
      <td>bir</td>
      <td>servesa</td>
      <td>beer</td>
    </tr>
    <tr>
      <td>ciblu</td>
      <td>ciue</td>
      <td>blad</td>
      <td>rakt</td>
      <td>sangr</td>
      <td>krof</td>
      <td>dam</td>
      <td>blada rakta krofa</td>
      <td>blood</td>
    </tr>
    <tr>
      <td>cipni</td>
      <td>cin</td>
      <td>brd</td>
      <td>cirii</td>
      <td>av</td>
      <td>ptis</td>
      <td>tair</td>
      <td>- to be proposed -</td>
      <td>bird</td>
    </tr>
    <tr>
      <td>jbini</td>
      <td>jian</td>
      <td>bituin</td>
      <td>bicmen</td>
      <td>entr</td>
      <td>miejd</td>
      <td>bin</td>
      <td>- to be proposed -</td>
      <td>between</td>
    </tr>
    <tr>
      <td>krici</td>
      <td>cin</td>
      <td>krid</td>
      <td>vicvas</td>
      <td>kre</td>
      <td>vierit</td>
      <td>itakad</td>
      <td>krida</td>
      <td>believe</td>
    </tr>
    <tr>
      <td>kurki</td>
      <td>ku</td>
      <td>akrid</td>
      <td>karu</td>
      <td>amarg</td>
      <td>gork</td>
      <td>mur</td>
      <td>gorka</td>
      <td>bitter</td>
    </tr>
    <tr>
      <td>tarti</td>
      <td>taidu</td>
      <td>kndakt</td>
      <td>viavxar</td>
      <td>komport</td>
      <td>vesti</td>
      <td>tasaraf</td>
      <td>vesti</td>
      <td>behave</td>
    </tr>
    <tr>
      <td>korcu</td>
      <td>cu</td>
      <td>kruked</td>
      <td>mor</td>
      <td>torsid</td>
      <td>krivo</td>
      <td>makuf</td>
      <td>krukeda torsida krivo</td>
      <td>bent</td>
    </tr>
    <tr>
      <td>blanu</td>
      <td>lan</td>
      <td>blu</td>
      <td>nil</td>
      <td>asul</td>
      <td>galuboi</td>
      <td>samau</td>
      <td>- to be proposed -</td>
      <td>blue</td>
    </tr>
    <tr>
      <td>bloti</td>
      <td>tin</td>
      <td>bot</td>
      <td>nav</td>
      <td>bot</td>
      <td>lotk</td>
      <td>markab</td>
      <td>lotka markaba</td>
      <td>boat</td>
    </tr>
    <tr>
      <td>bongu</td>
      <td>gu</td>
      <td>bon</td>
      <td>ast</td>
      <td>os</td>
      <td>kost</td>
      <td>adma</td>
      <td>asta kosta adma</td>
      <td>bone</td>
    </tr>
    <tr>
      <td>botpi</td>
      <td>pin</td>
      <td>batl</td>
      <td>botal</td>
      <td>botei</td>
      <td>butilk</td>
      <td>kinin</td>
      <td>batla</td>
      <td>bottle</td>
    </tr>
    <tr>
      <td>cukta</td>
      <td>cu</td>
      <td>buk</td>
      <td>pustak</td>
      <td>libr</td>
      <td>knik</td>
      <td>kitab</td>
      <td>libra</td>
      <td>book</td>
    </tr>
    <tr>
      <td>febvi</td>
      <td>fei</td>
      <td>boil</td>
      <td>ubal</td>
      <td>erv</td>
      <td>kipiit</td>
      <td>galai</td>
      <td>erva</td>
      <td>boil</td>
    </tr>
    <tr>
      <td>jbena</td>
      <td>cen</td>
      <td>ber</td>
      <td>janma</td>
      <td>nas</td>
      <td>rojdion</td>
      <td>maulud</td>
      <td>janma</td>
      <td>born</td>
    </tr>
    <tr>
      <td>jimca</td>
      <td>ji</td>
      <td>lim</td>
      <td>cak</td>
      <td>ram</td>
      <td>suk</td>
      <td>asna</td>
      <td>asna</td>
      <td>branch</td>
    </tr>
    <tr>
      <td>kluza</td>
      <td>kuan</td>
      <td>blauzd</td>
      <td>kurati</td>
      <td>blus</td>
      <td>blusk</td>
      <td>blauz</td>
      <td>blusa</td>
      <td>loose</td>
    </tr>
    <tr>
      <td>tanbo</td>
      <td>ban</td>
      <td>bord</td>
      <td>takt</td>
      <td>tabl</td>
      <td>daska</td>
      <td>laux</td>
      <td>borda takta tabla daska</td>
      <td>board</td>
    </tr>
    <tr>
      <td>xadni</td>
      <td>xai</td>
      <td>badi</td>
      <td>badan</td>
      <td>korp</td>
      <td>tiel</td>
      <td>badan</td>
      <td>korpa</td>
      <td>body</td>
    </tr>
    <tr>
      <td>tanxe</td>
      <td>xe</td>
      <td>trank</td>
      <td>sanduk</td>
      <td>trank</td>
      <td>karton</td>
      <td>sunduk</td>
      <td>sanduka kartona sunduka</td>
      <td>box</td>
    </tr>
    <tr>
      <td>batke</td>
      <td>keu</td>
      <td>batn</td>
      <td>batn</td>
      <td>boton</td>
      <td>pugovis</td>
      <td>zir</td>
      <td>batna</td>
      <td>button</td>
    </tr>
    <tr>
      <td>besna</td>
      <td>nau</td>
      <td>brein</td>
      <td>bej</td>
      <td>ses</td>
      <td>mosk</td>
      <td>dimag</td>
      <td>moska</td>
      <td>brain</td>
    </tr>
    <tr>
      <td>jabre</td>
      <td>ja</td>
      <td>breik</td>
      <td>brek</td>
      <td>fren</td>
      <td>tormas</td>
      <td>kabix</td>
      <td>breka frena tormasa</td>
      <td>brake</td>
    </tr>
    <tr>
      <td>cpedu</td>
      <td>cieu</td>
      <td>rikuest</td>
      <td>nivedan</td>
      <td>ped</td>
      <td>pros</td>
      <td>raj</td>
      <td>prosa</td>
      <td>request</td>
    </tr>
    <tr>
      <td>dacru</td>
      <td>ceuti</td>
      <td>drar</td>
      <td>daraj</td>
      <td>kaxon</td>
      <td>iacik</td>
      <td>jarur</td>
      <td>drara</td>
      <td>drawer</td>
    </tr>
    <tr>
      <td>gasnu</td>
      <td>gan</td>
      <td>du</td>
      <td>karn</td>
      <td>as</td>
      <td>diel</td>
      <td>amil</td>
      <td>karna</td>
      <td>do</td>
    </tr>
    <tr>
      <td>mamta</td>
      <td>ma</td>
      <td>mam</td>
      <td>mata</td>
      <td>mam</td>
      <td>mat</td>
      <td>am</td>
      <td>- to be proposed -</td>
      <td>mother</td>
    </tr>
    <tr>
      <td>nixli</td>
      <td>niuxai</td>
      <td>girl</td>
      <td>bali</td>
      <td>nin</td>
      <td>dievock</td>
      <td>ualda</td>
      <td>girla</td>
      <td>girl</td>
    </tr>
    <tr>
      <td>panlo</td>
      <td>pian</td>
      <td>sleis</td>
      <td>katl</td>
      <td>rebanad</td>
      <td>lomtik</td>
      <td>carix</td>
      <td>katla lomtika</td>
      <td>slice</td>
    </tr>
    <tr>
      <td>patfu</td>
      <td>fu</td>
      <td>pa</td>
      <td>pita</td>
      <td>pap</td>
      <td>pad</td>
      <td>ab</td>
      <td>- to be proposed -</td>
      <td>father</td>
    </tr>
    <tr>
      <td>verba</td>
      <td>er</td>
      <td>caild</td>
      <td>bac</td>
      <td>xoven</td>
      <td>pebionak</td>
      <td>tifl</td>
      <td>tifla</td>
      <td>child</td>
    </tr>
    <tr>
      <td>xamgu</td>
      <td>xau</td>
      <td>gud</td>
      <td>utam</td>
      <td>bon</td>
      <td>xaroc</td>
      <td>xaiid</td>
      <td>- to be proposed -</td>
      <td>good</td>
    </tr>
    <tr>
      <td>cradi</td>
      <td>uuciandian</td>
      <td>reidio</td>
      <td>rediio</td>
      <td>radio</td>
      <td>radio</td>
      <td>radiiu</td>
      <td>- to be proposed -</td>
      <td>radio</td>
    </tr>
    <tr>
      <td>daski</td>
      <td>dai</td>
      <td>pakit</td>
      <td>pakit</td>
      <td>bolsii</td>
      <td>karman</td>
      <td>jaibi</td>
      <td>karmana</td>
      <td>pocket</td>
    </tr>
    <tr>
      <td>gluta</td>
      <td>ceutau</td>
      <td>glav</td>
      <td>dastana</td>
      <td>guant</td>
      <td>percat</td>
      <td>kufaz</td>
      <td>glava percata</td>
      <td>glove</td>
    </tr>
    <tr>
      <td>greku</td>
      <td>geu</td>
      <td>freim</td>
      <td>danc</td>
      <td>estruktur</td>
      <td>struktur</td>
      <td>xaikal</td>
      <td>danca</td>
      <td>frame</td>
    </tr>
    <tr>
      <td>karli</td>
      <td>lin</td>
      <td>kalr</td>
      <td>gareban</td>
      <td>koi</td>
      <td>varatnik</td>
      <td>iaka</td>
      <td>kalra</td>
      <td>collar</td>
    </tr>
    <tr>
      <td>kosta</td>
      <td>uaii</td>
      <td>kot</td>
      <td>kot</td>
      <td>kasak</td>
      <td>palto</td>
      <td>sutra</td>
      <td>palto sutra</td>
      <td>coat</td>
    </tr>
    <tr>
      <td>palku</td>
      <td>ku</td>
      <td>pans</td>
      <td>patalun</td>
      <td>pantalon</td>
      <td>briuk</td>
      <td>sirual</td>
      <td>pansa</td>
      <td>pants</td>
    </tr>
    <tr>
      <td>taxfu</td>
      <td>fu</td>
      <td>garmnt</td>
      <td>paxnav</td>
      <td>trax</td>
      <td>adiejd</td>
      <td>taub</td>
      <td>paxnava traxa</td>
      <td>garment</td>
    </tr>
    <tr>
      <td>cilta</td>
      <td>cian</td>
      <td>filamnt</td>
      <td>taga</td>
      <td>il</td>
      <td>nitk</td>
      <td>xait</td>
      <td>nitka</td>
      <td>thread</td>
    </tr>
    <tr>
      <td>creka</td>
      <td>cencan</td>
      <td>crt</td>
      <td>kamiz</td>
      <td>kamis</td>
      <td>ruback</td>
      <td>kamis</td>
      <td>cencana</td>
      <td>shirt</td>
    </tr>
    <tr>
      <td>cutci</td>
      <td>cie</td>
      <td>cu</td>
      <td>juta</td>
      <td>sapat</td>
      <td>batinok</td>
      <td>naal</td>
      <td>- to be proposed -</td>
      <td>shoe</td>
    </tr>
    <tr>
      <td>fonxa</td>
      <td>dianxua</td>
      <td>fon</td>
      <td>telifon</td>
      <td>telefon</td>
      <td>tilifon</td>
      <td>xatif</td>
      <td>- to be proposed -</td>
      <td>telephone</td>
    </tr>
    <tr>
      <td>garna</td>
      <td>gan</td>
      <td>bar</td>
      <td>car</td>
      <td>bar</td>
      <td>piril</td>
      <td>kadib</td>
      <td>- to be proposed -</td>
      <td>rail</td>
    </tr>
    <tr>
      <td>palne</td>
      <td>pan</td>
      <td>trei</td>
      <td>tal</td>
      <td>bandex</td>
      <td>padnos</td>
      <td>sini</td>
      <td>bandexa padnosa</td>
      <td>tray</td>
    </tr>
    <tr>
      <td>pastu</td>
      <td>pau</td>
      <td>tunik</td>
      <td>vastr</td>
      <td>tunik</td>
      <td>mantii</td>
      <td>rub</td>
      <td>- to be proposed -</td>
      <td>robe</td>
    </tr>
    <tr>
      <td>santa</td>
      <td>san</td>
      <td>parasal</td>
      <td>cata</td>
      <td>paraguas</td>
      <td>zont</td>
      <td>midal</td>
      <td>zonta</td>
      <td>umbrella</td>
    </tr>
    <tr>
      <td>serti</td>
      <td>ti</td>
      <td>sterz</td>
      <td>siri</td>
      <td>eskaler</td>
      <td>liestnis</td>
      <td>sulam</td>
      <td>- to be proposed -</td>
      <td>stairs</td>
    </tr>
    <tr>
      <td>skaci</td>
      <td>ciun</td>
      <td>skrt</td>
      <td>skart</td>
      <td>sai</td>
      <td>iubk</td>
      <td>tanur</td>
      <td>- to be proposed -</td>
      <td>skirt</td>
    </tr>
    <tr>
      <td>tivni</td>
      <td>dianci</td>
      <td>tivi</td>
      <td>telivijan</td>
      <td>television</td>
      <td>tilividen</td>
      <td>tilfaz</td>
      <td>tilfaza</td>
      <td>television</td>
    </tr>
    <tr>
      <td>xarci</td>
      <td>uuci</td>
      <td>arm</td>
      <td>xatiar</td>
      <td>arm</td>
      <td>aruj</td>
      <td>silax</td>
      <td>arma</td>
      <td>weapon</td>
    </tr>
    <tr>
      <td>bikla</td>
      <td>bian</td>
      <td>lac</td>
      <td>cabuk</td>
      <td>latig</td>
      <td>bic</td>
      <td>saut</td>
      <td>- to be proposed -</td>
      <td>whip</td>
    </tr>
    <tr>
      <td>siclu</td>
      <td>cau</td>
      <td>uisl</td>
      <td>siti</td>
      <td>silb</td>
      <td>svisti</td>
      <td>safr</td>
      <td>silba safra</td>
      <td>whistle</td>
    </tr>
    <tr>
      <td>xekri</td>
      <td>xei</td>
      <td>blak</td>
      <td>kricn</td>
      <td>negr</td>
      <td>ciarn</td>
      <td>asuad</td>
      <td>blaka negra</td>
      <td>black</td>
    </tr>
    <tr>
      <td>mapku</td>
      <td>mau</td>
      <td>kap</td>
      <td>topi</td>
      <td>gor</td>
      <td>cliap</td>
      <td>kuba</td>
      <td>- to be proposed -</td>
      <td>cap</td>
    </tr>
    <tr>
      <td>bende</td>
      <td>iueduei</td>
      <td>band</td>
      <td>bend</td>
      <td>band</td>
      <td>orkestr</td>
      <td>jauka</td>
      <td>banda benda</td>
      <td>crew</td>
    </tr>
    <tr>
      <td>ckiku</td>
      <td>iau</td>
      <td>ki</td>
      <td>kunji</td>
      <td>iav</td>
      <td>kliuc</td>
      <td>mifta</td>
      <td>kunji mifta</td>
      <td>key</td>
    </tr>
    <tr>
      <td>genxu</td>
      <td>geu</td>
      <td>xuk</td>
      <td>kant</td>
      <td>ganc</td>
      <td>kriuk</td>
      <td>xutaf</td>
      <td>kanta ganca</td>
      <td>hook</td>
    </tr>
    <tr>
      <td>jinci</td>
      <td>jian</td>
      <td>cirz</td>
      <td>kainci</td>
      <td>tixer</td>
      <td>nojnis</td>
      <td>mikas</td>
      <td>cirza nojnisa</td>
      <td>shears</td>
    </tr>
    <tr>
      <td>klupe</td>
      <td>lue</td>
      <td>skru</td>
      <td>pec</td>
      <td>tornii</td>
      <td>vint</td>
      <td>burgi</td>
      <td>vinta burgi</td>
      <td>screw</td>
    </tr>
    <tr>
      <td>mruli</td>
      <td>cuei</td>
      <td>xamr</td>
      <td>martaul</td>
      <td>martii</td>
      <td>molot</td>
      <td>mitraka</td>
      <td>xamra</td>
      <td>hammer</td>
    </tr>
    <tr>
      <td>nanla</td>
      <td>nanxai</td>
      <td>lad</td>
      <td>balak</td>
      <td>nin</td>
      <td>malcik</td>
      <td>ualad</td>
      <td>malcika</td>
      <td>boy</td>
    </tr>
    <tr>
      <td>brife</td>
      <td>fen</td>
      <td>briz</td>
      <td>samir</td>
      <td>bris</td>
      <td>briz</td>
      <td>nasim</td>
      <td>briza brisa</td>
      <td>breeze</td>
    </tr>
    <tr>
      <td>carmi</td>
      <td>min</td>
      <td>brait</td>
      <td>camak</td>
      <td>brii</td>
      <td>iark</td>
      <td>lami</td>
      <td>- to be proposed -</td>
      <td>intense</td>
    </tr>
    <tr>
      <td>ganra</td>
      <td>guan</td>
      <td>brad</td>
      <td>caur</td>
      <td>anc</td>
      <td>cirok</td>
      <td>arid</td>
      <td>brada anca</td>
      <td>broad</td>
    </tr>
    <tr>
      <td>lastu</td>
      <td>xuantun</td>
      <td>bras</td>
      <td>pital</td>
      <td>laton</td>
      <td>latun</td>
      <td>nuxas</td>
      <td>brasa</td>
      <td>brass</td>
    </tr>
    <tr>
      <td>nanba</td>
      <td>mianbau</td>
      <td>bred</td>
      <td>nan</td>
      <td>pan</td>
      <td>xleb</td>
      <td>xubz</td>
      <td>breda xleba xubza</td>
      <td>bread</td>
    </tr>
    <tr>
      <td>porpi</td>
      <td>po</td>
      <td>breik</td>
      <td>torn</td>
      <td>romp</td>
      <td>lam</td>
      <td>kasar</td>
      <td>torna rompa</td>
      <td>break</td>
    </tr>
    <tr>
      <td>tatru</td>
      <td>ru</td>
      <td>tit</td>
      <td>stan</td>
      <td>tet</td>
      <td>sasok</td>
      <td>tadi</td>
      <td>stana</td>
      <td>breast</td>
    </tr>
    <tr>
      <td>vasxu</td>
      <td>xu</td>
      <td>brid</td>
      <td>cvas</td>
      <td>respir</td>
      <td>dic</td>
      <td>nafas</td>
      <td>brida</td>
      <td>breathe</td>
    </tr>
    <tr>
      <td>virnu</td>
      <td>iun</td>
      <td>valient</td>
      <td>vir</td>
      <td>valient</td>
      <td>xrabr</td>
      <td>cuja</td>
      <td>- to be proposed -</td>
      <td>brave</td>
    </tr>
    <tr>
      <td>baktu</td>
      <td>tun</td>
      <td>baket</td>
      <td>balt</td>
      <td>bald</td>
      <td>badia</td>
      <td>dal</td>
      <td>balta balda</td>
      <td>bucket</td>
    </tr>
    <tr>
      <td>balji</td>
      <td>linjin</td>
      <td>balb</td>
      <td>balb</td>
      <td>bulb</td>
      <td>lukavits</td>
      <td>basal</td>
      <td>linjina balba bulba</td>
      <td>bulb</td>
    </tr>
    <tr>
      <td>bruna</td>
      <td>ciun</td>
      <td>bradr</td>
      <td>brat</td>
      <td>erman</td>
      <td>brat</td>
      <td>ax</td>
      <td>brata ermana</td>
      <td>brother</td>
    </tr>
    <tr>
      <td>bunre</td>
      <td>zunse</td>
      <td>braun</td>
      <td>bur</td>
      <td>kastan</td>
      <td>bur</td>
      <td>asmar</td>
      <td>zunse</td>
      <td>brown</td>
    </tr>
    <tr>
      <td>karce</td>
      <td>ce</td>
      <td>kar</td>
      <td>kar</td>
      <td>automovil</td>
      <td>aftamabil</td>
      <td>saiar</td>
      <td>- to be proposed -</td>
      <td>car</td>
    </tr>
    <tr>
      <td>kicne</td>
      <td>dian</td>
      <td>kucn</td>
      <td>taki</td>
      <td>koxin</td>
      <td>poduck</td>
      <td>uisad</td>
      <td>kucna</td>
      <td>cushion</td>
    </tr>
    <tr>
      <td>spofu</td>
      <td>po</td>
      <td>brokn</td>
      <td>tut</td>
      <td>rot</td>
      <td>sloman</td>
      <td>kasar</td>
      <td>slomana</td>
      <td>broken</td>
    </tr>
    <tr>
      <td>stizu</td>
      <td>iiz</td>
      <td>stul</td>
      <td>kurs</td>
      <td>sii</td>
      <td>stul</td>
      <td>kursi</td>
      <td>stula kursa kursi</td>
      <td>chair</td>
    </tr>
    <tr>
      <td>simsa</td>
      <td>si</td>
      <td>simalr</td>
      <td>saduc</td>
      <td>similar</td>
      <td>padobn</td>
      <td>cabi</td>
      <td>- to be proposed -</td>
      <td>similar</td>
    </tr>
    <tr>
      <td>zbasu</td>
      <td>zau</td>
      <td>meik</td>
      <td>bana</td>
      <td>as</td>
      <td>praizvad</td>
      <td>sana</td>
      <td>- to be proposed -</td>
      <td>make</td>
    </tr>
    <tr>
      <td>zmadu</td>
      <td>due</td>
      <td>mor</td>
      <td>ziad</td>
      <td>mas</td>
      <td>bolc</td>
      <td>aziad</td>
      <td>bolca</td>
      <td>more</td>
    </tr>
    <tr>
      <td>purci</td>
      <td>ci</td>
      <td>rlir</td>
      <td>purv</td>
      <td>pasad</td>
      <td>procla</td>
      <td>madin</td>
      <td>purva</td>
      <td>past</td>
    </tr>
    <tr>
      <td>balvi</td>
      <td>jianlai</td>
      <td>leitr</td>
      <td>bavic</td>
      <td>futur</td>
      <td>buduc</td>
      <td>mukbil</td>
      <td>- to be proposed -</td>
      <td>future</td>
    </tr>
    <tr>
      <td>crino</td>
      <td>cin</td>
      <td>grin</td>
      <td>xarit</td>
      <td>verd</td>
      <td>zelion</td>
      <td>axdar</td>
      <td>grina verda</td>
      <td>green</td>
    </tr>
    <tr>
      <td>culno</td>
      <td>cun</td>
      <td>ful</td>
      <td>purn</td>
      <td>ien</td>
      <td>poln</td>
      <td>mali</td>
      <td>purna polna</td>
      <td>full</td>
    </tr>
    <tr>
      <td>galtu</td>
      <td>gau</td>
      <td>xai</td>
      <td>unc</td>
      <td>alt</td>
      <td>visok</td>
      <td>alin</td>
      <td>unca alta</td>
      <td>high</td>
    </tr>
    <tr>
      <td>grusi</td>
      <td>xuei</td>
      <td>grei</td>
      <td>dusar</td>
      <td>gris</td>
      <td>sier</td>
      <td>rasasi</td>
      <td>grisa</td>
      <td>gray</td>
    </tr>
    <tr>
      <td>klama</td>
      <td>lai</td>
      <td>kam</td>
      <td>ana</td>
      <td>ven</td>
      <td>it</td>
      <td>ja</td>
      <td>- to be proposed -</td>
      <td>come</td>
    </tr>
    <tr>
      <td>tarmi</td>
      <td>tai</td>
      <td>form</td>
      <td>akar</td>
      <td>form</td>
      <td>form</td>
      <td>cakl</td>
      <td>forma cakla</td>
      <td>shape</td>
    </tr>
    <tr>
      <td>turni</td>
      <td>tunji</td>
      <td>gavrn</td>
      <td>casan</td>
      <td>govern</td>
      <td>prav</td>
      <td>xakam</td>
      <td>tunji prava</td>
      <td>govern</td>
    </tr>
    <tr>
      <td>nenri</td>
      <td>nei</td>
      <td>inr</td>
      <td>men</td>
      <td>en</td>
      <td>vnutri</td>
      <td>fi</td>
      <td>inra</td>
      <td>in</td>
    </tr>
    <tr>
      <td>drudi</td>
      <td>uudin</td>
      <td>ruf</td>
      <td>cat</td>
      <td>tec</td>
      <td>dric</td>
      <td>satx</td>
      <td>drica satxa</td>
      <td>roof</td>
    </tr>
    <tr>
      <td>falnu</td>
      <td>fan</td>
      <td>seil</td>
      <td>pal</td>
      <td>val</td>
      <td>parus</td>
      <td>kalu</td>
      <td>- to be proposed -</td>
      <td>sail</td>
    </tr>
    <tr>
      <td>jmive</td>
      <td>min</td>
      <td>live</td>
      <td>jiv</td>
      <td>viv</td>
      <td>jiv</td>
      <td>xai</td>
      <td>- to be proposed -</td>
      <td>live</td>
    </tr>
    <tr>
      <td>jubme</td>
      <td>jue</td>
      <td>teibl</td>
      <td>mez</td>
      <td>mes</td>
      <td>stol</td>
      <td>mindad</td>
      <td>stola mindada</td>
      <td>table</td>
    </tr>
    <tr>
      <td>kajna</td>
      <td>jia</td>
      <td>kauntr</td>
      <td>kan</td>
      <td>anakel</td>
      <td>polk</td>
      <td>raf</td>
      <td>polka</td>
      <td>shelf</td>
    </tr>
    <tr>
      <td>narju</td>
      <td>juse</td>
      <td>arinj</td>
      <td>narang</td>
      <td>naranx</td>
      <td>aranjiv</td>
      <td>burtukal</td>
      <td>- to be proposed -</td>
      <td>orange</td>
    </tr>
    <tr>
      <td>prami</td>
      <td>reai</td>
      <td>lav</td>
      <td>prem</td>
      <td>am</td>
      <td>liub</td>
      <td>acik</td>
      <td>prema</td>
      <td>love</td>
    </tr>
    <tr>
      <td>saske</td>
      <td>keciue</td>
      <td>sains</td>
      <td>castr</td>
      <td>siensi</td>
      <td>nauk</td>
      <td>ilm</td>
      <td>ilma</td>
      <td>science</td>
    </tr>
    <tr>
      <td>sfofa</td>
      <td>cafa</td>
      <td>sof</td>
      <td>sofa</td>
      <td>sof</td>
      <td>sofa</td>
      <td>arik</td>
      <td>- to be proposed -</td>
      <td>sofa</td>
    </tr>
    <tr>
      <td>stuzi</td>
      <td>uei</td>
      <td>pazicn</td>
      <td>stiti</td>
      <td>siti</td>
      <td>miest</td>
      <td>makun</td>
      <td>stiti</td>
      <td>site</td>
    </tr>
    <tr>
      <td>xunre</td>
      <td>xun</td>
      <td>red</td>
      <td>arun</td>
      <td>rox</td>
      <td>krasn</td>
      <td>axmar</td>
      <td>axmara</td>
      <td>red</td>
    </tr>
    <tr>
      <td>bitmu</td>
      <td>bi</td>
      <td>ual</td>
      <td>bit</td>
      <td>mur</td>
      <td>stina</td>
      <td>xait</td>
      <td>stina</td>
      <td>wall</td>
    </tr>
    <tr>
      <td>blabi</td>
      <td>bai</td>
      <td>xuait</td>
      <td>cvet</td>
      <td>blank</td>
      <td>biel</td>
      <td>abiad</td>
      <td>- to be proposed -</td>
      <td>white</td>
    </tr>
    <tr>
      <td>canko</td>
      <td>cuan</td>
      <td>sindo</td>
      <td>kirk</td>
      <td>ventan</td>
      <td>akno</td>
      <td>cubak</td>
      <td>sindo kirka ventana akno</td>
      <td>window</td>
    </tr>
    <tr>
      <td>marce</td>
      <td>ce</td>
      <td>viakl</td>
      <td>gar</td>
      <td>veikul</td>
      <td>macin</td>
      <td>markab</td>
      <td>markaba</td>
      <td>vehicle</td>
    </tr>
    <tr>
      <td>pelxu</td>
      <td>xuan</td>
      <td>ielo</td>
      <td>pil</td>
      <td>amarii</td>
      <td>jelt</td>
      <td>asfar</td>
      <td>jelta</td>
      <td>yellow</td>
    </tr>
    <tr>
      <td>pilno</td>
      <td>iun</td>
      <td>emploi</td>
      <td>upiog</td>
      <td>us</td>
      <td>primin</td>
      <td>amal</td>
      <td>primina</td>
      <td>use</td>
    </tr>
    <tr>
      <td>tavla</td>
      <td>tan</td>
      <td>tak</td>
      <td>bakvad</td>
      <td>abl</td>
      <td>gavar</td>
      <td>kalam</td>
      <td>abla</td>
      <td>talk</td>
    </tr>
    <tr>
      <td>xislu</td>
      <td>luen</td>
      <td>xuil</td>
      <td>paxi</td>
      <td>rod</td>
      <td>kaliso</td>
      <td>ajal</td>
      <td>- to be proposed -</td>
      <td>wheel</td>
    </tr>
    <tr>
      <td>jelca</td>
      <td>cau</td>
      <td>brn</td>
      <td>jala</td>
      <td>kem</td>
      <td>jec</td>
      <td>axrak</td>
      <td>- to be proposed -</td>
      <td>burn</td>
    </tr>
    <tr>
      <td>matne</td>
      <td>xuanieu</td>
      <td>batr</td>
      <td>makan</td>
      <td>mantekii</td>
      <td>masl</td>
      <td>zubd</td>
      <td>batra masla zubda</td>
      <td>butter</td>
    </tr>
    <tr>
      <td>zargu</td>
      <td>pigu</td>
      <td>arse</td>
      <td>cutar</td>
      <td>nalg</td>
      <td>zad</td>
      <td>ridf</td>
      <td>arse nalga</td>
      <td>buttock</td>
    </tr>
    <tr>
      <td>bakfu</td>
      <td>bau</td>
      <td>pak</td>
      <td>gat</td>
      <td>paket</td>
      <td>pakiet</td>
      <td>rabat</td>
      <td>- to be proposed -</td>
      <td>bundle</td>
    </tr>
    <tr>
      <td>sabnu</td>
      <td>san</td>
      <td>kabn</td>
      <td>dabus</td>
      <td>kabin</td>
      <td>kabin</td>
      <td>kabin</td>
      <td>kabna</td>
      <td>cabin</td>
    </tr>
    <tr>
      <td>bevri</td>
      <td>bei</td>
      <td>ber</td>
      <td>dona</td>
      <td>iev</td>
      <td>nisti</td>
      <td>xamal</td>
      <td>nisti</td>
      <td>carry</td>
    </tr>
    <tr>
      <td>carce</td>
      <td>ce</td>
      <td>kart</td>
      <td>gari</td>
      <td>car</td>
      <td>kariet</td>
      <td>arab</td>
      <td>karta</td>
      <td>cart</td>
    </tr>
    <tr>
      <td>ginka</td>
      <td>iin</td>
      <td>kamp</td>
      <td>parav</td>
      <td>kampament</td>
      <td>lagir</td>
      <td>muxainam</td>
      <td>kampa</td>
      <td>camp</td>
    </tr>
    <tr>
      <td>jatna</td>
      <td>jan</td>
      <td>kaptn</td>
      <td>kaptan</td>
      <td>kapitan</td>
      <td>kapitan</td>
      <td>kubtan</td>
      <td>kaptana</td>
      <td>captain</td>
    </tr>
    <tr>
      <td>kakne</td>
      <td>nen</td>
      <td>kan</td>
      <td>sak</td>
      <td>kapas</td>
      <td>moc</td>
      <td>kadar</td>
      <td>- to be proposed -</td>
      <td>able</td>
    </tr>
    <tr>
      <td>karda</td>
      <td>kapian</td>
      <td>kard</td>
      <td>kard</td>
      <td>kart</td>
      <td>kartack</td>
      <td>bitak</td>
      <td>karda karta</td>
      <td>card</td>
    </tr>
    <tr>
      <td>kumte</td>
      <td>luetue</td>
      <td>kaml</td>
      <td>unt</td>
      <td>kamei</td>
      <td>virbliut</td>
      <td>jamal</td>
      <td>kamla unta</td>
      <td>camel</td>
    </tr>
    <tr>
      <td>kurji</td>
      <td>jin</td>
      <td>ker</td>
      <td>savdan</td>
      <td>kuid</td>
      <td>uxajiv</td>
      <td>raai</td>
      <td>savdana</td>
      <td>take care of</td>
    </tr>
    <tr>
      <td>naxle</td>
      <td>iuenxe</td>
      <td>kanal</td>
      <td>nal</td>
      <td>kanal</td>
      <td>kanal</td>
      <td>kanal</td>
      <td>- to be proposed -</td>
      <td>canal</td>
    </tr>
    <tr>
      <td>tabno</td>
      <td>tan</td>
      <td>karbn</td>
      <td>karban</td>
      <td>karbon</td>
      <td>uglirot</td>
      <td>karbun</td>
      <td>karbana karbona karbuna</td>
      <td>carbon</td>
    </tr>
    <tr>
      <td>kevna</td>
      <td>ken</td>
      <td>keiv</td>
      <td>kandra</td>
      <td>kov</td>
      <td>picier</td>
      <td>kaxf</td>
      <td>kaxfa</td>
      <td>cavity</td>
    </tr>
    <tr>
      <td>mlatu</td>
      <td>mau</td>
      <td>kat</td>
      <td>bilar</td>
      <td>gat</td>
      <td>kock</td>
      <td>kat</td>
      <td>kocka</td>
      <td>cat</td>
    </tr>
    <tr>
      <td>rinka</td>
      <td>iin</td>
      <td>kaz</td>
      <td>karn</td>
      <td>kaus</td>
      <td>pricin</td>
      <td>sabab</td>
      <td>karna pricina</td>
      <td>cause</td>
    </tr>
    <tr>
      <td>bakri</td>
      <td>baie</td>
      <td>cak</td>
      <td>kari</td>
      <td>klarion</td>
      <td>miel</td>
      <td>tabacir</td>
      <td>- to be proposed -</td>
      <td>chalk</td>
    </tr>
    <tr>
      <td>birti</td>
      <td>bi</td>
      <td>srtn</td>
      <td>stir</td>
      <td>siert</td>
      <td>uvierin</td>
      <td>tabit</td>
      <td>stira</td>
      <td>certain</td>
    </tr>
    <tr>
      <td>cartu</td>
      <td>tu</td>
      <td>cart</td>
      <td>nakca</td>
      <td>kart</td>
      <td>kart</td>
      <td>xarit</td>
      <td>carta nakca karta</td>
      <td>chart</td>
    </tr>
    <tr>
      <td>cirla</td>
      <td>lau</td>
      <td>ciz</td>
      <td>panir</td>
      <td>kes</td>
      <td>sir</td>
      <td>jubna</td>
      <td>jubna</td>
      <td>cheese</td>
    </tr>
    <tr>
      <td>cutne</td>
      <td>ciun</td>
      <td>cest</td>
      <td>cat</td>
      <td>pec</td>
      <td>grut</td>
      <td>sadr</td>
      <td>cesta gruta sadra</td>
      <td>chest</td>
    </tr>
    <tr>
      <td>dikca</td>
      <td>dian</td>
      <td>carj</td>
      <td>carj</td>
      <td>elektrik</td>
      <td>iliktricisk</td>
      <td>caxna</td>
      <td>carja caxna</td>
      <td>electric</td>
    </tr>
    <tr>
      <td>ralju</td>
      <td>ju</td>
      <td>prinsapal</td>
      <td>pramuk</td>
      <td>prinsipal</td>
      <td>glavn</td>
      <td>ransi</td>
      <td>pramuka ransi</td>
      <td>principal</td>
    </tr>
    <tr>
      <td>sisti</td>
      <td>tin</td>
      <td>sis</td>
      <td>ruk</td>
      <td>ses</td>
      <td>piristav</td>
      <td>kataa</td>
      <td>- to be proposed -</td>
      <td>cease</td>
    </tr>
    <tr>
      <td>xukmi</td>
      <td>xua</td>
      <td>kemikl</td>
      <td>rasaianik</td>
      <td>kimik</td>
      <td>ximicisk</td>
      <td>kimaui</td>
      <td>- to be proposed -</td>
      <td>chemical</td>
    </tr>
    <tr>
      <td>cakla</td>
      <td>ciaukeli</td>
      <td>caklat</td>
      <td>caklet</td>
      <td>cokolat</td>
      <td>cakalat</td>
      <td>cukulat</td>
      <td>- to be proposed -</td>
      <td>chocolate</td>
    </tr>
    <tr>
      <td>cuxna</td>
      <td>cuan</td>
      <td>cuz</td>
      <td>cuna</td>
      <td>escox</td>
      <td>vibir</td>
      <td>ixtar</td>
      <td>ixtara</td>
      <td>choose</td>
    </tr>
    <tr>
      <td>kliru</td>
      <td>liu</td>
      <td>klorin</td>
      <td>klorin</td>
      <td>klor</td>
      <td>xlor</td>
      <td>klur</td>
      <td>klorina klora xlora klura</td>
      <td>chlorine</td>
    </tr>
    <tr>
      <td>sigja</td>
      <td>ciuejia</td>
      <td>sigar</td>
      <td>sigar</td>
      <td>sigar</td>
      <td>sigar</td>
      <td>sigar</td>
      <td>- to be proposed -</td>
      <td>cigar</td>
    </tr>
    <tr>
      <td>tcadu</td>
      <td>du</td>
      <td>taun</td>
      <td>caxar</td>
      <td>siudad</td>
      <td>gorat</td>
      <td>madina</td>
      <td>- to be proposed -</td>
      <td>city</td>
    </tr>
    <tr>
      <td>ckafi</td>
      <td>kafei</td>
      <td>kafi</td>
      <td>kafi</td>
      <td>cafe</td>
      <td>kof</td>
      <td>kaxua</td>
      <td>- to be proposed -</td>
      <td>coffee</td>
    </tr>
    <tr>
      <td>dilnu</td>
      <td>iun</td>
      <td>klaud</td>
      <td>badal</td>
      <td>nub</td>
      <td>oblak</td>
      <td>gain</td>
      <td>- to be proposed -</td>
      <td>cloud</td>
    </tr>
    <tr>
      <td>ganlo</td>
      <td>guan</td>
      <td>kloz</td>
      <td>band</td>
      <td>ser</td>
      <td>sakriv</td>
      <td>agak</td>
      <td>kloza banda</td>
      <td>closed</td>
    </tr>
    <tr>
      <td>jinsa</td>
      <td>jin</td>
      <td>klin</td>
      <td>saf</td>
      <td>limpi</td>
      <td>cist</td>
      <td>nadif</td>
      <td>klina limpi cista</td>
      <td>clean</td>
    </tr>
    <tr>
      <td>klina</td>
      <td>cin</td>
      <td>klir</td>
      <td>vimal</td>
      <td>klar</td>
      <td>prazracn</td>
      <td>cafaf</td>
      <td>klira klara</td>
      <td>clear</td>
    </tr>
    <tr>
      <td>kolme</td>
      <td>mei</td>
      <td>kol</td>
      <td>koil</td>
      <td>karbon</td>
      <td>ugal</td>
      <td>faxm</td>
      <td>karbona faxma</td>
      <td>coal</td>
    </tr>
    <tr>
      <td>kufra</td>
      <td>cufu</td>
      <td>kamfrt</td>
      <td>aram</td>
      <td>konfort</td>
      <td>kamfartabil</td>
      <td>rax</td>
      <td>- to be proposed -</td>
      <td>comfort</td>
    </tr>
    <tr>
      <td>lenku</td>
      <td>len</td>
      <td>kul</td>
      <td>tard</td>
      <td>fir</td>
      <td>xalodn</td>
      <td>barid</td>
      <td>glagla</td>
      <td>cold</td>
    </tr>
    <tr>
      <td>skari</td>
      <td>sai</td>
      <td>kalr</td>
      <td>varn</td>
      <td>kolor</td>
      <td>tsviet</td>
      <td>laun</td>
      <td>kalra varna</td>
      <td>color</td>
    </tr>
    <tr>
      <td>cenba</td>
      <td>cen</td>
      <td>ceinj</td>
      <td>badal</td>
      <td>kambi</td>
      <td>menia</td>
      <td>gaiar</td>
      <td>kambi</td>
      <td>vary</td>
    </tr>
    <tr>
      <td>curmi</td>
      <td>cu</td>
      <td>prmit</td>
      <td>anumit</td>
      <td>permit</td>
      <td>pazval</td>
      <td>samax</td>
      <td>permita</td>
      <td>let</td>
    </tr>
    <tr>
      <td>djuno</td>
      <td>dun</td>
      <td>no</td>
      <td>jan</td>
      <td>konos</td>
      <td>zna</td>
      <td>alim</td>
      <td>- to be proposed -</td>
      <td>know</td>
    </tr>
    <tr>
      <td>fasnu</td>
      <td>facen</td>
      <td>xapn</td>
      <td>gatn</td>
      <td>okur</td>
      <td>sluc</td>
      <td>xasal</td>
      <td>xapna gatna sluca</td>
      <td>event</td>
    </tr>
    <tr>
      <td>flalu</td>
      <td>faliu</td>
      <td>la</td>
      <td>kanun</td>
      <td>legal</td>
      <td>zakon</td>
      <td>kanun</td>
      <td>- to be proposed -</td>
      <td>law</td>
    </tr>
    <tr>
      <td>gacri</td>
      <td>gai</td>
      <td>kavr</td>
      <td>acadan</td>
      <td>kubr</td>
      <td>kriv</td>
      <td>gatai</td>
      <td>kavra kubra kriva</td>
      <td>cover</td>
    </tr>
    <tr>
      <td>morsi</td>
      <td>si</td>
      <td>mort</td>
      <td>mrit</td>
      <td>mor</td>
      <td>miort</td>
      <td>maut</td>
      <td>morta mrita</td>
      <td>dead</td>
    </tr>
    <tr>
      <td>mulno</td>
      <td>uan</td>
      <td>kamplit</td>
      <td>sampurn</td>
      <td>komplet</td>
      <td>poln</td>
      <td>kamil</td>
      <td>polna</td>
      <td>complete</td>
    </tr>
    <tr>
      <td>traji</td>
      <td>ji</td>
      <td>ekstrim</td>
      <td>atiadik</td>
      <td>ekstrem</td>
      <td>krain</td>
      <td>mutatarif</td>
      <td>- to be proposed -</td>
      <td>superlative</td>
    </tr>
    <tr>
      <td>tumla</td>
      <td>tu</td>
      <td>land</td>
      <td>bum</td>
      <td>tier</td>
      <td>zemlia</td>
      <td>bilad</td>
      <td>landa</td>
      <td>land</td>
    </tr>
    <tr>
      <td>jorne</td>
      <td>jie</td>
      <td>join</td>
      <td>jor</td>
      <td>conekt</td>
      <td>sfiaziv</td>
      <td>rabat</td>
      <td>- to be proposed -</td>
      <td>joined</td>
    </tr>
    <tr>
      <td>merli</td>
      <td>lian</td>
      <td>mejr</td>
      <td>mapna</td>
      <td>med</td>
      <td>mier</td>
      <td>kias</td>
      <td>mejra mapna</td>
      <td>measure</td>
    </tr>
    <tr>
      <td>mutce</td>
      <td>cen</td>
      <td>muc</td>
      <td>baxut</td>
      <td>muc</td>
      <td>ocen</td>
      <td>jida</td>
      <td>- to be proposed -</td>
      <td>much</td>
    </tr>
    <tr>
      <td>muvdu</td>
      <td>dun</td>
      <td>muv</td>
      <td>cala</td>
      <td>mud</td>
      <td>dvig</td>
      <td>xarak</td>
      <td>- to be proposed -</td>
      <td>move</td>
    </tr>
    <tr>
      <td>ckaji</td>
      <td>ji</td>
      <td>kualati</td>
      <td>gurn</td>
      <td>kalidad</td>
      <td>kacestv</td>
      <td>naui</td>
      <td>gurna</td>
      <td>quality</td>
    </tr>
    <tr>
      <td>ckini</td>
      <td>cin</td>
      <td>kin</td>
      <td>sagotr</td>
      <td>parent</td>
      <td>radnia</td>
      <td>karib</td>
      <td>- to be proposed -</td>
      <td>related</td>
    </tr>
    <tr>
      <td>fatne</td>
      <td>fan</td>
      <td>rivrs</td>
      <td>ulat</td>
      <td>invert</td>
      <td>obratn</td>
      <td>aks</td>
      <td>aksa</td>
      <td>reverse</td>
    </tr>
    <tr>
      <td>javni</td>
      <td>jan</td>
      <td>rul</td>
      <td>niam</td>
      <td>regl</td>
      <td>pravil</td>
      <td>kaid</td>
      <td>regla pravila</td>
      <td>rule</td>
    </tr>
    <tr>
      <td>klani</td>
      <td>lian</td>
      <td>kuantati</td>
      <td>pariman</td>
      <td>kantidad</td>
      <td>kalicestv</td>
      <td>kami</td>
      <td>- to be proposed -</td>
      <td>quantity</td>
    </tr>
    <tr>
      <td>pixra</td>
      <td>xua</td>
      <td>pikcr</td>
      <td>citr</td>
      <td>pintur</td>
      <td>kartin</td>
      <td>sura</td>
      <td>citra pintura kartina</td>
      <td>picture</td>
    </tr>
    <tr>
      <td>ponse</td>
      <td>iunieu</td>
      <td>on</td>
      <td>malik</td>
      <td>pose</td>
      <td>ablad</td>
      <td>malak</td>
      <td>- to be proposed -</td>
      <td>possess</td>
    </tr>
    <tr>
      <td>punji</td>
      <td>ji</td>
      <td>put</td>
      <td>rak</td>
      <td>pon</td>
      <td>klast</td>
      <td>uada</td>
      <td>- to be proposed -</td>
      <td>put</td>
    </tr>
    <tr>
      <td>sevzi</td>
      <td>zi</td>
      <td>self</td>
      <td>svaiam</td>
      <td>si</td>
      <td>seb</td>
      <td>nafs</td>
      <td>selfa nafsa</td>
      <td>self</td>
    </tr>
    <tr>
      <td>sinxa</td>
      <td>xau</td>
      <td>sain</td>
      <td>sain</td>
      <td>sen</td>
      <td>simbal</td>
      <td>ramaz</td>
      <td>simbala</td>
      <td>sign</td>
    </tr>
    <tr>
      <td>viska</td>
      <td>kan</td>
      <td>viu</td>
      <td>vicar</td>
      <td>vist</td>
      <td>vid</td>
      <td>raa</td>
      <td>vista</td>
      <td>see</td>
    </tr>
    <tr>
      <td>canlu</td>
      <td>can</td>
      <td>valium</td>
      <td>vistar</td>
      <td>lugar</td>
      <td>prastranst</td>
      <td>makan</td>
      <td>- to be proposed -</td>
      <td>space</td>
    </tr>
    <tr>
      <td>cmalu</td>
      <td>ciau</td>
      <td>smal</td>
      <td>lagu</td>
      <td>peken</td>
      <td>mal</td>
      <td>kalil</td>
      <td>smala</td>
      <td>small</td>
    </tr>
    <tr>
      <td>ciste</td>
      <td>ci</td>
      <td>sistm</td>
      <td>viavastit</td>
      <td>sistem</td>
      <td>sistiem</td>
      <td>nidam</td>
      <td>- to be proposed -</td>
      <td>system</td>
    </tr>
    <tr>
      <td>claxu</td>
      <td>cau</td>
      <td>lak</td>
      <td>baxr</td>
      <td>sin</td>
      <td>bez</td>
      <td>bila</td>
      <td>baxra</td>
      <td>without</td>
    </tr>
    <tr>
      <td>stali</td>
      <td>lieu</td>
      <td>stei</td>
      <td>taxar</td>
      <td>rest</td>
      <td>astaits</td>
      <td>bakii</td>
      <td>resta</td>
      <td>remain</td>
    </tr>
    <tr>
      <td>temci</td>
      <td>ci</td>
      <td>tempo</td>
      <td>samai</td>
      <td>tiemp</td>
      <td>vriem</td>
      <td>uakt</td>
      <td>tempo</td>
      <td>time</td>
    </tr>
    <tr>
      <td>gunka</td>
      <td>gun</td>
      <td>urk</td>
      <td>kam</td>
      <td>trabax</td>
      <td>rabot</td>
      <td>amil</td>
      <td>urka trabaxa</td>
      <td>work</td>
    </tr>
    <tr>
      <td>xlali</td>
      <td>xuai</td>
      <td>mal</td>
      <td>bur</td>
      <td>mal</td>
      <td>plaxo</td>
      <td>radi</td>
      <td>plaxo</td>
      <td>bad</td>
    </tr>
    <tr>
      <td>ciska</td>
      <td>cie</td>
      <td>skraib</td>
      <td>lika</td>
      <td>eskrib</td>
      <td>pis</td>
      <td>katab</td>
      <td>- to be proposed -</td>
      <td>write</td>
    </tr>
    <tr>
      <td>trixe</td>
      <td>xeu</td>
      <td>rir</td>
      <td>pice</td>
      <td>tras</td>
      <td>zad</td>
      <td>uara</td>
      <td>trasa</td>
      <td>behind</td>
    </tr>
    <tr>
      <td>citka</td>
      <td>ci</td>
      <td>it</td>
      <td>kan</td>
      <td>kom</td>
      <td>iest</td>
      <td>akal</td>
      <td>- to be proposed -</td>
      <td>eat</td>
    </tr>
    <tr>
      <td>cusku</td>
      <td>cuo</td>
      <td>sei</td>
      <td>kax</td>
      <td>des</td>
      <td>skaz</td>
      <td>kala</td>
      <td>skaza</td>
      <td>express</td>
    </tr>
    <tr>
      <td>dunda</td>
      <td>sun</td>
      <td>doneit</td>
      <td>dena</td>
      <td>don</td>
      <td>dav</td>
      <td>atai</td>
      <td>- to be proposed -</td>
      <td>give</td>
    </tr>
    <tr>
      <td>farna</td>
      <td>fan</td>
      <td>darekcn</td>
      <td>taraf</td>
      <td>direksion</td>
      <td>starana</td>
      <td>tauji</td>
      <td>starana</td>
      <td>direction</td>
    </tr>
    <tr>
      <td>prenu</td>
      <td>ren</td>
      <td>prsn</td>
      <td>puruc</td>
      <td>person</td>
      <td>pirson</td>
      <td>caxs</td>
      <td>persona pirsona caxsa</td>
      <td>person</td>
    </tr>
    <tr>
      <td>valsi</td>
      <td>si</td>
      <td>urd</td>
      <td>vacan</td>
      <td>vokabl</td>
      <td>slov</td>
      <td>kalim</td>
      <td>urda slova</td>
      <td>word</td>
    </tr>
    <tr>
      <td>marji</td>
      <td>ji</td>
      <td>matr</td>
      <td>padart</td>
      <td>materi</td>
      <td>matier</td>
      <td>mad</td>
      <td>matra</td>
      <td>material</td>
    </tr>
    <tr>
      <td>pagbu</td>
      <td>bu</td>
      <td>part</td>
      <td>bag</td>
      <td>part</td>
      <td>cast</td>
      <td>juz</td>
      <td>parta casta</td>
      <td>part</td>
    </tr>
    <tr>
      <td>sutra</td>
      <td>su</td>
      <td>suift</td>
      <td>satvar</td>
      <td>rapid</td>
      <td>bistr</td>
      <td>saria</td>
      <td>- to be proposed -</td>
      <td>fast</td>
    </tr>
    <tr>
      <td>djedi</td>
      <td>jeu</td>
      <td>dei</td>
      <td>din</td>
      <td>di</td>
      <td>dien</td>
      <td>ium</td>
      <td>- to be proposed -</td>
      <td>full day</td>
    </tr>
    <tr>
      <td>djica</td>
      <td>iuan</td>
      <td>dizair</td>
      <td>ica</td>
      <td>dese</td>
      <td>jil</td>
      <td>ragib</td>
      <td>- to be proposed -</td>
      <td>desire</td>
    </tr>
    <tr>
      <td>minde</td>
      <td>min</td>
      <td>kamand</td>
      <td>adec</td>
      <td>mand</td>
      <td>prikaziv</td>
      <td>amar</td>
      <td>manda</td>
      <td>command</td>
    </tr>
    <tr>
      <td>platu</td>
      <td>tu</td>
      <td>plan</td>
      <td>kalpna</td>
      <td>plane</td>
      <td>plan</td>
      <td>xatat</td>
      <td>plana plane</td>
      <td>plan</td>
    </tr>
    <tr>
      <td>srera</td>
      <td>sue</td>
      <td>er</td>
      <td>bram</td>
      <td>ier</td>
      <td>acipk</td>
      <td>xata</td>
      <td>brama</td>
      <td>err</td>
    </tr>
    <tr>
      <td>bapli</td>
      <td>li</td>
      <td>kampel</td>
      <td>badi</td>
      <td>fors</td>
      <td>zastavl</td>
      <td>ajbar</td>
      <td>kampela forsa</td>
      <td>force</td>
    </tr>
    <tr>
      <td>cinmo</td>
      <td>cin</td>
      <td>imo</td>
      <td>sparc</td>
      <td>sent</td>
      <td>cufstvav</td>
      <td>axas</td>
      <td>senta</td>
      <td>emotion</td>
    </tr>
    <tr>
      <td>jetnu</td>
      <td>jen</td>
      <td>tru</td>
      <td>sati</td>
      <td>verdad</td>
      <td>pravdiv</td>
      <td>xakiki</td>
      <td>verdada</td>
      <td>TRUE</td>
    </tr>
    <tr>
      <td>pensi</td>
      <td>si</td>
      <td>pensiv</td>
      <td>cinti</td>
      <td>pens</td>
      <td>dum</td>
      <td>fakar</td>
      <td>pensiva cinti pensa</td>
      <td>think</td>
    </tr>
    <tr>
      <td>djacu</td>
      <td>cuei</td>
      <td>akua</td>
      <td>jal</td>
      <td>agu</td>
      <td>vada</td>
      <td>ma</td>
      <td>- to be proposed -</td>
      <td>water</td>
    </tr>
    <tr>
      <td>jinga</td>
      <td>iin</td>
      <td>uin</td>
      <td>jit</td>
      <td>gan</td>
      <td>viigr</td>
      <td>kasab</td>
      <td>- to be proposed -</td>
      <td>win</td>
    </tr>
    <tr>
      <td>slilu</td>
      <td>iau</td>
      <td>asaleit</td>
      <td>xil</td>
      <td>osil</td>
      <td>kalib</td>
      <td>xaz</td>
      <td>- to be proposed -</td>
      <td>oscillate</td>
    </tr>
    <tr>
      <td>vasru</td>
      <td>run</td>
      <td>vesl</td>
      <td>patr</td>
      <td>vasix</td>
      <td>sasut</td>
      <td>uia</td>
      <td>vesla patra</td>
      <td>contain</td>
    </tr>
    <tr>
      <td>kansa</td>
      <td>kan</td>
      <td>kampani</td>
      <td>sat</td>
      <td>kon</td>
      <td>sapravajd</td>
      <td>saxab</td>
      <td>kampani</td>
      <td>with</td>
    </tr>
    <tr>
      <td>ninmu</td>
      <td>niu</td>
      <td>uimin</td>
      <td>janan</td>
      <td>muxer</td>
      <td>jiencin</td>
      <td>nisa</td>
      <td>- to be proposed -</td>
      <td>woman</td>
    </tr>
    <tr>
      <td>bangu</td>
      <td>iuian</td>
      <td>languij</td>
      <td>bac</td>
      <td>lengu</td>
      <td>iizik</td>
      <td>lisan</td>
      <td>lengu</td>
      <td>language</td>
    </tr>
    <tr>
      <td>clani</td>
      <td>can</td>
      <td>lan</td>
      <td>lamb</td>
      <td>larg</td>
      <td>dlin</td>
      <td>tauil</td>
      <td>lamba larga</td>
      <td>long</td>
    </tr>
    <tr>
      <td>cnita</td>
      <td>cia</td>
      <td>binit</td>
      <td>tal</td>
      <td>abax</td>
      <td>vnis</td>
      <td>taxta</td>
      <td>taxta</td>
      <td>beneath</td>
    </tr>
    <tr>
      <td>crane</td>
      <td>cian</td>
      <td>frant</td>
      <td>samne</td>
      <td>frent</td>
      <td>piriedn</td>
      <td>kudam</td>
      <td>samne</td>
      <td>front</td>
    </tr>
    <tr>
      <td>nanmu</td>
      <td>nan</td>
      <td>man</td>
      <td>manuc</td>
      <td>ombr</td>
      <td>mucin</td>
      <td>insan</td>
      <td>insana</td>
      <td>man</td>
    </tr>
    <tr>
      <td>xance</td>
      <td>ceu</td>
      <td>xand</td>
      <td>xat</td>
      <td>man</td>
      <td>ruka</td>
      <td>iad</td>
      <td>xanda</td>
      <td>hand</td>
    </tr>
    <tr>
      <td>speni</td>
      <td>pei</td>
      <td>spaus</td>
      <td>vivax</td>
      <td>espos</td>
      <td>jen</td>
      <td>kalal</td>
      <td>- to be proposed -</td>
      <td>married</td>
    </tr>
    <tr>
      <td>bartu</td>
      <td>biau</td>
      <td>aut</td>
      <td>baxar</td>
      <td>for</td>
      <td>naruju</td>
      <td>xarij</td>
      <td>- to be proposed -</td>
      <td>out</td>
    </tr>
    <tr>
      <td>cortu</td>
      <td>tun</td>
      <td>xrt</td>
      <td>cot</td>
      <td>dolor</td>
      <td>bol</td>
      <td>alam</td>
      <td>- to be proposed -</td>
      <td>pain</td>
    </tr>
    <tr>
      <td>drata</td>
      <td>ta</td>
      <td>atr</td>
      <td>dusra</td>
      <td>otr</td>
      <td>drug</td>
      <td>axar</td>
      <td>atra dusra otra druga</td>
      <td>other</td>
    </tr>
    <tr>
      <td>jibni</td>
      <td>jin</td>
      <td>nir</td>
      <td>nikat</td>
      <td>serk</td>
      <td>blisk</td>
      <td>karib</td>
      <td>serka</td>
      <td>near</td>
    </tr>
    <tr>
      <td>namcu</td>
      <td>cu</td>
      <td>nambr</td>
      <td>ganan</td>
      <td>numer</td>
      <td>nomir</td>
      <td>rakm</td>
      <td>rakma</td>
      <td>number</td>
    </tr>
    <tr>
      <td>nicte</td>
      <td>ie</td>
      <td>nait</td>
      <td>nic</td>
      <td>noc</td>
      <td>noc</td>
      <td>lail</td>
      <td>- to be proposed -</td>
      <td>night</td>
    </tr>
    <tr>
      <td>cupra</td>
      <td>cu</td>
      <td>produs</td>
      <td>utpan</td>
      <td>produs</td>
      <td>praizvad</td>
      <td>antaj</td>
      <td>produsa utpana antaja</td>
      <td>produce</td>
    </tr>
    <tr>
      <td>jikca</td>
      <td>jiau</td>
      <td>socal</td>
      <td>samajik</td>
      <td>sosial</td>
      <td>apcats</td>
      <td>ijtima</td>
      <td>- to be proposed -</td>
      <td>socialize</td>
    </tr>
    <tr>
      <td>mipri</td>
      <td>mi</td>
      <td>sikrit</td>
      <td>cip</td>
      <td>sekret</td>
      <td>sekriet</td>
      <td>siri</td>
      <td>- to be proposed -</td>
      <td>secret</td>
    </tr>
    <tr>
      <td>pruce</td>
      <td>guecen</td>
      <td>prases</td>
      <td>prakram</td>
      <td>proses</td>
      <td>pratsies</td>
      <td>sairur</td>
      <td>prasesa prosesa</td>
      <td>process</td>
    </tr>
    <tr>
      <td>sance</td>
      <td>cen</td>
      <td>saund</td>
      <td>dvan</td>
      <td>son</td>
      <td>zvuk</td>
      <td>saut</td>
      <td>zvuka</td>
      <td>sound</td>
    </tr>
    <tr>
      <td>vlipa</td>
      <td>li</td>
      <td>paur</td>
      <td>cakt</td>
      <td>poder</td>
      <td>vlast</td>
      <td>cid</td>
      <td>cakta</td>
      <td>powerful</td>
    </tr>
    <tr>
      <td>krasi</td>
      <td>kai</td>
      <td>kamens</td>
      <td>aramb</td>
      <td>inisi</td>
      <td>nacin</td>
      <td>cara</td>
      <td>- to be proposed -</td>
      <td>source</td>
    </tr>
    <tr>
      <td>sorcu</td>
      <td>cu</td>
      <td>stor</td>
      <td>bandar</td>
      <td>surt</td>
      <td>zapas</td>
      <td>dajir</td>
      <td>stora bandara surta</td>
      <td>store</td>
    </tr>
    <tr>
      <td>tsali</td>
      <td>li</td>
      <td>stran</td>
      <td>bal</td>
      <td>fort</td>
      <td>siln</td>
      <td>kaui</td>
      <td>forta silna</td>
      <td>strong</td>
    </tr>
    <tr>
      <td>gleki</td>
      <td>le</td>
      <td>gei</td>
      <td>suki</td>
      <td>felis</td>
      <td>scasfliv</td>
      <td>said</td>
      <td>- to be proposed -</td>
      <td>happy</td>
    </tr>
    <tr>
      <td>grasu</td>
      <td>gau</td>
      <td>gris</td>
      <td>grit</td>
      <td>gras</td>
      <td>maslo</td>
      <td>samin</td>
      <td>grisa grita grasa maslo</td>
      <td>grease</td>
    </tr>
    <tr>
      <td>banro</td>
      <td>jan</td>
      <td>gro</td>
      <td>bar</td>
      <td>brot</td>
      <td>rasti</td>
      <td>nabat</td>
      <td>brota rasti</td>
      <td>grow</td>
    </tr>
    <tr>
      <td>linji</td>
      <td>ji</td>
      <td>linir</td>
      <td>rek</td>
      <td>line</td>
      <td>lini</td>
      <td>xat</td>
      <td>- to be proposed -</td>
      <td>line</td>
    </tr>
    <tr>
      <td>cmima</td>
      <td>iuan</td>
      <td>membr</td>
      <td>sadasi</td>
      <td>miembr</td>
      <td>clien</td>
      <td>udu</td>
      <td>- to be proposed -</td>
      <td>member</td>
    </tr>
    <tr>
      <td>facki</td>
      <td>facian</td>
      <td>faind</td>
      <td>avickar</td>
      <td>deskubr</td>
      <td>atkriv</td>
      <td>iktacaf</td>
      <td>- to be proposed -</td>
      <td>discover</td>
    </tr>
    <tr>
      <td>katna</td>
      <td>kan</td>
      <td>kat</td>
      <td>kat</td>
      <td>kort</td>
      <td>kas</td>
      <td>kata</td>
      <td>korta</td>
      <td>cut</td>
    </tr>
    <tr>
      <td>klaku</td>
      <td>ku</td>
      <td>krai</td>
      <td>vilap</td>
      <td>ior</td>
      <td>plak</td>
      <td>baka</td>
      <td>plaka</td>
      <td>weep</td>
    </tr>
    <tr>
      <td>krixa</td>
      <td>xan</td>
      <td>krai</td>
      <td>cila</td>
      <td>grit</td>
      <td>kric</td>
      <td>sarax</td>
      <td>grita krica</td>
      <td>cry out</td>
    </tr>
    <tr>
      <td>kulnu</td>
      <td>uen</td>
      <td>kalcr</td>
      <td>sabiat</td>
      <td>kultur</td>
      <td>kultur</td>
      <td>takaf</td>
      <td>kultura</td>
      <td>culture</td>
    </tr>
    <tr>
      <td>mitre</td>
      <td>mi</td>
      <td>mitr</td>
      <td>mitar</td>
      <td>metr</td>
      <td>mietr</td>
      <td>mitr</td>
      <td>mitra metra</td>
      <td>meter</td>
    </tr>
    <tr>
      <td>sanmi</td>
      <td>san</td>
      <td>mil</td>
      <td>bojan</td>
      <td>sen</td>
      <td>eda</td>
      <td>taam</td>
      <td>- to be proposed -</td>
      <td>meal</td>
    </tr>
    <tr>
      <td>sefta</td>
      <td>se</td>
      <td>srfis</td>
      <td>satax</td>
      <td>kostad</td>
      <td>pavierxnast</td>
      <td>satxa</td>
      <td>satxa</td>
      <td>surface</td>
    </tr>
    <tr>
      <td>bersa</td>
      <td>er</td>
      <td>san</td>
      <td>beta</td>
      <td>ix</td>
      <td>sin</td>
      <td>ibn</td>
      <td>ibna</td>
      <td>son</td>
    </tr>
    <tr>
      <td>pruxi</td>
      <td>guei</td>
      <td>spirit</td>
      <td>pret</td>
      <td>espiritu</td>
      <td>dux</td>
      <td>rux</td>
      <td>spirita preta</td>
      <td>spirit</td>
    </tr>
    <tr>
      <td>suksa</td>
      <td>su</td>
      <td>sadn</td>
      <td>saxsa</td>
      <td>subit</td>
      <td>vdruk</td>
      <td>faja</td>
      <td>sadna saxsa</td>
      <td>sudden</td>
    </tr>
    <tr>
      <td>cidja</td>
      <td>ci</td>
      <td>fid</td>
      <td>bojan</td>
      <td>komid</td>
      <td>pic</td>
      <td>gida</td>
      <td>- to be proposed -</td>
      <td>food</td>
    </tr>
    <tr>
      <td>fetsi</td>
      <td>si</td>
      <td>fem</td>
      <td>stri</td>
      <td>feminin</td>
      <td>jiensk</td>
      <td>uncau</td>
      <td>- to be proposed -</td>
      <td>female</td>
    </tr>
    <tr>
      <td>spoja</td>
      <td>ja</td>
      <td>iksplod</td>
      <td>vispot</td>
      <td>eksplo</td>
      <td>vzriv</td>
      <td>fajar</td>
      <td>- to be proposed -</td>
      <td>explode</td>
    </tr>
    <tr>
      <td>catlu</td>
      <td>ciau</td>
      <td>luk</td>
      <td>dek</td>
      <td>mir</td>
      <td>smatr</td>
      <td>tatala</td>
      <td>- to be proposed -</td>
      <td>look</td>
    </tr>
    <tr>
      <td>grake</td>
      <td>ke</td>
      <td>gram</td>
      <td>gram</td>
      <td>gram</td>
      <td>gram</td>
      <td>giram</td>
      <td>grama</td>
      <td>gram</td>
    </tr>
    <tr>
      <td>krefu</td>
      <td>fu</td>
      <td>rikr</td>
      <td>pir</td>
      <td>rekur</td>
      <td>pere</td>
      <td>takrar</td>
      <td>rikra</td>
      <td>recur</td>
    </tr>
    <tr>
      <td>lijda</td>
      <td>jiau</td>
      <td>rilij</td>
      <td>darm</td>
      <td>relixio</td>
      <td>religi</td>
      <td>din</td>
      <td>darma</td>
      <td>religion</td>
    </tr>
    <tr>
      <td>mlana</td>
      <td>mian</td>
      <td>latrl</td>
      <td>satax</td>
      <td>lad</td>
      <td>starana</td>
      <td>janib</td>
      <td>starana</td>
      <td>side</td>
    </tr>
    <tr>
      <td>rinju</td>
      <td>ju</td>
      <td>ristrein</td>
      <td>pratiband</td>
      <td>refren</td>
      <td>abuzdiv</td>
      <td>kabax</td>
      <td>- to be proposed -</td>
      <td>restrain</td>
    </tr>
    <tr>
      <td>ganse</td>
      <td>gan</td>
      <td>sens</td>
      <td>sanved</td>
      <td>sentid</td>
      <td>custv</td>
      <td>xas</td>
      <td>sensa sanveda sentida</td>
      <td>sense</td>
    </tr>
    <tr>
      <td>pluta</td>
      <td>lu</td>
      <td>rut</td>
      <td>rasta</td>
      <td>rut</td>
      <td>put</td>
      <td>tarik</td>
      <td>rasta</td>
      <td>route</td>
    </tr>
    <tr>
      <td>sligu</td>
      <td>gu</td>
      <td>salid</td>
      <td>ganibut</td>
      <td>solid</td>
      <td>salidn</td>
      <td>sulba</td>
      <td>sulba</td>
      <td>solid</td>
    </tr>
    <tr>
      <td>tordu</td>
      <td>duan</td>
      <td>cort</td>
      <td>tor</td>
      <td>kort</td>
      <td>karotk</td>
      <td>kasir</td>
      <td>corta korta</td>
      <td>short</td>
    </tr>
    <tr>
      <td>xamsi</td>
      <td>xai</td>
      <td>si</td>
      <td>samudr</td>
      <td>mar</td>
      <td>mor</td>
      <td>iam</td>
      <td>- to be proposed -</td>
      <td>sea</td>
    </tr>
    <tr>
      <td>jamna</td>
      <td>jan</td>
      <td>uor</td>
      <td>samar</td>
      <td>ger</td>
      <td>voina</td>
      <td>xarb</td>
      <td>xarba</td>
      <td>war</td>
    </tr>
    <tr>
      <td>lebna</td>
      <td>na</td>
      <td>teik</td>
      <td>le</td>
      <td>tom</td>
      <td>brat</td>
      <td>ajad</td>
      <td>brata</td>
      <td>take</td>
    </tr>
    <tr>
      <td>vamji</td>
      <td>ji</td>
      <td>valiu</td>
      <td>dam</td>
      <td>valu</td>
      <td>sienast</td>
      <td>taman</td>
      <td>- to be proposed -</td>
      <td>value</td>
    </tr>
    <tr>
      <td>renro</td>
      <td>ren</td>
      <td>tro</td>
      <td>penk</td>
      <td>arox</td>
      <td>broc</td>
      <td>kadaf</td>
      <td>penka broca</td>
      <td>throw</td>
    </tr>
    <tr>
      <td>drani</td>
      <td>dan</td>
      <td>rait</td>
      <td>tik</td>
      <td>korekt</td>
      <td>praviln</td>
      <td>saxix</td>
      <td>- to be proposed -</td>
      <td>correct</td>
    </tr>
    <tr>
      <td>frica</td>
      <td>ca</td>
      <td>difr</td>
      <td>farak</td>
      <td>difer</td>
      <td>razlic</td>
      <td>farik</td>
      <td>difra razlica</td>
      <td>differ</td>
    </tr>
    <tr>
      <td>jitfa</td>
      <td>jia</td>
      <td>fals</td>
      <td>jut</td>
      <td>fals</td>
      <td>loj</td>
      <td>kadib</td>
      <td>falsa</td>
      <td>FALSE</td>
    </tr>
    <tr>
      <td>tixnu</td>
      <td>nu</td>
      <td>datr</td>
      <td>beti</td>
      <td>ix</td>
      <td>doc</td>
      <td>ibna</td>
      <td>datra ibna</td>
      <td>daughter</td>
    </tr>
    <tr>
      <td>flecu</td>
      <td>lieu</td>
      <td>flo</td>
      <td>bax</td>
      <td>flu</td>
      <td>tiec</td>
      <td>jaraian</td>
      <td>- to be proposed -</td>
      <td>flow</td>
    </tr>
    <tr>
      <td>pajni</td>
      <td>pan</td>
      <td>jaj</td>
      <td>narni</td>
      <td>xusg</td>
      <td>sud</td>
      <td>kadai</td>
      <td>narni</td>
      <td>judge</td>
    </tr>
    <tr>
      <td>remna</td>
      <td>ren</td>
      <td>iumn</td>
      <td>manav</td>
      <td>uman</td>
      <td>liutsko</td>
      <td>incan</td>
      <td>incana</td>
      <td>human</td>
    </tr>
    <tr>
      <td>xrani</td>
      <td>xai</td>
      <td>xrt</td>
      <td>xan</td>
      <td>dan</td>
      <td>ran</td>
      <td>adi</td>
      <td>- to be proposed -</td>
      <td>injure</td>
    </tr>
    <tr>
      <td>cabna</td>
      <td>cian</td>
      <td>nau</td>
      <td>ab</td>
      <td>aor</td>
      <td>seicas</td>
      <td>alan</td>
      <td>- to be proposed -</td>
      <td>now</td>
    </tr>
    <tr>
      <td>cladu</td>
      <td>cau</td>
      <td>laud</td>
      <td>tivr</td>
      <td>for</td>
      <td>gromk</td>
      <td>jaxir</td>
      <td>tivra</td>
      <td>loud</td>
    </tr>
    <tr>
      <td>kalri</td>
      <td>kai</td>
      <td>opn</td>
      <td>kol</td>
      <td>abr</td>
      <td>atkriv</td>
      <td>fatax</td>
      <td>opna abra</td>
      <td>open</td>
    </tr>
    <tr>
      <td>kelci</td>
      <td>ci</td>
      <td>plei</td>
      <td>kel</td>
      <td>xug</td>
      <td>igr</td>
      <td>laib</td>
      <td>igra</td>
      <td>play</td>
    </tr>
    <tr>
      <td>litki</td>
      <td>ieti</td>
      <td>likuid</td>
      <td>drav</td>
      <td>likid</td>
      <td>jitk</td>
      <td>sail</td>
      <td>drava jitka</td>
      <td>liquid</td>
    </tr>
    <tr>
      <td>minji</td>
      <td>ji</td>
      <td>macin</td>
      <td>macin</td>
      <td>makin</td>
      <td>macin</td>
      <td>makin</td>
      <td>- to be proposed -</td>
      <td>machine</td>
    </tr>
    <tr>
      <td>pinta</td>
      <td>pin</td>
      <td>xarazantl</td>
      <td>talmap</td>
      <td>orizontal</td>
      <td>garizontal</td>
      <td>saua</td>
      <td>talmapa</td>
      <td>level</td>
    </tr>
    <tr>
      <td>barna</td>
      <td>ban</td>
      <td>mark</td>
      <td>mark</td>
      <td>mark</td>
      <td>piitna</td>
      <td>atar</td>
      <td>marka</td>
      <td>mark</td>
    </tr>
    <tr>
      <td>nakni</td>
      <td>nan</td>
      <td>maskialin</td>
      <td>nar</td>
      <td>maskulin</td>
      <td>mucsk</td>
      <td>dakar</td>
      <td>- to be proposed -</td>
      <td>male</td>
    </tr>
    <tr>
      <td>penmi</td>
      <td>pen</td>
      <td>mit</td>
      <td>mil</td>
      <td>enkontr</td>
      <td>vstric</td>
      <td>lakai</td>
      <td>- to be proposed -</td>
      <td>meet</td>
    </tr>
    <tr>
      <td>cmana</td>
      <td>can</td>
      <td>mauntn</td>
      <td>paxar</td>
      <td>montan</td>
      <td>gara</td>
      <td>jabal</td>
      <td>montana</td>
      <td>mountain</td>
    </tr>
    <tr>
      <td>cmene</td>
      <td>cen</td>
      <td>neim</td>
      <td>man</td>
      <td>monbre</td>
      <td>imen</td>
      <td>ism</td>
      <td>isma</td>
      <td>name</td>
    </tr>
    <tr>
      <td>midju</td>
      <td>jun</td>
      <td>midl</td>
      <td>madi</td>
      <td>medi</td>
      <td>siridin</td>
      <td>uasat</td>
      <td>midla</td>
      <td>middle</td>
    </tr>
    <tr>
      <td>nitcu</td>
      <td>cu</td>
      <td>nid</td>
      <td>avaciak</td>
      <td>nesesit</td>
      <td>nujda</td>
      <td>xaj</td>
      <td>nujda</td>
      <td>need</td>
    </tr>
    <tr>
      <td>zgike</td>
      <td>iue</td>
      <td>miuzik</td>
      <td>sangit</td>
      <td>musik</td>
      <td>muzik</td>
      <td>musika</td>
      <td>sangita</td>
      <td>music</td>
    </tr>
    <tr>
      <td>cnano</td>
      <td>can</td>
      <td>norm</td>
      <td>manak</td>
      <td>noral</td>
      <td>narmaln</td>
      <td>adi</td>
      <td>norma</td>
      <td>norm</td>
    </tr>
    <tr>
      <td>dacti</td>
      <td>dunci</td>
      <td>tin</td>
      <td>padart</td>
      <td>obxet</td>
      <td>pridmiet</td>
      <td>cai</td>
      <td>dunci</td>
      <td>object</td>
    </tr>
    <tr>
      <td>sarcu</td>
      <td>cu</td>
      <td>nesaseri</td>
      <td>zarur</td>
      <td>nesesari</td>
      <td>niapxadim</td>
      <td>darur</td>
      <td>- to be proposed -</td>
      <td>necessary</td>
    </tr>
    <tr>
      <td>prali</td>
      <td>li</td>
      <td>prafit</td>
      <td>prapti</td>
      <td>gananci</td>
      <td>pribil</td>
      <td>ribxa</td>
      <td>prafita pribila</td>
      <td>profit</td>
    </tr>
    <tr>
      <td>pelji</td>
      <td>ji</td>
      <td>peipr</td>
      <td>kagaz</td>
      <td>papel</td>
      <td>bumag</td>
      <td>uarak</td>
      <td>- to be proposed -</td>
      <td>paper</td>
    </tr>
    <tr>
      <td>slabu</td>
      <td>lau</td>
      <td>old</td>
      <td>bur</td>
      <td>viex</td>
      <td>star</td>
      <td>ajuz</td>
      <td>olda stara</td>
      <td>familiar</td>
    </tr>
    <tr>
      <td>spati</td>
      <td>sai</td>
      <td>plant</td>
      <td>vamspat</td>
      <td>plant</td>
      <td>rastien</td>
      <td>banat</td>
      <td>- to be proposed -</td>
      <td>plant</td>
    </tr>
    <tr>
      <td>frati</td>
      <td>faniin</td>
      <td>riakt</td>
      <td>prativadan</td>
      <td>reaksion</td>
      <td>atklik</td>
      <td>ajab</td>
      <td>- to be proposed -</td>
      <td>react</td>
    </tr>
    <tr>
      <td>gunro</td>
      <td>guen</td>
      <td>rol</td>
      <td>lurk</td>
      <td>rod</td>
      <td>kat</td>
      <td>adar</td>
      <td>lurka</td>
      <td>roll</td>
    </tr>
    <tr>
      <td>lacpu</td>
      <td>la</td>
      <td>pul</td>
      <td>laga</td>
      <td>tir</td>
      <td>tac</td>
      <td>saxab</td>
      <td>- to be proposed -</td>
      <td>pull</td>
    </tr>
    <tr>
      <td>morji</td>
      <td>ji</td>
      <td>rimembr</td>
      <td>smarn</td>
      <td>rekord</td>
      <td>pomn</td>
      <td>dakar</td>
      <td>pomna</td>
      <td>remember</td>
    </tr>
    <tr>
      <td>catke</td>
      <td>tuei</td>
      <td>cav</td>
      <td>dakel</td>
      <td>empux</td>
      <td>talk</td>
      <td>dagat</td>
      <td>empuxa talka</td>
      <td>shove</td>
    </tr>
    <tr>
      <td>sfasa</td>
      <td>fa</td>
      <td>kastageit</td>
      <td>saz</td>
      <td>kastig</td>
      <td>nakaz</td>
      <td>akab</td>
      <td>- to be proposed -</td>
      <td>punish</td>
    </tr>
    <tr>
      <td>cunso</td>
      <td>iun</td>
      <td>cans</td>
      <td>iadrici</td>
      <td>fortun</td>
      <td>cans</td>
      <td>acuan</td>
      <td>cansa fortuna</td>
      <td>random</td>
    </tr>
    <tr>
      <td>cukla</td>
      <td>cuan</td>
      <td>srkl</td>
      <td>cakar</td>
      <td>redond</td>
      <td>krukl</td>
      <td>dair</td>
      <td>- to be proposed -</td>
      <td>round</td>
    </tr>
    <tr>
      <td>mintu</td>
      <td>tun</td>
      <td>aident</td>
      <td>abin</td>
      <td>mism</td>
      <td>adin</td>
      <td>datu</td>
      <td>misma</td>
      <td>same</td>
    </tr>
    <tr>
      <td>malsi</td>
      <td>si</td>
      <td>templ</td>
      <td>mandir</td>
      <td>iglesi</td>
      <td>xram</td>
      <td>mabid</td>
      <td>mandira xrama</td>
      <td>temple</td>
    </tr>
    <tr>
      <td>selfu</td>
      <td>fu</td>
      <td>srv</td>
      <td>sev</td>
      <td>serv</td>
      <td>sluj</td>
      <td>xadam</td>
      <td>serva sluja</td>
      <td>serve</td>
    </tr>
    <tr>
      <td>trene</td>
      <td>liece</td>
      <td>trein</td>
      <td>tren</td>
      <td>tren</td>
      <td>paist</td>
      <td>kitar</td>
      <td>trena</td>
      <td>train</td>
    </tr>
    <tr>
      <td>tricu</td>
      <td>cu</td>
      <td>tri</td>
      <td>taru</td>
      <td>arbol</td>
      <td>dieriv</td>
      <td>cazar</td>
      <td>arbola</td>
      <td>tree</td>
    </tr>
    <tr>
      <td>vanju</td>
      <td>taujieu</td>
      <td>vain</td>
      <td>angur</td>
      <td>vin</td>
      <td>vino</td>
      <td>nabid</td>
      <td>angura</td>
      <td>wine</td>
    </tr>
    <tr>
      <td>vecnu</td>
      <td>ceu</td>
      <td>vend</td>
      <td>bec</td>
      <td>vend</td>
      <td>pradav</td>
      <td>baa</td>
      <td>venda pradava</td>
      <td>sell</td>
    </tr>
    <tr>
      <td>cumki</td>
      <td>cu</td>
      <td>meibi</td>
      <td>caki</td>
      <td>posible</td>
      <td>vazmojn</td>
      <td>iumkinu</td>
      <td>- to be proposed -</td>
      <td>possible</td>
    </tr>
    <tr>
      <td>krati</td>
      <td>kai</td>
      <td>praksi</td>
      <td>pratinid</td>
      <td>represent</td>
      <td>pritstavl</td>
      <td>matal</td>
      <td>- to be proposed -</td>
      <td>represent</td>
    </tr>
    <tr>
      <td>condi</td>
      <td>cen</td>
      <td>dip</td>
      <td>gaxr</td>
      <td>ond</td>
      <td>glubok</td>
      <td>amik</td>
      <td>gaxra onda gluboka</td>
      <td>deep</td>
    </tr>
    <tr>
      <td>fanmo</td>
      <td>mo</td>
      <td>fainl</td>
      <td>ant</td>
      <td>fin</td>
      <td>kaniets</td>
      <td>xitam</td>
      <td>anta</td>
      <td>end</td>
    </tr>
    <tr>
      <td>kampu</td>
      <td>pu</td>
      <td>kamn</td>
      <td>samani</td>
      <td>komun</td>
      <td>opc</td>
      <td>muctarak</td>
      <td>kamna opca</td>
      <td>common</td>
    </tr>
    <tr>
      <td>lifri</td>
      <td>li</td>
      <td>ikspirins</td>
      <td>anubav</td>
      <td>sufr</td>
      <td>pirijiv</td>
      <td>xibr</td>
      <td>sufra xibra</td>
      <td>experience</td>
    </tr>
    <tr>
      <td>certu</td>
      <td>ceu</td>
      <td>eksprt</td>
      <td>catur</td>
      <td>ekspert</td>
      <td>ikspiert</td>
      <td>maxir</td>
      <td>- to be proposed -</td>
      <td>expert</td>
    </tr>
    <tr>
      <td>terpa</td>
      <td>pa</td>
      <td>terr</td>
      <td>dar</td>
      <td>teror</td>
      <td>strax</td>
      <td>xuf</td>
      <td>- to be proposed -</td>
      <td>fear</td>
    </tr>
    <tr>
      <td>bilni</td>
      <td>bin</td>
      <td>milateri</td>
      <td>saini</td>
      <td>militar</td>
      <td>vaien</td>
      <td>askari</td>
      <td>- to be proposed -</td>
      <td>military</td>
    </tr>
    <tr>
      <td>jamfu</td>
      <td>jiau</td>
      <td>fut</td>
      <td>pamv</td>
      <td>pie</td>
      <td>naga</td>
      <td>kadam</td>
      <td>pamva</td>
      <td>foot</td>
    </tr>
    <tr>
      <td>jdini</td>
      <td>jin</td>
      <td>mani</td>
      <td>mudr</td>
      <td>diner</td>
      <td>dieng</td>
      <td>mal</td>
      <td>mudra</td>
      <td>money</td>
    </tr>
    <tr>
      <td>xendo</td>
      <td>xe</td>
      <td>kaind</td>
      <td>kripalu</td>
      <td>benevol</td>
      <td>dobr</td>
      <td>xanun</td>
      <td>kripalu dobra</td>
      <td>kind</td>
    </tr>
    <tr>
      <td>xirma</td>
      <td>ma</td>
      <td>xors</td>
      <td>gir</td>
      <td>kabai</td>
      <td>locad</td>
      <td>xisan</td>
      <td>xorsa</td>
      <td>horse</td>
    </tr>
    <tr>
      <td>zifre</td>
      <td>zieu</td>
      <td>fri</td>
      <td>svatantr</td>
      <td>libr</td>
      <td>svabodn</td>
      <td>xur</td>
      <td>libra</td>
      <td>free</td>
    </tr>
    <tr>
      <td>mukti</td>
      <td>mudi</td>
      <td>motiv</td>
      <td>lakci</td>
      <td>motiv</td>
      <td>matif</td>
      <td>xadaf</td>
      <td>lakci</td>
      <td>motive</td>
    </tr>
    <tr>
      <td>badri</td>
      <td>beiai</td>
      <td>sad</td>
      <td>duxkad</td>
      <td>trist</td>
      <td>pecal</td>
      <td>xazin</td>
      <td>- to be proposed -</td>
      <td>sad</td>
    </tr>
    <tr>
      <td>cnino</td>
      <td>cin</td>
      <td>niu</td>
      <td>navin</td>
      <td>nov</td>
      <td>nov</td>
      <td>jadid</td>
      <td>- to be proposed -</td>
      <td>new</td>
    </tr>
    <tr>
      <td>fapro</td>
      <td>fan</td>
      <td>apoz</td>
      <td>virod</td>
      <td>opon</td>
      <td>protif</td>
      <td>arad</td>
      <td>protifa</td>
      <td>oppose</td>
    </tr>
    <tr>
      <td>jdima</td>
      <td>jia</td>
      <td>prais</td>
      <td>dam</td>
      <td>kost</td>
      <td>tsina</td>
      <td>taman</td>
      <td>kosta tsina</td>
      <td>price</td>
    </tr>
    <tr>
      <td>jinvi</td>
      <td>jian</td>
      <td>apinian</td>
      <td>vicar</td>
      <td>opin</td>
      <td>mnieni</td>
      <td>rai</td>
      <td>- to be proposed -</td>
      <td>opine</td>
    </tr>
    <tr>
      <td>kumfa</td>
      <td>fan</td>
      <td>rum</td>
      <td>kamra</td>
      <td>kuart</td>
      <td>komnat</td>
      <td>gurfa</td>
      <td>kamra komnata gurfa</td>
      <td>room</td>
    </tr>
    <tr>
      <td>pluka</td>
      <td>iukuai</td>
      <td>pliz</td>
      <td>tript</td>
      <td>plas</td>
      <td>ugajd</td>
      <td>sar</td>
      <td>pliza plasa</td>
      <td>pleasant</td>
    </tr>
    <tr>
      <td>cilre</td>
      <td>ciue</td>
      <td>lrn</td>
      <td>sik</td>
      <td>aprend</td>
      <td>ucits</td>
      <td>taalam</td>
      <td>- to be proposed -</td>
      <td>learn</td>
    </tr>
    <tr>
      <td>gusni</td>
      <td>guan</td>
      <td>lait</td>
      <td>rocni</td>
      <td>lus</td>
      <td>sviet</td>
      <td>dau</td>
      <td>rocni</td>
      <td>illumine</td>
    </tr>
    <tr>
      <td>jimte</td>
      <td>jie</td>
      <td>limit</td>
      <td>sim</td>
      <td>limit</td>
      <td>granis</td>
      <td>xad</td>
      <td>granisa</td>
      <td>limit</td>
    </tr>
    <tr>
      <td>litru</td>
      <td>liu</td>
      <td>travl</td>
      <td>iatr</td>
      <td>viax</td>
      <td>raziezj</td>
      <td>safar</td>
      <td>- to be proposed -</td>
      <td>travel</td>
    </tr>
    <tr>
      <td>manci</td>
      <td>ci</td>
      <td>uandr</td>
      <td>vismai</td>
      <td>maravii</td>
      <td>izmlieni</td>
      <td>caxba</td>
      <td>- to be proposed -</td>
      <td>wonder</td>
    </tr>
    <tr>
      <td>mluni</td>
      <td>ueicin</td>
      <td>mun</td>
      <td>upgrax</td>
      <td>lun</td>
      <td>lunam</td>
      <td>kamar</td>
      <td>- to be proposed -</td>
      <td>satellite</td>
    </tr>
    <tr>
      <td>sarji</td>
      <td>ji</td>
      <td>saport</td>
      <td>saxar</td>
      <td>sosten</td>
      <td>padierjiv</td>
      <td>xamal</td>
      <td>- to be proposed -</td>
      <td>support</td>
    </tr>
    <tr>
      <td>tagji</td>
      <td>jin</td>
      <td>tait</td>
      <td>tang</td>
      <td>apret</td>
      <td>tuga</td>
      <td>macdud</td>
      <td>tanga</td>
      <td>snug</td>
    </tr>
    <tr>
      <td>raktu</td>
      <td>rau</td>
      <td>trabl</td>
      <td>kact</td>
      <td>disturb</td>
      <td>bispako</td>
      <td>daiak</td>
      <td>kacta</td>
      <td>trouble</td>
    </tr>
    <tr>
      <td>logji</td>
      <td>lueji</td>
      <td>lajik</td>
      <td>tark</td>
      <td>loxik</td>
      <td>logik</td>
      <td>mantik</td>
      <td>tarka mantika</td>
      <td>logic</td>
    </tr>
    <tr>
      <td>ckilu</td>
      <td>cidu</td>
      <td>skeil</td>
      <td>anumap</td>
      <td>eskal</td>
      <td>ckala</td>
      <td>jidul</td>
      <td>ckala</td>
      <td>scale</td>
    </tr>
    <tr>
      <td>jufra</td>
      <td>ju</td>
      <td>sentns</td>
      <td>vaki</td>
      <td>fras</td>
      <td>fraz</td>
      <td>jumla</td>
      <td>frasa fraza jumla</td>
      <td>sentence</td>
    </tr>
    <tr>
      <td>kurfa</td>
      <td>fan</td>
      <td>skuar</td>
      <td>caukar</td>
      <td>kuadrad</td>
      <td>kuadrat</td>
      <td>muraba</td>
      <td>- to be proposed -</td>
      <td>square</td>
    </tr>
    <tr>
      <td>sanga</td>
      <td>can</td>
      <td>sin</td>
      <td>ga</td>
      <td>kant</td>
      <td>piet</td>
      <td>gana</td>
      <td>kanta</td>
      <td>sing</td>
    </tr>
    <tr>
      <td>sanli</td>
      <td>li</td>
      <td>stand</td>
      <td>stan</td>
      <td>levant</td>
      <td>stai</td>
      <td>intasab</td>
      <td>stana</td>
      <td>stand</td>
    </tr>
    <tr>
      <td>steci</td>
      <td>te</td>
      <td>specl</td>
      <td>vicec</td>
      <td>espesial</td>
      <td>asoben</td>
      <td>aian</td>
      <td>- to be proposed -</td>
      <td>specific</td>
    </tr>
    <tr>
      <td>zutse</td>
      <td>zue</td>
      <td>sit</td>
      <td>bait</td>
      <td>sent</td>
      <td>sadits</td>
      <td>jalas</td>
      <td>senta</td>
      <td>sit</td>
    </tr>
    <tr>
      <td>banzu</td>
      <td>zu</td>
      <td>safaiz</td>
      <td>bas</td>
      <td>bast</td>
      <td>dastatocn</td>
      <td>kaf</td>
      <td>basta</td>
      <td>suffice</td>
    </tr>
    <tr>
      <td>boxna</td>
      <td>bo</td>
      <td>ueiv</td>
      <td>laxra</td>
      <td>onda</td>
      <td>valna</td>
      <td>mauj</td>
      <td>laxra onda valna</td>
      <td>wave</td>
    </tr>
    <tr>
      <td>troci</td>
      <td>ci</td>
      <td>trai</td>
      <td>kocic</td>
      <td>prob</td>
      <td>pit</td>
      <td>xaual</td>
      <td>proba</td>
      <td>try</td>
    </tr>
    <tr>
      <td>vlile</td>
      <td>lie</td>
      <td>vaialnt</td>
      <td>xinsak</td>
      <td>violent</td>
      <td>nasil</td>
      <td>anif</td>
      <td>xinsaka</td>
      <td>violent</td>
    </tr>
    <tr>
      <td>cafne</td>
      <td>can</td>
      <td>afn</td>
      <td>anekac</td>
      <td>frekont</td>
      <td>cast</td>
      <td>katir</td>
      <td>afna casta</td>
      <td>often</td>
    </tr>
    <tr>
      <td>citri</td>
      <td>ci</td>
      <td>xistri</td>
      <td>itixas</td>
      <td>istori</td>
      <td>istori</td>
      <td>tarix</td>
      <td>- to be proposed -</td>
      <td>history</td>
    </tr>
    <tr>
      <td>dunli</td>
      <td>den</td>
      <td>ikual</td>
      <td>tuli</td>
      <td>igual</td>
      <td>ravn</td>
      <td>muadil</td>
      <td>ravna</td>
      <td>equal</td>
    </tr>
    <tr>
      <td>fatci</td>
      <td>ci</td>
      <td>fakt</td>
      <td>tat</td>
      <td>ec</td>
      <td>fakt</td>
      <td>xakik</td>
      <td>fakta</td>
      <td>fact</td>
    </tr>
    <tr>
      <td>grute</td>
      <td>gue</td>
      <td>frut</td>
      <td>pal</td>
      <td>frut</td>
      <td>frukt</td>
      <td>fakix</td>
      <td>fruta</td>
      <td>fruit</td>
    </tr>
    <tr>
      <td>kruvi</td>
      <td>cucian</td>
      <td>krv</td>
      <td>vakr</td>
      <td>kurv</td>
      <td>kriva</td>
      <td>munxan</td>
      <td>vakra kurva kriva munxana</td>
      <td>curve</td>
    </tr>
    <tr>
      <td>mudri</td>
      <td>mu</td>
      <td>uud</td>
      <td>lakr</td>
      <td>mader</td>
      <td>dieriv</td>
      <td>xacab</td>
      <td>lakra</td>
      <td>wood</td>
    </tr>
    <tr>
      <td>pacna</td>
      <td>pan</td>
      <td>xop</td>
      <td>aca</td>
      <td>esper</td>
      <td>nadie</td>
      <td>amal</td>
      <td>- to be proposed -</td>
      <td>hope</td>
    </tr>
    <tr>
      <td>tirna</td>
      <td>tin</td>
      <td>xir</td>
      <td>suna</td>
      <td>oient</td>
      <td>slic</td>
      <td>samia</td>
      <td>slica</td>
      <td>hear</td>
    </tr>
    <tr>
      <td>vajni</td>
      <td>juniao</td>
      <td>signifik</td>
      <td>avaciak</td>
      <td>signifik</td>
      <td>vajn</td>
      <td>muxim</td>
      <td>vajna</td>
      <td>important</td>
    </tr>
    <tr>
      <td>tcaci</td>
      <td>ci</td>
      <td>xabit</td>
      <td>acar</td>
      <td>kostumbr</td>
      <td>obica</td>
      <td>taklid</td>
      <td>- to be proposed -</td>
      <td>custom</td>
    </tr>
    <tr>
      <td>cpacu</td>
      <td>cu</td>
      <td>akuair</td>
      <td>pa</td>
      <td>obten</td>
      <td>paluc</td>
      <td>xasal</td>
      <td>- to be proposed -</td>
      <td>get</td>
    </tr>
    <tr>
      <td>liste</td>
      <td>lie</td>
      <td>list</td>
      <td>suc</td>
      <td>list</td>
      <td>spisak</td>
      <td>kaim</td>
      <td>lista spisaka</td>
      <td>list</td>
    </tr>
    <tr>
      <td>mrilu</td>
      <td>ieu</td>
      <td>mail</td>
      <td>dak</td>
      <td>kore</td>
      <td>poct</td>
      <td>barid</td>
      <td>pocta</td>
      <td>mail</td>
    </tr>
    <tr>
      <td>pagre</td>
      <td>gue</td>
      <td>pas</td>
      <td>par</td>
      <td>pas</td>
      <td>cieris</td>
      <td>xilab</td>
      <td>- to be proposed -</td>
      <td>pass through</td>
    </tr>
    <tr>
      <td>prane</td>
      <td>uanmei</td>
      <td>prfikt</td>
      <td>purn</td>
      <td>perfekt</td>
      <td>bizupriecn</td>
      <td>xasan</td>
      <td>purna</td>
      <td>perfect</td>
    </tr>
    <tr>
      <td>preti</td>
      <td>uenti</td>
      <td>kueri</td>
      <td>pracn</td>
      <td>pregunt</td>
      <td>vapros</td>
      <td>istifxan</td>
      <td>- to be proposed -</td>
      <td>question</td>
    </tr>
    <tr>
      <td>rirxe</td>
      <td>xe</td>
      <td>rivr</td>
      <td>nadi</td>
      <td>ri</td>
      <td>rika</td>
      <td>naxar</td>
      <td>rivra</td>
      <td>river</td>
    </tr>
    <tr>
      <td>rokci</td>
      <td>ci</td>
      <td>rak</td>
      <td>patar</td>
      <td>rok</td>
      <td>kamin</td>
      <td>saxr</td>
      <td>saxra</td>
      <td>rock</td>
    </tr>
    <tr>
      <td>vreji</td>
      <td>ji</td>
      <td>rekrd</td>
      <td>vrit</td>
      <td>rexistr</td>
      <td>zapis</td>
      <td>sajal</td>
      <td>vrita</td>
      <td>record</td>
    </tr>
    <tr>
      <td>dikni</td>
      <td>dinci</td>
      <td>siklik</td>
      <td>niiamit</td>
      <td>siklik</td>
      <td>siklicesk</td>
      <td>muntadim</td>
      <td>dinci</td>
      <td>regular</td>
    </tr>
    <tr>
      <td>cinse</td>
      <td>cin</td>
      <td>seks</td>
      <td>ion</td>
      <td>seks</td>
      <td>siksualn</td>
      <td>jinsi</td>
      <td>seksa jinsi</td>
      <td>sexual</td>
    </tr>
    <tr>
      <td>mensi</td>
      <td>mei</td>
      <td>sistr</td>
      <td>baxn</td>
      <td>erman</td>
      <td>sistra</td>
      <td>uxt</td>
      <td>baxna ermana uxta</td>
      <td>sister</td>
    </tr>
    <tr>
      <td>punli</td>
      <td>jun</td>
      <td>suel</td>
      <td>pul</td>
      <td>protuberansi</td>
      <td>opuxal</td>
      <td>uarim</td>
      <td>- to be proposed -</td>
      <td>swelling</td>
    </tr>
    <tr>
      <td>rufsu</td>
      <td>su</td>
      <td>raf</td>
      <td>rukc</td>
      <td>asper</td>
      <td>grub</td>
      <td>xacin</td>
      <td>rukca gruba</td>
      <td>rough</td>
    </tr>
    <tr>
      <td>simlu</td>
      <td>si</td>
      <td>sim</td>
      <td>malum</td>
      <td>pares</td>
      <td>kaz</td>
      <td>daxar</td>
      <td>- to be proposed -</td>
      <td>seem</td>
    </tr>
    <tr>
      <td>snura</td>
      <td>ancuan</td>
      <td>sikiur</td>
      <td>surkcit</td>
      <td>segur</td>
      <td>bizapasn</td>
      <td>amin</td>
      <td>- to be proposed -</td>
      <td>secure</td>
    </tr>
    <tr>
      <td>ctuca</td>
      <td>ceu</td>
      <td>tic</td>
      <td>cikca</td>
      <td>enseni</td>
      <td>uc</td>
      <td>alam</td>
      <td>cikca enseni</td>
      <td>teach</td>
    </tr>
    <tr>
      <td>cadzu</td>
      <td>zeu</td>
      <td>uak</td>
      <td>cal</td>
      <td>and</td>
      <td>xad</td>
      <td>maca</td>
      <td>anda</td>
      <td>walk</td>
    </tr>
    <tr>
      <td>pencu</td>
      <td>pen</td>
      <td>tac</td>
      <td>cu</td>
      <td>toc</td>
      <td>trog</td>
      <td>lamas</td>
      <td>troga</td>
      <td>touch</td>
    </tr>
    <tr>
      <td>plipe</td>
      <td>iue</td>
      <td>lip</td>
      <td>kud</td>
      <td>salt</td>
      <td>prig</td>
      <td>kafaz</td>
      <td>salta priga</td>
      <td>leap</td>
    </tr>
    <tr>
      <td>sraji</td>
      <td>ji</td>
      <td>aprait</td>
      <td>kara</td>
      <td>vertikal</td>
      <td>skak</td>
      <td>rasi</td>
      <td>skaka</td>
      <td>vertical</td>
    </tr>
    <tr>
      <td>terdi</td>
      <td>di</td>
      <td>ter</td>
      <td>partiv</td>
      <td>tier</td>
      <td>zimn</td>
      <td>ard</td>
      <td>partiva zimna arda</td>
      <td>earth</td>
    </tr>
    <tr>
      <td>cilmo</td>
      <td>ci</td>
      <td>moist</td>
      <td>gila</td>
      <td>mox</td>
      <td>mokr</td>
      <td>mubtal</td>
      <td>mokra</td>
      <td>moist</td>
    </tr>
    <tr>
      <td>lakse</td>
      <td>la</td>
      <td>uaks</td>
      <td>lak</td>
      <td>ser</td>
      <td>vosk</td>
      <td>cam</td>
      <td>voska</td>
      <td>wax</td>
    </tr>
    <tr>
      <td>nanca</td>
      <td>nian</td>
      <td>aniu</td>
      <td>varc</td>
      <td>an</td>
      <td>got</td>
      <td>sana</td>
      <td>varca</td>
      <td>year</td>
    </tr>
    <tr>
      <td>jecta</td>
      <td>jen</td>
      <td>steit</td>
      <td>ractra</td>
      <td>estad</td>
      <td>ctat</td>
      <td>uilai</td>
      <td>ctata</td>
      <td>polity</td>
    </tr>
    <tr>
      <td>gugde</td>
      <td>gue</td>
      <td>kantri</td>
      <td>dec</td>
      <td>pais</td>
      <td>strana</td>
      <td>iklim</td>
      <td>- to be proposed -</td>
      <td>country</td>
    </tr>
    <tr>
      <td>jisra</td>
      <td>ji</td>
      <td>jus</td>
      <td>ras</td>
      <td>sum</td>
      <td>sok</td>
      <td>asir</td>
      <td>- to be proposed -</td>
      <td>juice</td>
    </tr>
    <tr>
      <td>natmi</td>
      <td>min</td>
      <td>nacn</td>
      <td>jati</td>
      <td>nasion</td>
      <td>nasian</td>
      <td>kaum</td>
      <td>nacna</td>
      <td>nation</td>
    </tr>
    <tr>
      <td>slanu</td>
      <td>iuanju</td>
      <td>silndr</td>
      <td>belan</td>
      <td>silindr</td>
      <td>silindr</td>
      <td>ustuuan</td>
      <td>- to be proposed -</td>
      <td>cylinder</td>
    </tr>
    <tr>
      <td>sodva</td>
      <td>suda</td>
      <td>soda</td>
      <td>sodavatar</td>
      <td>sod</td>
      <td>sodava</td>
      <td>mausuda</td>
      <td>- to be proposed -</td>
      <td>soda</td>
    </tr>
    <tr>
      <td>banli</td>
      <td>juanli</td>
      <td>grand</td>
      <td>bar</td>
      <td>gran</td>
      <td>vilik</td>
      <td>bariz</td>
      <td>grana</td>
      <td>great</td>
    </tr>
    <tr>
      <td>darxi</td>
      <td>da</td>
      <td>xit</td>
      <td>mar</td>
      <td>golpe</td>
      <td>udar</td>
      <td>darab</td>
      <td>golpe</td>
      <td>hit</td>
    </tr>
    <tr>
      <td>kensa</td>
      <td>kunjian</td>
      <td>speis</td>
      <td>antarikc</td>
      <td>espase</td>
      <td>kosmas</td>
      <td>alfada</td>
      <td>alfada</td>
      <td>outer space</td>
    </tr>
    <tr>
      <td>kucli</td>
      <td>xauci</td>
      <td>kiurias</td>
      <td>kutuxal</td>
      <td>kurios</td>
      <td>liubapitn</td>
      <td>fuduli</td>
      <td>- to be proposed -</td>
      <td>curious</td>
    </tr>
    <tr>
      <td>munje</td>
      <td>iujen</td>
      <td>iunavrs</td>
      <td>braxmand</td>
      <td>univers</td>
      <td>kosmas</td>
      <td>kun</td>
      <td>- to be proposed -</td>
      <td>universe</td>
    </tr>
    <tr>
      <td>nurma</td>
      <td>nun</td>
      <td>rurl</td>
      <td>dexat</td>
      <td>rural</td>
      <td>diriviensk</td>
      <td>rifi</td>
      <td>rurla</td>
      <td>rural</td>
    </tr>
    <tr>
      <td>plini</td>
      <td>cincin</td>
      <td>planit</td>
      <td>grax</td>
      <td>planet</td>
      <td>planiet</td>
      <td>kaukabsaiar</td>
      <td>cincina planita graxa planeta</td>
      <td>planet</td>
    </tr>
    <tr>
      <td>sidju</td>
      <td>ju</td>
      <td>eid</td>
      <td>saxait</td>
      <td>aiud</td>
      <td>pamag</td>
      <td>sada</td>
      <td>- to be proposed -</td>
      <td>help</td>
    </tr>
    <tr>
      <td>tutra</td>
      <td>tu</td>
      <td>teratori</td>
      <td>ract</td>
      <td>teritori</td>
      <td>tiritor</td>
      <td>urad</td>
      <td>racta</td>
      <td>territory</td>
    </tr>
    <tr>
      <td>jgari</td>
      <td>jua</td>
      <td>grip</td>
      <td>pakar</td>
      <td>agar</td>
      <td>zajim</td>
      <td>kabad</td>
      <td>gripa</td>
      <td>grasp</td>
    </tr>
    <tr>
      <td>jvinu</td>
      <td>jin</td>
      <td>viu</td>
      <td>dirc</td>
      <td>vist</td>
      <td>vid</td>
      <td>mandar</td>
      <td>dirca vista mandara</td>
      <td>view</td>
    </tr>
    <tr>
      <td>moklu</td>
      <td>keu</td>
      <td>orl</td>
      <td>muk</td>
      <td>bok</td>
      <td>rot</td>
      <td>fam</td>
      <td>orla</td>
      <td>mouth</td>
    </tr>
    <tr>
      <td>tuple</td>
      <td>tuei</td>
      <td>leg</td>
      <td>tang</td>
      <td>piern</td>
      <td>naga</td>
      <td>rijl</td>
      <td>tanga rijla</td>
      <td>leg</td>
    </tr>
    <tr>
      <td>korbi</td>
      <td>bian</td>
      <td>bordr</td>
      <td>kor</td>
      <td>orii</td>
      <td>krai</td>
      <td>xad</td>
      <td>- to be proposed -</td>
      <td>edge</td>
    </tr>
    <tr>
      <td>darno</td>
      <td>iaun</td>
      <td>far</td>
      <td>dur</td>
      <td>lexan</td>
      <td>daleko</td>
      <td>baid</td>
      <td>- to be proposed -</td>
      <td>far</td>
    </tr>
    <tr>
      <td>kanla</td>
      <td>ian</td>
      <td>okial</td>
      <td>ank</td>
      <td>ox</td>
      <td>glas</td>
      <td>ain</td>
      <td>anka glasa</td>
      <td>eye</td>
    </tr>
    <tr>
      <td>damba</td>
      <td>da</td>
      <td>kambat</td>
      <td>samgarc</td>
      <td>kombat</td>
      <td>bar</td>
      <td>katal</td>
      <td>kambata kombata</td>
      <td>fight</td>
    </tr>
    <tr>
      <td>canre</td>
      <td>ca</td>
      <td>sand</td>
      <td>ret</td>
      <td>aren</td>
      <td>pisok</td>
      <td>raml</td>
      <td>sanda ramla</td>
      <td>sand</td>
    </tr>
    <tr>
      <td>crisa</td>
      <td>cia</td>
      <td>samr</td>
      <td>gricm</td>
      <td>veran</td>
      <td>pet</td>
      <td>saif</td>
      <td>samra</td>
      <td>summer</td>
    </tr>
    <tr>
      <td>vindu</td>
      <td>du</td>
      <td>venm</td>
      <td>vic</td>
      <td>venen</td>
      <td>iid</td>
      <td>sam</td>
      <td>venma</td>
      <td>poison</td>
    </tr>
    <tr>
      <td>vrusi</td>
      <td>uei</td>
      <td>flavr</td>
      <td>svad</td>
      <td>gust</td>
      <td>vkus</td>
      <td>taam</td>
      <td>gusta</td>
      <td>taste</td>
    </tr>
    <tr>
      <td>prije</td>
      <td>je</td>
      <td>seij</td>
      <td>pragia</td>
      <td>sabi</td>
      <td>mudri</td>
      <td>xakim</td>
      <td>mudri</td>
      <td>wise</td>
    </tr>
    <tr>
      <td>cipra</td>
      <td>ci</td>
      <td>pruf</td>
      <td>parak</td>
      <td>prob</td>
      <td>prob</td>
      <td>tajrib</td>
      <td>prufa proba tajriba</td>
      <td>test</td>
    </tr>
    <tr>
      <td>tutci</td>
      <td>ci</td>
      <td>tul</td>
      <td>xatiiar</td>
      <td>utensili</td>
      <td>utvar</td>
      <td>ada</td>
      <td>- to be proposed -</td>
      <td>tool</td>
    </tr>
    <tr>
      <td>fukpi</td>
      <td>fu</td>
      <td>kapi</td>
      <td>nakal</td>
      <td>kopi</td>
      <td>kopi</td>
      <td>taklid</td>
      <td>- to be proposed -</td>
      <td>copy</td>
    </tr>
    <tr>
      <td>litce</td>
      <td>cen</td>
      <td>litr</td>
      <td>litr</td>
      <td>litr</td>
      <td>litr</td>
      <td>litr</td>
      <td>litra</td>
      <td>liter</td>
    </tr>
    <tr>
      <td>manku</td>
      <td>an</td>
      <td>dark</td>
      <td>ander</td>
      <td>oskur</td>
      <td>mrak</td>
      <td>dulma</td>
      <td>darka andera mraka dulma</td>
      <td>dark</td>
    </tr>
    <tr>
      <td>zekri</td>
      <td>zuei</td>
      <td>kraim</td>
      <td>aprad</td>
      <td>krimen</td>
      <td>prestuplien</td>
      <td>jarim</td>
      <td>krimena</td>
      <td>crime</td>
    </tr>
    <tr>
      <td>kanro</td>
      <td>kan</td>
      <td>xelti</td>
      <td>nirog</td>
      <td>san</td>
      <td>zdarov</td>
      <td>sixa</td>
      <td>xelti zdarova</td>
      <td>healthy</td>
    </tr>
    <tr>
      <td>tcima</td>
      <td>ci</td>
      <td>mitiralaj</td>
      <td>mausam</td>
      <td>tiemp</td>
      <td>pagod</td>
      <td>jau</td>
      <td>- to be proposed -</td>
      <td>weather</td>
    </tr>
    <tr>
      <td>citno</td>
      <td>cin</td>
      <td>ian</td>
      <td>cot</td>
      <td>xoven</td>
      <td>molod</td>
      <td>xadat</td>
      <td>- to be proposed -</td>
      <td>young</td>
    </tr>
    <tr>
      <td>stapa</td>
      <td>tabu</td>
      <td>step</td>
      <td>par</td>
      <td>pas</td>
      <td>stup</td>
      <td>xatn</td>
      <td>stepa stupa xatna</td>
      <td>step</td>
    </tr>
    <tr>
      <td>stidi</td>
      <td>tiii</td>
      <td>sagjest</td>
      <td>prastav</td>
      <td>indik</td>
      <td>pridlag</td>
      <td>ikiarax</td>
      <td>indika</td>
      <td>suggest</td>
    </tr>
    <tr>
      <td>tarci</td>
      <td>cin</td>
      <td>star</td>
      <td>tar</td>
      <td>estrei</td>
      <td>zvizd</td>
      <td>najm</td>
      <td>stara najma</td>
      <td>star</td>
    </tr>
    <tr>
      <td>cevni</td>
      <td>cen</td>
      <td>diviniti</td>
      <td>dev</td>
      <td>divinidad</td>
      <td>bok</td>
      <td>ala</td>
      <td>- to be proposed -</td>
      <td>god</td>
    </tr>
    <tr>
      <td>sumji</td>
      <td>jia</td>
      <td>sam</td>
      <td>samcti</td>
      <td>sum</td>
      <td>sum</td>
      <td>juml</td>
      <td>jumla</td>
      <td>sum</td>
    </tr>
    <tr>
      <td>glare</td>
      <td>re</td>
      <td>uarm</td>
      <td>garm</td>
      <td>kaluros</td>
      <td>gariac</td>
      <td>xar</td>
      <td>glagla</td>
      <td>hot</td>
    </tr>
    <tr>
      <td>cifnu</td>
      <td>iin</td>
      <td>infnt</td>
      <td>cicu</td>
      <td>infant</td>
      <td>rebion</td>
      <td>tifl</td>
      <td>tifla</td>
      <td>infant</td>
    </tr>
    <tr>
      <td>dejni</td>
      <td>jai</td>
      <td>det</td>
      <td>dendar</td>
      <td>deb</td>
      <td>doljn</td>
      <td>dain</td>
      <td>dendara</td>
      <td>owe</td>
    </tr>
    <tr>
      <td>rectu</td>
      <td>reu</td>
      <td>flec</td>
      <td>goct</td>
      <td>karn</td>
      <td>mias</td>
      <td>laxm</td>
      <td>fleca gocta karna laxma</td>
      <td>meat</td>
    </tr>
    <tr>
      <td>degji</td>
      <td>ji</td>
      <td>dijit</td>
      <td>ungli</td>
      <td>ded</td>
      <td>palis</td>
      <td>isba</td>
      <td>- to be proposed -</td>
      <td>finger</td>
    </tr>
    <tr>
      <td>fagri</td>
      <td>xue</td>
      <td>fair</td>
      <td>ag</td>
      <td>fog</td>
      <td>agon</td>
      <td>xarik</td>
      <td>- to be proposed -</td>
      <td>fire</td>
    </tr>
    <tr>
      <td>jdari</td>
      <td>jian</td>
      <td>xard</td>
      <td>kar</td>
      <td>dur</td>
      <td>tviord</td>
      <td>jamid</td>
      <td>xarda</td>
      <td>firm</td>
    </tr>
    <tr>
      <td>palta</td>
      <td>pan</td>
      <td>pleit</td>
      <td>tal</td>
      <td>plat</td>
      <td>tarielk</td>
      <td>tabak</td>
      <td>plata</td>
      <td>plate</td>
    </tr>
    <tr>
      <td>purdi</td>
      <td>pu</td>
      <td>gardn</td>
      <td>udian</td>
      <td>xardin</td>
      <td>sat</td>
      <td>xadik</td>
      <td>xardina</td>
      <td>garden</td>
    </tr>
    <tr>
      <td>xrula</td>
      <td>xua</td>
      <td>blasm</td>
      <td>pul</td>
      <td>flor</td>
      <td>svet</td>
      <td>zaxr</td>
      <td>flora zaxra</td>
      <td>flower</td>
    </tr>
    <tr>
      <td>kajde</td>
      <td>jie</td>
      <td>kacn</td>
      <td>savdan</td>
      <td>advert</td>
      <td>priduprijd</td>
      <td>andar</td>
      <td>kacna savdana andara</td>
      <td>warn</td>
    </tr>
    <tr>
      <td>kabri</td>
      <td>bei</td>
      <td>kap</td>
      <td>kator</td>
      <td>kop</td>
      <td>kubak</td>
      <td>kub</td>
      <td>- to be proposed -</td>
      <td>cup</td>
    </tr>
    <tr>
      <td>cange</td>
      <td>can</td>
      <td>agrer</td>
      <td>cak</td>
      <td>granx</td>
      <td>kolxoz</td>
      <td>zaraa</td>
      <td>kolxoza</td>
      <td>farm</td>
    </tr>
    <tr>
      <td>casnu</td>
      <td>can</td>
      <td>diskas</td>
      <td>vicar</td>
      <td>diskut</td>
      <td>absujd</td>
      <td>nakac</td>
      <td>- to be proposed -</td>
      <td>discuss</td>
    </tr>
    <tr>
      <td>farlu</td>
      <td>lue</td>
      <td>fal</td>
      <td>jar</td>
      <td>ka</td>
      <td>pad</td>
      <td>inxar</td>
      <td>inxara</td>
      <td>fall</td>
    </tr>
    <tr>
      <td>nuzba</td>
      <td>cinuen</td>
      <td>nuz</td>
      <td>xabar</td>
      <td>novas</td>
      <td>novast</td>
      <td>anba</td>
      <td>anba</td>
      <td>news</td>
    </tr>
    <tr>
      <td>smaji</td>
      <td>ji</td>
      <td>sailnt</td>
      <td>maun</td>
      <td>kaiad</td>
      <td>malc</td>
      <td>sakin</td>
      <td>malca</td>
      <td>quiet</td>
    </tr>
    <tr>
      <td>srana</td>
      <td>guan</td>
      <td>knsrn</td>
      <td>samband</td>
      <td>konsern</td>
      <td>atnas</td>
      <td>taialaki</td>
      <td>atnasa</td>
      <td>pertain</td>
    </tr>
    <tr>
      <td>jarki</td>
      <td>jai</td>
      <td>naro</td>
      <td>sankir</td>
      <td>angost</td>
      <td>uski</td>
      <td>muxdad</td>
      <td>sankira uski</td>
      <td>narrow</td>
    </tr>
    <tr>
      <td>skina</td>
      <td>iin</td>
      <td>sinam</td>
      <td>sinema</td>
      <td>sine</td>
      <td>kino</td>
      <td>sinima</td>
      <td>- to be proposed -</td>
      <td>cinema</td>
    </tr>
    <tr>
      <td>ralte</td>
      <td>lieu</td>
      <td>ritein</td>
      <td>rak</td>
      <td>ten</td>
      <td>astav</td>
      <td>xaras</td>
      <td>- to be proposed -</td>
      <td>retain</td>
    </tr>
    <tr>
      <td>cinri</td>
      <td>cin</td>
      <td>intrist</td>
      <td>ruci</td>
      <td>interes</td>
      <td>intiries</td>
      <td>atar</td>
      <td>- to be proposed -</td>
      <td>interesting</td>
    </tr>
    <tr>
      <td>cinta</td>
      <td>ci</td>
      <td>peint</td>
      <td>paint</td>
      <td>pintur</td>
      <td>krask</td>
      <td>tala</td>
      <td>pintura</td>
      <td>paint</td>
    </tr>
    <tr>
      <td>kalte</td>
      <td>lie</td>
      <td>xant</td>
      <td>cikar</td>
      <td>kas</td>
      <td>axot</td>
      <td>kanas</td>
      <td>xanta</td>
      <td>hunt</td>
    </tr>
    <tr>
      <td>lakne</td>
      <td>kenen</td>
      <td>laikli</td>
      <td>sambavat</td>
      <td>probabl</td>
      <td>viraiatn</td>
      <td>mutauaka</td>
      <td>- to be proposed -</td>
      <td>probable</td>
    </tr>
    <tr>
      <td>pleji</td>
      <td>ji</td>
      <td>pei</td>
      <td>cuka</td>
      <td>pag</td>
      <td>plat</td>
      <td>dafa</td>
      <td>plata</td>
      <td>pay</td>
    </tr>
    <tr>
      <td>sarxe</td>
      <td>xe</td>
      <td>xarmoni</td>
      <td>susvar</td>
      <td>armonios</td>
      <td>garmanicn</td>
      <td>insajam</td>
      <td>xarmoni</td>
      <td>harmonious</td>
    </tr>
    <tr>
      <td>tirse</td>
      <td>tie</td>
      <td>airn</td>
      <td>aias</td>
      <td>iero</td>
      <td>jelies</td>
      <td>xadid</td>
      <td>- to be proposed -</td>
      <td>iron</td>
    </tr>
    <tr>
      <td>krinu</td>
      <td>ieu</td>
      <td>rizn</td>
      <td>karn</td>
      <td>rason</td>
      <td>rizon</td>
      <td>sabab</td>
      <td>rizna karna</td>
      <td>reason</td>
    </tr>
    <tr>
      <td>parbi</td>
      <td>bi</td>
      <td>reit</td>
      <td>anupat</td>
      <td>proporsion</td>
      <td>praports</td>
      <td>nispa</td>
      <td>nispa</td>
      <td>ratio</td>
    </tr>
    <tr>
      <td>carna</td>
      <td>cuan</td>
      <td>trn</td>
      <td>cakra</td>
      <td>rod</td>
      <td>pavaraciv</td>
      <td>adar</td>
      <td>cakra</td>
      <td>turn</td>
    </tr>
    <tr>
      <td>sinma</td>
      <td>jin</td>
      <td>astim</td>
      <td>saman</td>
      <td>estim</td>
      <td>uvaj</td>
      <td>ixtaram</td>
      <td>- to be proposed -</td>
      <td>esteem</td>
    </tr>
    <tr>
      <td>carvi</td>
      <td>ciaiu</td>
      <td>rein</td>
      <td>baric</td>
      <td>iuvi</td>
      <td>doct</td>
      <td>matar</td>
      <td>docta</td>
      <td>rain</td>
    </tr>
    <tr>
      <td>cteki</td>
      <td>cuei</td>
      <td>taks</td>
      <td>teks</td>
      <td>impost</td>
      <td>sbor</td>
      <td>dariba</td>
      <td>taksa teksa</td>
      <td>tax</td>
    </tr>
    <tr>
      <td>dunra</td>
      <td>dun</td>
      <td>uintr</td>
      <td>jara</td>
      <td>inviern</td>
      <td>zima</td>
      <td>cita</td>
      <td>- to be proposed -</td>
      <td>winter</td>
    </tr>
    <tr>
      <td>tcena</td>
      <td>cen</td>
      <td>ikstend</td>
      <td>tana</td>
      <td>ekstend</td>
      <td>rastiagiv</td>
      <td>mada</td>
      <td>- to be proposed -</td>
      <td>stretch</td>
    </tr>
    <tr>
      <td>torni</td>
      <td>nin</td>
      <td>torcn</td>
      <td>maror</td>
      <td>tors</td>
      <td>krut</td>
      <td>baram</td>
      <td>torsa kruta</td>
      <td>twist</td>
    </tr>
    <tr>
      <td>danmo</td>
      <td>ian</td>
      <td>smok</td>
      <td>duan</td>
      <td>um</td>
      <td>dim</td>
      <td>duxan</td>
      <td>smoka</td>
      <td>smoke</td>
    </tr>
    <tr>
      <td>denci</td>
      <td>ci</td>
      <td>dent</td>
      <td>dant</td>
      <td>dient</td>
      <td>zup</td>
      <td>sin</td>
      <td>denta danta</td>
      <td>tooth</td>
    </tr>
    <tr>
      <td>smuci</td>
      <td>ci</td>
      <td>spun</td>
      <td>camac</td>
      <td>kucar</td>
      <td>lock</td>
      <td>milak</td>
      <td>spuna locka</td>
      <td>spoon</td>
    </tr>
    <tr>
      <td>tatpi</td>
      <td>pi</td>
      <td>taird</td>
      <td>takit</td>
      <td>fatig</td>
      <td>ustali</td>
      <td>taban</td>
      <td>- to be proposed -</td>
      <td>tired</td>
    </tr>
    <tr>
      <td>klaji</td>
      <td>jie</td>
      <td>avaniu</td>
      <td>gali</td>
      <td>kai</td>
      <td>aviniu</td>
      <td>cari</td>
      <td>- to be proposed -</td>
      <td>street</td>
    </tr>
    <tr>
      <td>sonci</td>
      <td>ci</td>
      <td>soljr</td>
      <td>senik</td>
      <td>soldad</td>
      <td>saldat</td>
      <td>jundi</td>
      <td>soldada saldata jundi</td>
      <td>soldier</td>
    </tr>
    <tr>
      <td>fenra</td>
      <td>fen</td>
      <td>krak</td>
      <td>darar</td>
      <td>rax</td>
      <td>triecin</td>
      <td>maftur</td>
      <td>kraka maftura</td>
      <td>crack</td>
    </tr>
    <tr>
      <td>dertu</td>
      <td>tu</td>
      <td>rt</td>
      <td>darti</td>
      <td>tier</td>
      <td>griaz</td>
      <td>kadar</td>
      <td>darti</td>
      <td>dirt</td>
    </tr>
    <tr>
      <td>nandu</td>
      <td>nan</td>
      <td>xard</td>
      <td>duckar</td>
      <td>ardu</td>
      <td>trudn</td>
      <td>saab</td>
      <td>xarda ardu</td>
      <td>difficult</td>
    </tr>
    <tr>
      <td>jivna</td>
      <td>jin</td>
      <td>raivl</td>
      <td>pratispardva</td>
      <td>kompet</td>
      <td>sarivnav</td>
      <td>nafas</td>
      <td>kompeta</td>
      <td>compete</td>
    </tr>
    <tr>
      <td>mavji</td>
      <td>ianmai</td>
      <td>ots</td>
      <td>ji</td>
      <td>aven</td>
      <td>avios</td>
      <td>cufan</td>
      <td>otsa</td>
      <td>oats</td>
    </tr>
    <tr>
      <td>sanji</td>
      <td>ji</td>
      <td>kancas</td>
      <td>cetan</td>
      <td>konsient</td>
      <td>sazn</td>
      <td>mudrik</td>
      <td>kancasa sazna</td>
      <td>conscious</td>
    </tr>
    <tr>
      <td>slari</td>
      <td>suan</td>
      <td>saur</td>
      <td>amla</td>
      <td>agri</td>
      <td>kisl</td>
      <td>xamid</td>
      <td>amla agri kisla</td>
      <td>sour</td>
    </tr>
    <tr>
      <td>voksa</td>
      <td>san</td>
      <td>vokal</td>
      <td>vak</td>
      <td>vos</td>
      <td>golas</td>
      <td>saut</td>
      <td>- to be proposed -</td>
      <td>voice</td>
    </tr>
    <tr>
      <td>fuzme</td>
      <td>fuze</td>
      <td>rispansabl</td>
      <td>jimevar</td>
      <td>responsabl</td>
      <td>atvic</td>
      <td>masuul</td>
      <td>- to be proposed -</td>
      <td>responsible</td>
    </tr>
    <tr>
      <td>sisku</td>
      <td>seu</td>
      <td>sik</td>
      <td>koj</td>
      <td>busk</td>
      <td>isk</td>
      <td>talab</td>
      <td>buska iska</td>
      <td>seek</td>
    </tr>
    <tr>
      <td>sputu</td>
      <td>tu</td>
      <td>spit</td>
      <td>tuk</td>
      <td>esput</td>
      <td>pliv</td>
      <td>basak</td>
      <td>spita pliva</td>
      <td>spit</td>
    </tr>
    <tr>
      <td>bakni</td>
      <td>nieu</td>
      <td>aks</td>
      <td>bail</td>
      <td>vak</td>
      <td>bik</td>
      <td>bakar</td>
      <td>aksa</td>
      <td>bovine</td>
    </tr>
    <tr>
      <td>marbi</td>
      <td>bi</td>
      <td>xarbr</td>
      <td>acrai</td>
      <td>ampar</td>
      <td>priiut</td>
      <td>maxba</td>
      <td>ampara</td>
      <td>shelter</td>
    </tr>
    <tr>
      <td>daspo</td>
      <td>po</td>
      <td>distroi</td>
      <td>dvast</td>
      <td>destru</td>
      <td>razruc</td>
      <td>damar</td>
      <td>razruca</td>
      <td>destroy</td>
    </tr>
    <tr>
      <td>senpi</td>
      <td>iiuen</td>
      <td>skeptik</td>
      <td>sandex</td>
      <td>eseptik</td>
      <td>skieptik</td>
      <td>cak</td>
      <td>sandexa</td>
      <td>doubt</td>
    </tr>
    <tr>
      <td>cfika</td>
      <td>ciaucue</td>
      <td>fikcn</td>
      <td>kalpna</td>
      <td>fiksion</td>
      <td>fiksi</td>
      <td>xaiali</td>
      <td>fiksi</td>
      <td>fiction</td>
    </tr>
    <tr>
      <td>flira</td>
      <td>lian</td>
      <td>feis</td>
      <td>cexra</td>
      <td>kara</td>
      <td>liso</td>
      <td>uajx</td>
      <td>cexra</td>
      <td>face</td>
    </tr>
    <tr>
      <td>frili</td>
      <td>runii</td>
      <td>izi</td>
      <td>saxaj</td>
      <td>fasil</td>
      <td>liok</td>
      <td>saxl</td>
      <td>saxla</td>
      <td>easy</td>
    </tr>
    <tr>
      <td>kunti</td>
      <td>kun</td>
      <td>vaiknt</td>
      <td>cuni</td>
      <td>vakant</td>
      <td>pusto</td>
      <td>farig</td>
      <td>pusto</td>
      <td>empty</td>
    </tr>
    <tr>
      <td>pimlu</td>
      <td>iumau</td>
      <td>plum</td>
      <td>pic</td>
      <td>plum</td>
      <td>piro</td>
      <td>rica</td>
      <td>pluma</td>
      <td>feather</td>
    </tr>
    <tr>
      <td>senva</td>
      <td>men</td>
      <td>revari</td>
      <td>svapn</td>
      <td>son</td>
      <td>son</td>
      <td>xalam</td>
      <td>- to be proposed -</td>
      <td>dream</td>
    </tr>
    <tr>
      <td>bumru</td>
      <td>bouu</td>
      <td>fag</td>
      <td>kuxra</td>
      <td>brum</td>
      <td>tuman</td>
      <td>cabur</td>
      <td>kuxra bruma</td>
      <td>fog</td>
    </tr>
    <tr>
      <td>dandu</td>
      <td>diau</td>
      <td>xan</td>
      <td>tang</td>
      <td>pend</td>
      <td>viec</td>
      <td>dala</td>
      <td>tanga penda</td>
      <td>hang</td>
    </tr>
    <tr>
      <td>polje</td>
      <td>je</td>
      <td>fold</td>
      <td>valit</td>
      <td>pleg</td>
      <td>skladiv</td>
      <td>taua</td>
      <td>folda plega</td>
      <td>fold</td>
    </tr>
    <tr>
      <td>cacra</td>
      <td>ciauc</td>
      <td>aur</td>
      <td>xora</td>
      <td>ora</td>
      <td>cas</td>
      <td>saa</td>
      <td>- to be proposed -</td>
      <td>hour</td>
    </tr>
    <tr>
      <td>jemna</td>
      <td>jenbau</td>
      <td>jem</td>
      <td>ratna</td>
      <td>xem</td>
      <td>dragasien</td>
      <td>jauxar</td>
      <td>ratna</td>
      <td>gem</td>
    </tr>
    <tr>
      <td>tilju</td>
      <td>jun</td>
      <td>ueiti</td>
      <td>tol</td>
      <td>pesad</td>
      <td>tiajiol</td>
      <td>takil</td>
      <td>- to be proposed -</td>
      <td>heavy</td>
    </tr>
    <tr>
      <td>zvati</td>
      <td>zai</td>
      <td>at</td>
      <td>upastit</td>
      <td>asist</td>
      <td>prisutstvav</td>
      <td>xadir</td>
      <td>- to be proposed -</td>
      <td>at</td>
    </tr>
    <tr>
      <td>zenba</td>
      <td>zen</td>
      <td>agment</td>
      <td>bar</td>
      <td>aument</td>
      <td>pribavl</td>
      <td>zada</td>
      <td>- to be proposed -</td>
      <td>increase</td>
    </tr>
    <tr>
      <td>sidbo</td>
      <td>si</td>
      <td>aidi</td>
      <td>bod</td>
      <td>ide</td>
      <td>idieia</td>
      <td>fikr</td>
      <td>fikra</td>
      <td>idea</td>
    </tr>
    <tr>
      <td>jdice</td>
      <td>jiue</td>
      <td>disaid</td>
      <td>nicai</td>
      <td>desid</td>
      <td>ric</td>
      <td>karar</td>
      <td>- to be proposed -</td>
      <td>decide</td>
    </tr>
    <tr>
      <td>stedu</td>
      <td>teu</td>
      <td>xed</td>
      <td>sir</td>
      <td>kabes</td>
      <td>galav</td>
      <td>ras</td>
      <td>- to be proposed -</td>
      <td>head</td>
    </tr>
    <tr>
      <td>xebni</td>
      <td>xen</td>
      <td>xeit</td>
      <td>bair</td>
      <td>detest</td>
      <td>ninavid</td>
      <td>karix</td>
      <td>- to be proposed -</td>
      <td>hate</td>
    </tr>
    <tr>
      <td>bajra</td>
      <td>ban</td>
      <td>ran</td>
      <td>daur</td>
      <td>kor</td>
      <td>bij</td>
      <td>jara</td>
      <td>- to be proposed -</td>
      <td>run</td>
    </tr>
    <tr>
      <td>fenso</td>
      <td>fen</td>
      <td>so</td>
      <td>sina</td>
      <td>kos</td>
      <td>cit</td>
      <td>xat</td>
      <td>- to be proposed -</td>
      <td>sew</td>
    </tr>
    <tr>
      <td>nabmi</td>
      <td>nanti</td>
      <td>prablm</td>
      <td>samsia</td>
      <td>problem</td>
      <td>prabliem</td>
      <td>muckil</td>
      <td>nanti</td>
      <td>problem</td>
    </tr>
    <tr>
      <td>pilji</td>
      <td>ji</td>
      <td>maltaplai</td>
      <td>gunanpal</td>
      <td>multiplik</td>
      <td>praizvidien</td>
      <td>xasil</td>
      <td>- to be proposed -</td>
      <td>multiply</td>
    </tr>
    <tr>
      <td>prina</td>
      <td>iin</td>
      <td>print</td>
      <td>mudrit</td>
      <td>imprim</td>
      <td>picat</td>
      <td>taba</td>
      <td>- to be proposed -</td>
      <td>print</td>
    </tr>
    <tr>
      <td>rilti</td>
      <td>iuenliu</td>
      <td>ritm</td>
      <td>lai</td>
      <td>ritm</td>
      <td>ritm</td>
      <td>ika</td>
      <td>ritma</td>
      <td>rhythm</td>
    </tr>
    <tr>
      <td>junri</td>
      <td>jun</td>
      <td>sirias</td>
      <td>ganbir</td>
      <td>seri</td>
      <td>siriozn</td>
      <td>rasin</td>
      <td>ganbira</td>
      <td>serious</td>
    </tr>
    <tr>
      <td>fusra</td>
      <td>fu</td>
      <td>rat</td>
      <td>saran</td>
      <td>pudr</td>
      <td>tuxn</td>
      <td>fasad</td>
      <td>pudra tuxna</td>
      <td>rotten</td>
    </tr>
    <tr>
      <td>friti</td>
      <td>tigun</td>
      <td>ofr</td>
      <td>arpit</td>
      <td>ofres</td>
      <td>predlag</td>
      <td>kadam</td>
      <td>ofra arpita</td>
      <td>offer</td>
    </tr>
    <tr>
      <td>panpi</td>
      <td>an</td>
      <td>pis</td>
      <td>canti</td>
      <td>pas</td>
      <td>mir</td>
      <td>salam</td>
      <td>canti</td>
      <td>peace</td>
    </tr>
    <tr>
      <td>plita</td>
      <td>pinmian</td>
      <td>plein</td>
      <td>tal</td>
      <td>plan</td>
      <td>slosk</td>
      <td>mustau</td>
      <td>plana</td>
      <td>plane</td>
    </tr>
    <tr>
      <td>purmo</td>
      <td>mo</td>
      <td>paudr</td>
      <td>paudar</td>
      <td>polv</td>
      <td>pudr</td>
      <td>budra</td>
      <td>polva pudra budra</td>
      <td>powder</td>
    </tr>
    <tr>
      <td>toknu</td>
      <td>kaulu</td>
      <td>ovn</td>
      <td>tandur</td>
      <td>orn</td>
      <td>duxof</td>
      <td>furn</td>
      <td>ovna tandura orna furna</td>
      <td>oven</td>
    </tr>
    <tr>
      <td>xarju</td>
      <td>ju</td>
      <td>xag</td>
      <td>suar</td>
      <td>maran</td>
      <td>svin</td>
      <td>xanzir</td>
      <td>xanzira</td>
      <td>pig</td>
    </tr>
    <tr>
      <td>fadni</td>
      <td>fan</td>
      <td>kamn</td>
      <td>samani</td>
      <td>ordinari</td>
      <td>abidien</td>
      <td>itiiadi</td>
      <td>kamna</td>
      <td>ordinary</td>
    </tr>
    <tr>
      <td>denpa</td>
      <td>den</td>
      <td>paz</td>
      <td>xicak</td>
      <td>paus</td>
      <td>pauz</td>
      <td>intadar</td>
      <td>- to be proposed -</td>
      <td>wait</td>
    </tr>
    <tr>
      <td>cmila</td>
      <td>ciau</td>
      <td>laf</td>
      <td>xans</td>
      <td>re</td>
      <td>smi</td>
      <td>daxik</td>
      <td>xansa</td>
      <td>laugh</td>
    </tr>
    <tr>
      <td>kunra</td>
      <td>kuan</td>
      <td>minrl</td>
      <td>kanij</td>
      <td>mineral</td>
      <td>miniral</td>
      <td>madin</td>
      <td>- to be proposed -</td>
      <td>mineral</td>
    </tr>
    <tr>
      <td>mixre</td>
      <td>xue</td>
      <td>mikscr</td>
      <td>micran</td>
      <td>mikstur</td>
      <td>miec</td>
      <td>xalil</td>
      <td>- to be proposed -</td>
      <td>mixture</td>
    </tr>
    <tr>
      <td>rarna</td>
      <td>ziran</td>
      <td>nacrl</td>
      <td>prakrit</td>
      <td>natural</td>
      <td>prirodn</td>
      <td>tabi</td>
      <td>- to be proposed -</td>
      <td>natural</td>
    </tr>
    <tr>
      <td>smani</td>
      <td>iuan</td>
      <td>manki</td>
      <td>vanar</td>
      <td>simi</td>
      <td>abizian</td>
      <td>sadun</td>
      <td>manki</td>
      <td>monkey</td>
    </tr>
    <tr>
      <td>bilma</td>
      <td>bin</td>
      <td>il</td>
      <td>bimar</td>
      <td>mal</td>
      <td>balno</td>
      <td>alil</td>
      <td>balno</td>
      <td>ill</td>
    </tr>
    <tr>
      <td>sumne</td>
      <td>uen</td>
      <td>smel</td>
      <td>sund</td>
      <td>ol</td>
      <td>cu</td>
      <td>cam</td>
      <td>smela sunda</td>
      <td>smell</td>
    </tr>
    <tr>
      <td>panci</td>
      <td>ci</td>
      <td>fragrans</td>
      <td>gand</td>
      <td>fragrans</td>
      <td>paxn</td>
      <td>ranix</td>
      <td>ganda paxna</td>
      <td>odor</td>
    </tr>
    <tr>
      <td>kagni</td>
      <td>gunsi</td>
      <td>kampani</td>
      <td>sangati</td>
      <td>korporasion</td>
      <td>kampani</td>
      <td>cirka</td>
      <td>gunsi kampani sangati cirka</td>
      <td>company</td>
    </tr>
    <tr>
      <td>kamni</td>
      <td>ueiiuanxuei</td>
      <td>kamiti</td>
      <td>kameti</td>
      <td>komite</td>
      <td>kamisi</td>
      <td>lajna</td>
      <td>lajna</td>
      <td>committee</td>
    </tr>
    <tr>
      <td>lasna</td>
      <td>lian</td>
      <td>fasn</td>
      <td>laga</td>
      <td>asegur</td>
      <td>zakripl</td>
      <td>arfak</td>
      <td>fasna arfaka</td>
      <td>fasten</td>
    </tr>
    <tr>
      <td>zasti</td>
      <td>zai</td>
      <td>igzist</td>
      <td>astitva</td>
      <td>eksist</td>
      <td>sucistv</td>
      <td>kana</td>
      <td>- to be proposed -</td>
      <td>exist</td>
    </tr>
    <tr>
      <td>ckape</td>
      <td>cian</td>
      <td>perl</td>
      <td>katr</td>
      <td>peligr</td>
      <td>apasn</td>
      <td>xatar</td>
      <td>perla katra</td>
      <td>peril</td>
    </tr>
    <tr>
      <td>jukpa</td>
      <td>ju</td>
      <td>kuk</td>
      <td>paka</td>
      <td>kos</td>
      <td>striap</td>
      <td>taxa</td>
      <td>- to be proposed -</td>
      <td>cook</td>
    </tr>
    <tr>
      <td>kancu</td>
      <td>cu</td>
      <td>kaunt</td>
      <td>gani</td>
      <td>kont</td>
      <td>scit</td>
      <td>ada</td>
      <td>konta</td>
      <td>count</td>
    </tr>
    <tr>
      <td>dirba</td>
      <td>bau</td>
      <td>dir</td>
      <td>piara</td>
      <td>kerid</td>
      <td>darag</td>
      <td>aziz</td>
      <td>- to be proposed -</td>
      <td>dear</td>
    </tr>
    <tr>
      <td>fatri</td>
      <td>fa</td>
      <td>distribiut</td>
      <td>vitran</td>
      <td>distrib</td>
      <td>raspridil</td>
      <td>farak</td>
      <td>- to be proposed -</td>
      <td>distribute</td>
    </tr>
    <tr>
      <td>kakpa</td>
      <td>pau</td>
      <td>dig</td>
      <td>kod</td>
      <td>kav</td>
      <td>kap</td>
      <td>nakab</td>
      <td>- to be proposed -</td>
      <td>dig</td>
    </tr>
    <tr>
      <td>mikce</td>
      <td>iicen</td>
      <td>medik</td>
      <td>cikitsak</td>
      <td>medik</td>
      <td>izliec</td>
      <td>tabib</td>
      <td>- to be proposed -</td>
      <td>doctor</td>
    </tr>
    <tr>
      <td>fliba</td>
      <td>cibai</td>
      <td>feil</td>
      <td>abav</td>
      <td>fai</td>
      <td>niudacn</td>
      <td>xaba</td>
      <td>- to be proposed -</td>
      <td>fail</td>
    </tr>
    <tr>
      <td>kerlo</td>
      <td>er</td>
      <td>orl</td>
      <td>karm</td>
      <td>orex</td>
      <td>ux</td>
      <td>uzn</td>
      <td>orla karma uzna</td>
      <td>ear</td>
    </tr>
    <tr>
      <td>mupli</td>
      <td>li</td>
      <td>igzampl</td>
      <td>damuna</td>
      <td>exempl</td>
      <td>primier</td>
      <td>namudaj</td>
      <td>- to be proposed -</td>
      <td>example</td>
    </tr>
    <tr>
      <td>pulce</td>
      <td>cen</td>
      <td>dast</td>
      <td>dul</td>
      <td>polv</td>
      <td>pil</td>
      <td>gubar</td>
      <td>dasta polva</td>
      <td>dust</td>
    </tr>
    <tr>
      <td>stuna</td>
      <td>dun</td>
      <td>ist</td>
      <td>purab</td>
      <td>est</td>
      <td>vastok</td>
      <td>cark</td>
      <td>ista esta carka</td>
      <td>east</td>
    </tr>
    <tr>
      <td>lanzu</td>
      <td>zu</td>
      <td>klan</td>
      <td>vanc</td>
      <td>famili</td>
      <td>klan</td>
      <td>aila</td>
      <td>klana vanca</td>
      <td>family</td>
    </tr>
    <tr>
      <td>ruble</td>
      <td>rue</td>
      <td>fibl</td>
      <td>durbal</td>
      <td>endebl</td>
      <td>slab</td>
      <td>uaxin</td>
      <td>fibla durbala slaba</td>
      <td>weak</td>
    </tr>
    <tr>
      <td>fanri</td>
      <td>can</td>
      <td>faktri</td>
      <td>fektri</td>
      <td>fabrik</td>
      <td>fabrik</td>
      <td>masna</td>
      <td>masna</td>
      <td>factory</td>
    </tr>
    <tr>
      <td>gidva</td>
      <td>dau</td>
      <td>gaid</td>
      <td>netritv</td>
      <td>gi</td>
      <td>visti</td>
      <td>murcid</td>
      <td>visti murcida</td>
      <td>guide</td>
    </tr>
    <tr>
      <td>stace</td>
      <td>cen</td>
      <td>anast</td>
      <td>sac</td>
      <td>onest</td>
      <td>ceistn</td>
      <td>mustakim</td>
      <td>- to be proposed -</td>
      <td>honest</td>
    </tr>
    <tr>
      <td>jinme</td>
      <td>jin</td>
      <td>metl</td>
      <td>datu</td>
      <td>metal</td>
      <td>mital</td>
      <td>madin</td>
      <td>metla</td>
      <td>metal</td>
    </tr>
    <tr>
      <td>lenjo</td>
      <td>jin</td>
      <td>lenz</td>
      <td>lens</td>
      <td>lent</td>
      <td>linz</td>
      <td>adas</td>
      <td>lenza lensa lenta linza</td>
      <td>lens</td>
    </tr>
    <tr>
      <td>lerfu</td>
      <td>fu</td>
      <td>letr</td>
      <td>varn</td>
      <td>letr</td>
      <td>bukv</td>
      <td>xarf</td>
      <td>letra varna xarfa</td>
      <td>letteral</td>
    </tr>
    <tr>
      <td>milxe</td>
      <td>xe</td>
      <td>maild</td>
      <td>mridul</td>
      <td>duls</td>
      <td>miak</td>
      <td>latif</td>
      <td>mridula dulsa</td>
      <td>mild</td>
    </tr>
    <tr>
      <td>blaci</td>
      <td>boli</td>
      <td>glas</td>
      <td>cic</td>
      <td>vidri</td>
      <td>stiklo</td>
      <td>zujaj</td>
      <td>glasa vidri</td>
      <td>glass</td>
    </tr>
    <tr>
      <td>gurni</td>
      <td>gu</td>
      <td>grein</td>
      <td>gani</td>
      <td>gran</td>
      <td>zirno</td>
      <td>gilal</td>
      <td>grana zirno</td>
      <td>grain</td>
    </tr>
    <tr>
      <td>kanba</td>
      <td>cianian</td>
      <td>got</td>
      <td>bakr</td>
      <td>kabr</td>
      <td>kaz</td>
      <td>anza</td>
      <td>bakra kabra anza</td>
      <td>goat</td>
    </tr>
    <tr>
      <td>srasu</td>
      <td>sau</td>
      <td>gras</td>
      <td>gas</td>
      <td>ierb</td>
      <td>trava</td>
      <td>ueba</td>
      <td>grasa trava</td>
      <td>grass</td>
    </tr>
    <tr>
      <td>cerni</td>
      <td>cen</td>
      <td>mornin</td>
      <td>saber</td>
      <td>manan</td>
      <td>utr</td>
      <td>sabax</td>
      <td>mornina utra</td>
      <td>morning</td>
    </tr>
    <tr>
      <td>ctile</td>
      <td>ciieu</td>
      <td>oil</td>
      <td>butal</td>
      <td>petrole</td>
      <td>nieft</td>
      <td>naft</td>
      <td>nafta</td>
      <td>petroleum</td>
    </tr>
    <tr>
      <td>fendi</td>
      <td>fen</td>
      <td>davaid</td>
      <td>bag</td>
      <td>divid</td>
      <td>dil</td>
      <td>kasam</td>
      <td>- to be proposed -</td>
      <td>divide</td>
    </tr>
    <tr>
      <td>ferti</td>
      <td>fei</td>
      <td>frtl</td>
      <td>urvar</td>
      <td>fertil</td>
      <td>pladarodn</td>
      <td>xasib</td>
      <td>urvara fertila</td>
      <td>fertile</td>
    </tr>
    <tr>
      <td>gapci</td>
      <td>ci</td>
      <td>gas</td>
      <td>bap</td>
      <td>gas</td>
      <td>gas</td>
      <td>gaz</td>
      <td>- to be proposed -</td>
      <td>gas</td>
    </tr>
    <tr>
      <td>gerku</td>
      <td>geu</td>
      <td>dag</td>
      <td>kuta</td>
      <td>per</td>
      <td>sabak</td>
      <td>kalb</td>
      <td>kalba</td>
      <td>dog</td>
    </tr>
    <tr>
      <td>nelci</td>
      <td>ci</td>
      <td>laik</td>
      <td>snex</td>
      <td>gust</td>
      <td>liub</td>
      <td>axab</td>
      <td>snexa gusta</td>
      <td>fond</td>
    </tr>
    <tr>
      <td>pinxe</td>
      <td>xe</td>
      <td>drink</td>
      <td>pi</td>
      <td>beb</td>
      <td>pit</td>
      <td>carab</td>
      <td>- to be proposed -</td>
      <td>drink</td>
    </tr>
    <tr>
      <td>sluji</td>
      <td>ji</td>
      <td>masl</td>
      <td>pec</td>
      <td>muskul</td>
      <td>muskul</td>
      <td>adala</td>
      <td>masla</td>
      <td>muscle</td>
    </tr>
    <tr>
      <td>sudga</td>
      <td>gan</td>
      <td>drai</td>
      <td>suk</td>
      <td>sek</td>
      <td>sux</td>
      <td>jaf</td>
      <td>- to be proposed -</td>
      <td>dry</td>
    </tr>
    <tr>
      <td>vofli</td>
      <td>fei</td>
      <td>flai</td>
      <td>ur</td>
      <td>vol</td>
      <td>lit</td>
      <td>tara</td>
      <td>- to be proposed -</td>
      <td>flight</td>
    </tr>
    <tr>
      <td>tcica</td>
      <td>ci</td>
      <td>trik</td>
      <td>cal</td>
      <td>embauk</td>
      <td>abman</td>
      <td>gaca</td>
      <td>trika abmana</td>
      <td>deceive</td>
    </tr>
    <tr>
      <td>matra</td>
      <td>mada</td>
      <td>motr</td>
      <td>motar</td>
      <td>motor</td>
      <td>mator</td>
      <td>motor</td>
      <td>motra</td>
      <td>motor</td>
    </tr>
    <tr>
      <td>menli</td>
      <td>cinli</td>
      <td>mentl</td>
      <td>mans</td>
      <td>ment</td>
      <td>mislin</td>
      <td>dixn</td>
      <td>cinli mansa menta dixna</td>
      <td>mind</td>
    </tr>
    <tr>
      <td>berti</td>
      <td>bei</td>
      <td>nort</td>
      <td>utar</td>
      <td>nort</td>
      <td>sievir</td>
      <td>camal</td>
      <td>norta</td>
      <td>north</td>
    </tr>
    <tr>
      <td>ctino</td>
      <td>iin</td>
      <td>ceid</td>
      <td>cai</td>
      <td>sombr</td>
      <td>tien</td>
      <td>dil</td>
      <td>- to be proposed -</td>
      <td>shadow</td>
    </tr>
    <tr>
      <td>ganzu</td>
      <td>zu</td>
      <td>organaiz</td>
      <td>sangatit</td>
      <td>organis</td>
      <td>arganiz</td>
      <td>nadam</td>
      <td>- to be proposed -</td>
      <td>organize</td>
    </tr>
    <tr>
      <td>jenca</td>
      <td>jen</td>
      <td>cak</td>
      <td>dak</td>
      <td>cok</td>
      <td>cakir</td>
      <td>sadma</td>
      <td>sadma</td>
      <td>shock</td>
    </tr>
    <tr>
      <td>pesxu</td>
      <td>xu</td>
      <td>peist</td>
      <td>lei</td>
      <td>past</td>
      <td>past</td>
      <td>majun</td>
      <td>pasta</td>
      <td>paste</td>
    </tr>
    <tr>
      <td>sraku</td>
      <td>sau</td>
      <td>skrac</td>
      <td>kurac</td>
      <td>rask</td>
      <td>sarap</td>
      <td>xak</td>
      <td>raska</td>
      <td>scratch</td>
    </tr>
    <tr>
      <td>dukti</td>
      <td>duei</td>
      <td>kantreri</td>
      <td>ulta</td>
      <td>kontrari</td>
      <td>abratna</td>
      <td>aksi</td>
      <td>ulta aksi</td>
      <td>opposite</td>
    </tr>
    <tr>
      <td>nirna</td>
      <td>cenjin</td>
      <td>niurl</td>
      <td>nas</td>
      <td>nerv</td>
      <td>nierf</td>
      <td>asab</td>
      <td>cenjina nerva</td>
      <td>nerve</td>
    </tr>
    <tr>
      <td>lanme</td>
      <td>ian</td>
      <td>lam</td>
      <td>mec</td>
      <td>karner</td>
      <td>baran</td>
      <td>dan</td>
      <td>karnera</td>
      <td>sheep</td>
    </tr>
    <tr>
      <td>tansi</td>
      <td>uan</td>
      <td>pan</td>
      <td>tav</td>
      <td>basi</td>
      <td>tas</td>
      <td>tast</td>
      <td>tasta</td>
      <td>pan</td>
    </tr>
    <tr>
      <td>pinfu</td>
      <td>fu</td>
      <td>prizanr</td>
      <td>kaid</td>
      <td>prisioner</td>
      <td>plien</td>
      <td>sajin</td>
      <td>- to be proposed -</td>
      <td>prisoner</td>
    </tr>
    <tr>
      <td>spisa</td>
      <td>pian</td>
      <td>pis</td>
      <td>xis</td>
      <td>pies</td>
      <td>kusok</td>
      <td>kita</td>
      <td>- to be proposed -</td>
      <td>piece</td>
    </tr>
    <tr>
      <td>sovda</td>
      <td>dan</td>
      <td>ovam</td>
      <td>anda</td>
      <td>ov</td>
      <td>iiso</td>
      <td>baida</td>
      <td>anda</td>
      <td>egg</td>
    </tr>
    <tr>
      <td>bredi</td>
      <td>bei</td>
      <td>redi</td>
      <td>taiar</td>
      <td>prepar</td>
      <td>gatov</td>
      <td>mustaid</td>
      <td>prepara</td>
      <td>ready</td>
    </tr>
    <tr>
      <td>ckule</td>
      <td>ciue</td>
      <td>skul</td>
      <td>skul</td>
      <td>eskol</td>
      <td>ckol</td>
      <td>madrasa</td>
      <td>skula ckola</td>
      <td>school</td>
    </tr>
    <tr>
      <td>ranti</td>
      <td>ruan</td>
      <td>saft</td>
      <td>naram</td>
      <td>bland</td>
      <td>miaxk</td>
      <td>naim</td>
      <td>safta</td>
      <td>soft</td>
    </tr>
    <tr>
      <td>sakli</td>
      <td>lieu</td>
      <td>slip</td>
      <td>sark</td>
      <td>resbal</td>
      <td>skolz</td>
      <td>zalak</td>
      <td>slipa sarka</td>
      <td>slide</td>
    </tr>
    <tr>
      <td>skiji</td>
      <td>xuaciueji</td>
      <td>ski</td>
      <td>ski</td>
      <td>eski</td>
      <td>lij</td>
      <td>zalaj</td>
      <td>eski</td>
      <td>ski</td>
    </tr>
    <tr>
      <td>snime</td>
      <td>ciue</td>
      <td>sno</td>
      <td>xim</td>
      <td>niev</td>
      <td>sniek</td>
      <td>talj</td>
      <td>talja</td>
      <td>snow</td>
    </tr>
    <tr>
      <td>dakli</td>
      <td>dai</td>
      <td>sak</td>
      <td>tail</td>
      <td>sak</td>
      <td>sumk</td>
      <td>zakib</td>
      <td>sumka</td>
      <td>sack</td>
    </tr>
    <tr>
      <td>dargu</td>
      <td>dau</td>
      <td>rod</td>
      <td>marg</td>
      <td>kareter</td>
      <td>darog</td>
      <td>darb</td>
      <td>marga darba</td>
      <td>road</td>
    </tr>
    <tr>
      <td>stasu</td>
      <td>tan</td>
      <td>stu</td>
      <td>ras</td>
      <td>sop</td>
      <td>sup</td>
      <td>xasa</td>
      <td>- to be proposed -</td>
      <td>soup</td>
    </tr>
    <tr>
      <td>snanu</td>
      <td>nan</td>
      <td>saut</td>
      <td>dakcin</td>
      <td>sur</td>
      <td>iuk</td>
      <td>janub</td>
      <td>dakcina</td>
      <td>south</td>
    </tr>
    <tr>
      <td>cizra</td>
      <td>ci</td>
      <td>bizar</td>
      <td>niral</td>
      <td>rar</td>
      <td>stran</td>
      <td>garib</td>
      <td>- to be proposed -</td>
      <td>strange</td>
    </tr>
    <tr>
      <td>snada</td>
      <td>da</td>
      <td>saksid</td>
      <td>sapal</td>
      <td>konseg</td>
      <td>uda</td>
      <td>najax</td>
      <td>saksida konsega</td>
      <td>succeed</td>
    </tr>
    <tr>
      <td>ganti</td>
      <td>gauuan</td>
      <td>testis</td>
      <td>and</td>
      <td>test</td>
      <td>iick</td>
      <td>xusia</td>
      <td>anda testa</td>
      <td>gonad</td>
    </tr>
    <tr>
      <td>judri</td>
      <td>juji</td>
      <td>adres</td>
      <td>pat</td>
      <td>direksion</td>
      <td>adris</td>
      <td>unuan</td>
      <td>- to be proposed -</td>
      <td>address</td>
    </tr>
    <tr>
      <td>spaji</td>
      <td>jin</td>
      <td>srpraiz</td>
      <td>cakit</td>
      <td>sorprend</td>
      <td>siurpriz</td>
      <td>faja</td>
      <td>- to be proposed -</td>
      <td>surprise</td>
    </tr>
    <tr>
      <td>titla</td>
      <td>tian</td>
      <td>suit</td>
      <td>mitai</td>
      <td>duls</td>
      <td>slatk</td>
      <td>xalan</td>
      <td>dulsa</td>
      <td>sweet</td>
    </tr>
    <tr>
      <td>dansu</td>
      <td>uudau</td>
      <td>dans</td>
      <td>nac</td>
      <td>dans</td>
      <td>tans</td>
      <td>rakas</td>
      <td>dansa tansa</td>
      <td>dance</td>
    </tr>
    <tr>
      <td>solji</td>
      <td>jin</td>
      <td>gold</td>
      <td>son</td>
      <td>or</td>
      <td>zolat</td>
      <td>daxab</td>
      <td>golda</td>
      <td>gold</td>
    </tr>
    <tr>
      <td>zunti</td>
      <td>zu</td>
      <td>intrfir</td>
      <td>viatikarn</td>
      <td>interfer</td>
      <td>sriv</td>
      <td>xaca</td>
      <td>sriva</td>
      <td>interfere</td>
    </tr>
    <tr>
      <td>basti</td>
      <td>ti</td>
      <td>sabstatiut</td>
      <td>badil</td>
      <td>sustitu</td>
      <td>smin</td>
      <td>badal</td>
      <td>smina</td>
      <td>replace</td>
    </tr>
    <tr>
      <td>denmi</td>
      <td>mi</td>
      <td>dens</td>
      <td>sankendran</td>
      <td>dens</td>
      <td>plotn</td>
      <td>katif</td>
      <td>densa</td>
      <td>dense</td>
    </tr>
    <tr>
      <td>pemci</td>
      <td>ci</td>
      <td>pom</td>
      <td>kavit</td>
      <td>poem</td>
      <td>paem</td>
      <td>karid</td>
      <td>- to be proposed -</td>
      <td>poem</td>
    </tr>
    <tr>
      <td>rotsu</td>
      <td>su</td>
      <td>staut</td>
      <td>mota</td>
      <td>gros</td>
      <td>tolst</td>
      <td>katif</td>
      <td>grosa</td>
      <td>thick</td>
    </tr>
    <tr>
      <td>canja</td>
      <td>can</td>
      <td>iksceinj</td>
      <td>tijarat</td>
      <td>kanxe</td>
      <td>min</td>
      <td>tajar</td>
      <td>kanxe</td>
      <td>exchange</td>
    </tr>
    <tr>
      <td>festi</td>
      <td>fei</td>
      <td>ueist</td>
      <td>apcec</td>
      <td>desperdik</td>
      <td>rastac</td>
      <td>badad</td>
      <td>apceca</td>
      <td>waste</td>
    </tr>
    <tr>
      <td>jeftu</td>
      <td>jeu</td>
      <td>uik</td>
      <td>xaft</td>
      <td>seman</td>
      <td>nidieli</td>
      <td>usbua</td>
      <td>xafta</td>
      <td>week</td>
    </tr>
    <tr>
      <td>pikta</td>
      <td>piau</td>
      <td>tiket</td>
      <td>tikat</td>
      <td>biiet</td>
      <td>biliet</td>
      <td>bitak</td>
      <td>- to be proposed -</td>
      <td>ticket</td>
    </tr>
    <tr>
      <td>sruri</td>
      <td>uei</td>
      <td>sraund</td>
      <td>ger</td>
      <td>sirkund</td>
      <td>akrij</td>
      <td>taxuit</td>
      <td>- to be proposed -</td>
      <td>surround</td>
    </tr>
    <tr>
      <td>tubnu</td>
      <td>guan</td>
      <td>tub</td>
      <td>nalik</td>
      <td>tub</td>
      <td>trub</td>
      <td>unbub</td>
      <td>truba unbuba</td>
      <td>tube</td>
    </tr>
    <tr>
      <td>snuti</td>
      <td>iiuai</td>
      <td>aksadent</td>
      <td>saniog</td>
      <td>aksidental</td>
      <td>slucai</td>
      <td>sudfa</td>
      <td>- to be proposed -</td>
      <td>accidental</td>
    </tr>
    <tr>
      <td>stici</td>
      <td>ci</td>
      <td>uest</td>
      <td>pratic</td>
      <td>oest</td>
      <td>zapat</td>
      <td>garba</td>
      <td>pratica garba</td>
      <td>west</td>
    </tr>
    <tr>
      <td>kargu</td>
      <td>guei</td>
      <td>kastli</td>
      <td>maxang</td>
      <td>kar</td>
      <td>darag</td>
      <td>gali</td>
      <td>- to be proposed -</td>
      <td>costly</td>
    </tr>
    <tr>
      <td>tcila</td>
      <td>cian</td>
      <td>diteil</td>
      <td>tafsil</td>
      <td>detai</td>
      <td>dital</td>
      <td>tafasil</td>
      <td>tafsila</td>
      <td>detail</td>
    </tr>
    <tr>
      <td>ralci</td>
      <td>ci</td>
      <td>frajl</td>
      <td>komal</td>
      <td>fraxil</td>
      <td>niejn</td>
      <td>rakik</td>
      <td>fraxila</td>
      <td>delicate</td>
    </tr>
    <tr>
      <td>foldi</td>
      <td>di</td>
      <td>fild</td>
      <td>maidan</td>
      <td>kamp</td>
      <td>pol</td>
      <td>marj</td>
      <td>filda kampa marja</td>
      <td>field</td>
    </tr>
    <tr>
      <td>fulta</td>
      <td>fu</td>
      <td>flot</td>
      <td>utra</td>
      <td>flot</td>
      <td>plav</td>
      <td>tafa</td>
      <td>flota utra plava</td>
      <td>float</td>
    </tr>
    <tr>
      <td>loldi</td>
      <td>di</td>
      <td>flor</td>
      <td>kudim</td>
      <td>sol</td>
      <td>pol</td>
      <td>ard</td>
      <td>flora arda</td>
      <td>floor</td>
    </tr>
    <tr>
      <td>bebna</td>
      <td>ben</td>
      <td>bub</td>
      <td>murk</td>
      <td>bob</td>
      <td>durak</td>
      <td>abla</td>
      <td>murka abla</td>
      <td>foolish</td>
    </tr>
    <tr>
      <td>pendo</td>
      <td>pen</td>
      <td>frend</td>
      <td>dost</td>
      <td>amig</td>
      <td>druk</td>
      <td>rafik</td>
      <td>dosta druka</td>
      <td>friend</td>
    </tr>
    <tr>
      <td>vifne</td>
      <td>cian</td>
      <td>frec</td>
      <td>navin</td>
      <td>fresk</td>
      <td>sviej</td>
      <td>tazaj</td>
      <td>freca</td>
      <td>fresh</td>
    </tr>
    <tr>
      <td>bisli</td>
      <td>bin</td>
      <td>ais</td>
      <td>barf</td>
      <td>ial</td>
      <td>liot</td>
      <td>jalid</td>
      <td>barfa</td>
      <td>ice</td>
    </tr>
    <tr>
      <td>censa</td>
      <td>cen</td>
      <td>xoli</td>
      <td>sant</td>
      <td>sak</td>
      <td>sviit</td>
      <td>kudisa</td>
      <td>santa</td>
      <td>holy</td>
    </tr>
    <tr>
      <td>cinki</td>
      <td>cun</td>
      <td>insekt</td>
      <td>kit</td>
      <td>insekt</td>
      <td>nasikoma</td>
      <td>xacara</td>
      <td>- to be proposed -</td>
      <td>insect</td>
    </tr>
    <tr>
      <td>ckire</td>
      <td>cie</td>
      <td>greitfl</td>
      <td>cukra</td>
      <td>rekonos</td>
      <td>priznatiln</td>
      <td>cukran</td>
      <td>cukra</td>
      <td>grateful</td>
    </tr>
    <tr>
      <td>kerfa</td>
      <td>fa</td>
      <td>xer</td>
      <td>kec</td>
      <td>pel</td>
      <td>volas</td>
      <td>car</td>
      <td>- to be proposed -</td>
      <td>hair</td>
    </tr>
    <tr>
      <td>spita</td>
      <td>iiiuan</td>
      <td>xaspitl</td>
      <td>aspatal</td>
      <td>ospital</td>
      <td>balnis</td>
      <td>mustacfa</td>
      <td>balnisa</td>
      <td>hospital</td>
    </tr>
    <tr>
      <td>xinmo</td>
      <td>mo</td>
      <td>ink</td>
      <td>siaxi</td>
      <td>tint</td>
      <td>cirnil</td>
      <td>xibr</td>
      <td>inka tinta cirnila xibra</td>
      <td>ink</td>
    </tr>
    <tr>
      <td>canti</td>
      <td>can</td>
      <td>entreilz</td>
      <td>antr</td>
      <td>entran</td>
      <td>vnutrin</td>
      <td>axca</td>
      <td>- to be proposed -</td>
      <td>gut</td>
    </tr>
    <tr>
      <td>kukte</td>
      <td>kekeu</td>
      <td>teisti</td>
      <td>sukad</td>
      <td>gustos</td>
      <td>vkusn</td>
      <td>caxi</td>
      <td>- to be proposed -</td>
      <td>delicious</td>
    </tr>
    <tr>
      <td>lisri</td>
      <td>lici</td>
      <td>stori</td>
      <td>kisa</td>
      <td>istori</td>
      <td>raskas</td>
      <td>kisa</td>
      <td>stori</td>
      <td>story</td>
    </tr>
    <tr>
      <td>cinfo</td>
      <td>ci</td>
      <td>lain</td>
      <td>sinx</td>
      <td>leon</td>
      <td>lief</td>
      <td>asad</td>
      <td>sinxa</td>
      <td>lion</td>
    </tr>
    <tr>
      <td>cnisa</td>
      <td>cian</td>
      <td>led</td>
      <td>sisak</td>
      <td>plom</td>
      <td>svinies</td>
      <td>rasis</td>
      <td>ploma</td>
      <td>lead</td>
    </tr>
    <tr>
      <td>jikru</td>
      <td>jieu</td>
      <td>likr</td>
      <td>likar</td>
      <td>likor</td>
      <td>likior</td>
      <td>carabkuxuli</td>
      <td>likra</td>
      <td>liquor</td>
    </tr>
    <tr>
      <td>linto</td>
      <td>cin</td>
      <td>lait</td>
      <td>xalk</td>
      <td>livian</td>
      <td>lioxk</td>
      <td>xafif</td>
      <td>xalka</td>
      <td>lightweight</td>
    </tr>
    <tr>
      <td>pezli</td>
      <td>iez</td>
      <td>lif</td>
      <td>patr</td>
      <td>ox</td>
      <td>list</td>
      <td>uarak</td>
      <td>patra lista</td>
      <td>leaf</td>
    </tr>
    <tr>
      <td>zunle</td>
      <td>zue</td>
      <td>left</td>
      <td>baian</td>
      <td>izkier</td>
      <td>naliev</td>
      <td>iasar</td>
      <td>lefta</td>
      <td>left</td>
    </tr>
    <tr>
      <td>finti</td>
      <td>famin</td>
      <td>invent</td>
      <td>sricti</td>
      <td>invent</td>
      <td>sazdav</td>
      <td>ixtira</td>
      <td>ixtira</td>
      <td>invent</td>
    </tr>
    <tr>
      <td>jgena</td>
      <td>jie</td>
      <td>nat</td>
      <td>gant</td>
      <td>nud</td>
      <td>uzil</td>
      <td>ukda</td>
      <td>ganta</td>
      <td>knot</td>
    </tr>
    <tr>
      <td>lalxu</td>
      <td>xu</td>
      <td>lagun</td>
      <td>tal</td>
      <td>lag</td>
      <td>ozir</td>
      <td>buxair</td>
      <td>- to be proposed -</td>
      <td>lake</td>
    </tr>
    <tr>
      <td>mabru</td>
      <td>buru</td>
      <td>maml</td>
      <td>stanpai</td>
      <td>mamifer</td>
      <td>mlikapitaiuc</td>
      <td>labun</td>
      <td>mamla</td>
      <td>mammal</td>
    </tr>
    <tr>
      <td>cirko</td>
      <td>ci</td>
      <td>luz</td>
      <td>ko</td>
      <td>perd</td>
      <td>tiriat</td>
      <td>xasir</td>
      <td>perda</td>
      <td>lose</td>
    </tr>
    <tr>
      <td>diklo</td>
      <td>di</td>
      <td>lokl</td>
      <td>stanik</td>
      <td>lokal</td>
      <td>miestn</td>
      <td>maxali</td>
      <td>lokla stanika</td>
      <td>local</td>
    </tr>
    <tr>
      <td>farvi</td>
      <td>fa</td>
      <td>evalv</td>
      <td>bar</td>
      <td>desaroi</td>
      <td>razviv</td>
      <td>taua</td>
      <td>- to be proposed -</td>
      <td>develop</td>
    </tr>
    <tr>
      <td>jduli</td>
      <td>dun</td>
      <td>jeli</td>
      <td>jeli</td>
      <td>xale</td>
      <td>jilie</td>
      <td>jalia</td>
      <td>- to be proposed -</td>
      <td>jelly</td>
    </tr>
    <tr>
      <td>jerna</td>
      <td>jen</td>
      <td>rn</td>
      <td>uparjan</td>
      <td>gan</td>
      <td>zarabativ</td>
      <td>kasab</td>
      <td>- to be proposed -</td>
      <td>earn</td>
    </tr>
    <tr>
      <td>ladru</td>
      <td>ru</td>
      <td>laktik</td>
      <td>dad</td>
      <td>lec</td>
      <td>malako</td>
      <td>laban</td>
      <td>laktika</td>
      <td>milk</td>
    </tr>
    <tr>
      <td>masti</td>
      <td>iue</td>
      <td>mant</td>
      <td>mas</td>
      <td>mes</td>
      <td>miesiis</td>
      <td>caxr</td>
      <td>manta caxra</td>
      <td>month</td>
    </tr>
    <tr>
      <td>slasi</td>
      <td>suliau</td>
      <td>plastik</td>
      <td>plastik</td>
      <td>plastik</td>
      <td>plastik</td>
      <td>blastik</td>
      <td>- to be proposed -</td>
      <td>plastic</td>
    </tr>
    <tr>
      <td>cinla</td>
      <td>ci</td>
      <td>tin</td>
      <td>patla</td>
      <td>flak</td>
      <td>tonk</td>
      <td>naxil</td>
      <td>patla flaka tonka</td>
      <td>thin</td>
    </tr>
    <tr>
      <td>kalci</td>
      <td>ci</td>
      <td>cit</td>
      <td>mal</td>
      <td>mierd</td>
      <td>kal</td>
      <td>xara</td>
      <td>- to be proposed -</td>
      <td>feces</td>
    </tr>
    <tr>
      <td>kinli</td>
      <td>li</td>
      <td>kin</td>
      <td>paina</td>
      <td>agud</td>
      <td>ostr</td>
      <td>takib</td>
      <td>- to be proposed -</td>
      <td>sharp</td>
    </tr>
    <tr>
      <td>lindi</td>
      <td>leidian</td>
      <td>laitnin</td>
      <td>bijli</td>
      <td>relampag</td>
      <td>molin</td>
      <td>bark</td>
      <td>bijli barka</td>
      <td>lightning</td>
    </tr>
    <tr>
      <td>rango</td>
      <td>guan</td>
      <td>orgn</td>
      <td>ang</td>
      <td>organ</td>
      <td>organ</td>
      <td>udu</td>
      <td>anga organa</td>
      <td>organ</td>
    </tr>
    <tr>
      <td>bavmi</td>
      <td>damai</td>
      <td>barli</td>
      <td>iav</td>
      <td>sebad</td>
      <td>iicmien</td>
      <td>cair</td>
      <td>barli</td>
      <td>barley</td>
    </tr>
    <tr>
      <td>cnebo</td>
      <td>bo</td>
      <td>nek</td>
      <td>gardan</td>
      <td>koi</td>
      <td>ciei</td>
      <td>unuk</td>
      <td>gardana</td>
      <td>neck</td>
    </tr>
    <tr>
      <td>cnici</td>
      <td>ci</td>
      <td>nit</td>
      <td>vicudv</td>
      <td>ase</td>
      <td>akuratn</td>
      <td>anik</td>
      <td>- to be proposed -</td>
      <td>orderly</td>
    </tr>
    <tr>
      <td>jansu</td>
      <td>uaijiau</td>
      <td>kansl</td>
      <td>rajaniik</td>
      <td>konsul</td>
      <td>konsul</td>
      <td>kunsul</td>
      <td>konsula kunsula</td>
      <td>diplomat</td>
    </tr>
    <tr>
      <td>narge</td>
      <td>jiangue</td>
      <td>nat</td>
      <td>giridarpal</td>
      <td>nos</td>
      <td>ariex</td>
      <td>mukasarat</td>
      <td>- to be proposed -</td>
      <td>nut</td>
    </tr>
    <tr>
      <td>nazbi</td>
      <td>bi</td>
      <td>noz</td>
      <td>nas</td>
      <td>naris</td>
      <td>nos</td>
      <td>anf</td>
      <td>anfa</td>
      <td>nose</td>
    </tr>
    <tr>
      <td>rinsa</td>
      <td>iin</td>
      <td>grit</td>
      <td>namaskar</td>
      <td>salud</td>
      <td>privietstv</td>
      <td>raxab</td>
      <td>grita</td>
      <td>greet</td>
    </tr>
    <tr>
      <td>jitro</td>
      <td>ji</td>
      <td>kantrol</td>
      <td>niiantrin</td>
      <td>kontrol</td>
      <td>kantrol</td>
      <td>saitar</td>
      <td>- to be proposed -</td>
      <td>control</td>
    </tr>
    <tr>
      <td>korka</td>
      <td>ruanmu</td>
      <td>kork</td>
      <td>kark</td>
      <td>korc</td>
      <td>propk</td>
      <td>filin</td>
      <td>korka karka korca</td>
      <td>cork</td>
    </tr>
    <tr>
      <td>sobde</td>
      <td>deu</td>
      <td>soi</td>
      <td>soiabin</td>
      <td>sox</td>
      <td>soi</td>
      <td>soja</td>
      <td>- to be proposed -</td>
      <td>soya</td>
    </tr>
    <tr>
      <td>tunka</td>
      <td>tun</td>
      <td>kapr</td>
      <td>tanba</td>
      <td>kobr</td>
      <td>miet</td>
      <td>nuxas</td>
      <td>kapra tanba kobra</td>
      <td>copper</td>
    </tr>
    <tr>
      <td>fepni</td>
      <td>fen</td>
      <td>peni</td>
      <td>paisa</td>
      <td>sentim</td>
      <td>kopek</td>
      <td>fils</td>
      <td>sentima filsa</td>
      <td>cent</td>
    </tr>
    <tr>
      <td>rupnu</td>
      <td>iuan</td>
      <td>paund</td>
      <td>rupi</td>
      <td>peso</td>
      <td>rubl</td>
      <td>dinar</td>
      <td>rubla</td>
      <td>dollar</td>
    </tr>
    <tr>
      <td>gusta</td>
      <td>guan</td>
      <td>restarnt</td>
      <td>restran</td>
      <td>restaurant</td>
      <td>ristaran</td>
      <td>matam</td>
      <td>- to be proposed -</td>
      <td>restaurant</td>
    </tr>
    <tr>
      <td>smacu</td>
      <td>cu</td>
      <td>maus</td>
      <td>mucik</td>
      <td>raton</td>
      <td>mic</td>
      <td>far</td>
      <td>- to be proposed -</td>
      <td>mouse</td>
    </tr>
    <tr>
      <td>tcidu</td>
      <td>du</td>
      <td>rid</td>
      <td>par</td>
      <td>le</td>
      <td>cit</td>
      <td>kara</td>
      <td>- to be proposed -</td>
      <td>read</td>
    </tr>
    <tr>
      <td>vreta</td>
      <td>tan</td>
      <td>rest</td>
      <td>vicram</td>
      <td>rekost</td>
      <td>lejac</td>
      <td>rakad</td>
      <td>resta</td>
      <td>reclining</td>
    </tr>
    <tr>
      <td>stani</td>
      <td>gan</td>
      <td>stak</td>
      <td>tan</td>
      <td>tai</td>
      <td>stiebil</td>
      <td>sak</td>
      <td>staka</td>
      <td>stalk</td>
    </tr>
    <tr>
      <td>preja</td>
      <td>jan</td>
      <td>spred</td>
      <td>pela</td>
      <td>propag</td>
      <td>rasprastir</td>
      <td>mabsut</td>
      <td>propaga</td>
      <td>spread</td>
    </tr>
    <tr>
      <td>solri</td>
      <td>ri</td>
      <td>solr</td>
      <td>sor</td>
      <td>sol</td>
      <td>solns</td>
      <td>cams</td>
      <td>solra camsa</td>
      <td>solar</td>
    </tr>
    <tr>
      <td>tcana</td>
      <td>jan</td>
      <td>steicn</td>
      <td>stecan</td>
      <td>parad</td>
      <td>stansii</td>
      <td>maxata</td>
      <td>stecana</td>
      <td>station</td>
    </tr>
    <tr>
      <td>fange</td>
      <td>uaigue</td>
      <td>farin</td>
      <td>aniadec</td>
      <td>ekstranxer</td>
      <td>inastran</td>
      <td>ajnabi</td>
      <td>ajnabi</td>
      <td>alien</td>
    </tr>
    <tr>
      <td>cisma</td>
      <td>ciau</td>
      <td>smail</td>
      <td>smit</td>
      <td>rison</td>
      <td>uliv</td>
      <td>basma</td>
      <td>smita basma</td>
      <td>smile</td>
    </tr>
    <tr>
      <td>rirci</td>
      <td>ci</td>
      <td>rer</td>
      <td>viral</td>
      <td>rar</td>
      <td>rietk</td>
      <td>nadir</td>
      <td>- to be proposed -</td>
      <td>rare</td>
    </tr>
    <tr>
      <td>xutla</td>
      <td>xua</td>
      <td>smut</td>
      <td>cikan</td>
      <td>plan</td>
      <td>glatk</td>
      <td>amlas</td>
      <td>smuta plana</td>
      <td>smooth</td>
    </tr>
    <tr>
      <td>salpo</td>
      <td>po</td>
      <td>slop</td>
      <td>dal</td>
      <td>sesg</td>
      <td>sklon</td>
      <td>inxadar</td>
      <td>slopa</td>
      <td>slope</td>
    </tr>
    <tr>
      <td>masno</td>
      <td>man</td>
      <td>slo</td>
      <td>mand</td>
      <td>despasi</td>
      <td>miedlin</td>
      <td>maxal</td>
      <td>manda</td>
      <td>slow</td>
    </tr>
    <tr>
      <td>calku</td>
      <td>ciau</td>
      <td>cel</td>
      <td>cilka</td>
      <td>kask</td>
      <td>abalock</td>
      <td>sadafa</td>
      <td>cilka kaska</td>
      <td>shell</td>
    </tr>
    <tr>
      <td>gubni</td>
      <td>gun</td>
      <td>pablik</td>
      <td>sarvajanik</td>
      <td>publik</td>
      <td>publicn</td>
      <td>cabi</td>
      <td>- to be proposed -</td>
      <td>public</td>
    </tr>
    <tr>
      <td>mosra</td>
      <td>mosa</td>
      <td>frikcn</td>
      <td>ragar</td>
      <td>ros</td>
      <td>trieni</td>
      <td>tasadum</td>
      <td>- to be proposed -</td>
      <td>friction</td>
    </tr>
    <tr>
      <td>ratcu</td>
      <td>cu</td>
      <td>rat</td>
      <td>cux</td>
      <td>rat</td>
      <td>kris</td>
      <td>jurad</td>
      <td>krisa</td>
      <td>rat</td>
    </tr>
    <tr>
      <td>gasta</td>
      <td>gan</td>
      <td>stil</td>
      <td>ispat</td>
      <td>aser</td>
      <td>stal</td>
      <td>sulb</td>
      <td>stila stala sulba</td>
      <td>steel</td>
    </tr>
    <tr>
      <td>limna</td>
      <td>iun</td>
      <td>suim</td>
      <td>ter</td>
      <td>nad</td>
      <td>plit</td>
      <td>sabax</td>
      <td>plita</td>
      <td>swim</td>
    </tr>
    <tr>
      <td>nalci</td>
      <td>ci</td>
      <td>uin</td>
      <td>pakc</td>
      <td>al</td>
      <td>krilo</td>
      <td>janax</td>
      <td>pakca krilo</td>
      <td>wing</td>
    </tr>
    <tr>
      <td>pante</td>
      <td>kan</td>
      <td>protest</td>
      <td>prativad</td>
      <td>protest</td>
      <td>pratiest</td>
      <td>ixtaj</td>
      <td>ixtaja</td>
      <td>protest</td>
    </tr>
    <tr>
      <td>prosa</td>
      <td>sanuen</td>
      <td>proz</td>
      <td>gadia</td>
      <td>pros</td>
      <td>proz</td>
      <td>natri</td>
      <td>proza prosa natri</td>
      <td>prose</td>
    </tr>
    <tr>
      <td>sakta</td>
      <td>tan</td>
      <td>sukros</td>
      <td>cakar</td>
      <td>asukar</td>
      <td>saxar</td>
      <td>sukar</td>
      <td>- to be proposed -</td>
      <td>sugar</td>
    </tr>
    <tr>
      <td>sipna</td>
      <td>mian</td>
      <td>slip</td>
      <td>sona</td>
      <td>dorm</td>
      <td>spat</td>
      <td>nam</td>
      <td>slipa dorma spata</td>
      <td>sleep</td>
    </tr>
    <tr>
      <td>sivni</td>
      <td>si</td>
      <td>privi</td>
      <td>nij</td>
      <td>privad</td>
      <td>castn</td>
      <td>xusus</td>
      <td>privi privada</td>
      <td>private</td>
    </tr>
    <tr>
      <td>stura</td>
      <td>geuzau</td>
      <td>strakcr</td>
      <td>sanracna</td>
      <td>estruktur</td>
      <td>struktur</td>
      <td>tarkib</td>
      <td>tarkiba</td>
      <td>structure</td>
    </tr>
    <tr>
      <td>sunla</td>
      <td>ianmau</td>
      <td>uul</td>
      <td>un</td>
      <td>lan</td>
      <td>cierst</td>
      <td>suf</td>
      <td>- to be proposed -</td>
      <td>wool</td>
    </tr>
    <tr>
      <td>genja</td>
      <td>gen</td>
      <td>rut</td>
      <td>jar</td>
      <td>rais</td>
      <td>korin</td>
      <td>jadra</td>
      <td>jadra</td>
      <td>root</td>
    </tr>
    <tr>
      <td>pluja</td>
      <td>fuza</td>
      <td>kamplakeit</td>
      <td>jatil</td>
      <td>komplex</td>
      <td>slojn</td>
      <td>murakab</td>
      <td>- to be proposed -</td>
      <td>complicated</td>
    </tr>
    <tr>
      <td>rozgu</td>
      <td>maiguei</td>
      <td>roz</td>
      <td>gulab</td>
      <td>ros</td>
      <td>roz</td>
      <td>uarda</td>
      <td>- to be proposed -</td>
      <td>rose</td>
    </tr>
    <tr>
      <td>sampu</td>
      <td>pu</td>
      <td>simpl</td>
      <td>sad</td>
      <td>simpl</td>
      <td>prost</td>
      <td>sadaj</td>
      <td>- to be proposed -</td>
      <td>simple</td>
    </tr>
    <tr>
      <td>silka</td>
      <td>si</td>
      <td>silk</td>
      <td>silk</td>
      <td>sed</td>
      <td>ciak</td>
      <td>kaz</td>
      <td>silka</td>
      <td>silk</td>
    </tr>
    <tr>
      <td>bancu</td>
      <td>cu</td>
      <td>biand</td>
      <td>baxar</td>
      <td>tras</td>
      <td>vic</td>
      <td>bada</td>
      <td>trasa</td>
      <td>beyond</td>
    </tr>
    <tr>
      <td>cnemu</td>
      <td>ceu</td>
      <td>riuord</td>
      <td>inam</td>
      <td>premi</td>
      <td>nagrajd</td>
      <td>kafa</td>
      <td>premi</td>
      <td>reward</td>
    </tr>
    <tr>
      <td>silna</td>
      <td>ian</td>
      <td>salt</td>
      <td>namak</td>
      <td>sal</td>
      <td>sol</td>
      <td>milx</td>
      <td>salta milxa</td>
      <td>salt</td>
    </tr>
    <tr>
      <td>tsiju</td>
      <td>jun</td>
      <td>sid</td>
      <td>bij</td>
      <td>simient</td>
      <td>siemi</td>
      <td>badra</td>
      <td>badra</td>
      <td>seed</td>
    </tr>
    <tr>
      <td>mleca</td>
      <td>cau</td>
      <td>les</td>
      <td>kam</td>
      <td>menos</td>
      <td>mienc</td>
      <td>akala</td>
      <td>- to be proposed -</td>
      <td>less</td>
    </tr>
    <tr>
      <td>djine</td>
      <td>jie</td>
      <td>rin</td>
      <td>mudrik</td>
      <td>ar</td>
      <td>kalso</td>
      <td>xatim</td>
      <td>kalso</td>
      <td>ring</td>
    </tr>
    <tr>
      <td>pritu</td>
      <td>ieu</td>
      <td>rait</td>
      <td>daxin</td>
      <td>derec</td>
      <td>prav</td>
      <td>iamin</td>
      <td>prava</td>
      <td>right</td>
    </tr>
    <tr>
      <td>renvi</td>
      <td>ren</td>
      <td>srvaiv</td>
      <td>jivitrax</td>
      <td>sobreviv</td>
      <td>vijiv</td>
      <td>bakaxai</td>
      <td>- to be proposed -</td>
      <td>survive</td>
    </tr>
    <tr>
      <td>ricfu</td>
      <td>fu</td>
      <td>ric</td>
      <td>dan</td>
      <td>rik</td>
      <td>bagat</td>
      <td>tari</td>
      <td>- to be proposed -</td>
      <td>rich</td>
    </tr>
    <tr>
      <td>manfo</td>
      <td>iiian</td>
      <td>iunaform</td>
      <td>eksaman</td>
      <td>uniform</td>
      <td>adnarodn</td>
      <td>tamatul</td>
      <td>- to be proposed -</td>
      <td>uniform</td>
    </tr>
    <tr>
      <td>kuspe</td>
      <td>kue</td>
      <td>span</td>
      <td>pel</td>
      <td>abark</td>
      <td>oxvativ</td>
      <td>xaiiz</td>
      <td>spana</td>
      <td>range</td>
    </tr>
    <tr>
      <td>satre</td>
      <td>sa</td>
      <td>strok</td>
      <td>saxl</td>
      <td>estreg</td>
      <td>tiriet</td>
      <td>lataf</td>
      <td>saxla</td>
      <td>stroke</td>
    </tr>
    <tr>
      <td>dasni</td>
      <td>dai</td>
      <td>uer</td>
      <td>paxna</td>
      <td>vest</td>
      <td>nas</td>
      <td>albas</td>
      <td>paxna vesta albasa</td>
      <td>wear</td>
    </tr>
    <tr>
      <td>kanji</td>
      <td>ji</td>
      <td>rekan</td>
      <td>ganan</td>
      <td>kalkul</td>
      <td>vicisl</td>
      <td>xasab</td>
      <td>kalkula</td>
      <td>calculate</td>
    </tr>
    <tr>
      <td>skami</td>
      <td>jisuanji</td>
      <td>kampiutr</td>
      <td>parikalk</td>
      <td>kalkulador</td>
      <td>kampiutir</td>
      <td>xasib</td>
      <td>- to be proposed -</td>
      <td>computer</td>
    </tr>
    <tr>
      <td>sicni</td>
      <td>iinbi</td>
      <td>spici</td>
      <td>sik</td>
      <td>fic</td>
      <td>maniet</td>
      <td>nakda</td>
      <td>spici</td>
      <td>coin</td>
    </tr>
    <tr>
      <td>binxo</td>
      <td>bian</td>
      <td>bikam</td>
      <td>xo</td>
      <td>asers</td>
      <td>dien</td>
      <td>inkalab</td>
      <td>- to be proposed -</td>
      <td>become</td>
    </tr>
    <tr>
      <td>slami</td>
      <td>suan</td>
      <td>asid</td>
      <td>amli</td>
      <td>asid</td>
      <td>kislata</td>
      <td>xamid</td>
      <td>amli</td>
      <td>acid</td>
    </tr>
    <tr>
      <td>sucta</td>
      <td>ceucian</td>
      <td>abstakt</td>
      <td>amurt</td>
      <td>apstrakt</td>
      <td>apstraktn</td>
      <td>tajridi</td>
      <td>tajridi</td>
      <td>abstract</td>
    </tr>
    <tr>
      <td>vinji</td>
      <td>feiji</td>
      <td>erplein</td>
      <td>viman</td>
      <td>avion</td>
      <td>samaliot</td>
      <td>taiir</td>
      <td>- to be proposed -</td>
      <td>airplane</td>
    </tr>
    <tr>
      <td>zbepi</td>
      <td>zue</td>
      <td>beis</td>
      <td>piti</td>
      <td>pedestal</td>
      <td>pidistal</td>
      <td>rakiz</td>
      <td>- to be proposed -</td>
      <td>pedestal</td>
    </tr>
    <tr>
      <td>galfi</td>
      <td>gai</td>
      <td>altr</td>
      <td>badal</td>
      <td>modifik</td>
      <td>madifisirav</td>
      <td>gaiar</td>
      <td>- to be proposed -</td>
      <td>modify</td>
    </tr>
    <tr>
      <td>danre</td>
      <td>an</td>
      <td>precr</td>
      <td>dab</td>
      <td>presion</td>
      <td>davlieni</td>
      <td>dagta</td>
      <td>- to be proposed -</td>
      <td>pressure</td>
    </tr>
    <tr>
      <td>simxu</td>
      <td>xu</td>
      <td>miucul</td>
      <td>apsi</td>
      <td>resiprok</td>
      <td>vzaimn</td>
      <td>muctarak</td>
      <td>apsi</td>
      <td>mutual</td>
    </tr>
    <tr>
      <td>banfi</td>
      <td>lianci</td>
      <td>amfibian</td>
      <td>ubaiacar</td>
      <td>anfibi</td>
      <td>amfibii</td>
      <td>barmai</td>
      <td>anfibi</td>
      <td>amphibian</td>
    </tr>
    <tr>
      <td>gradu</td>
      <td>du</td>
      <td>dagri</td>
      <td>anc</td>
      <td>grad</td>
      <td>gradus</td>
      <td>daraj</td>
      <td>dagri anca grada gradusa</td>
      <td>unit</td>
    </tr>
    <tr>
      <td>jimpe</td>
      <td>jie</td>
      <td>kampraxend</td>
      <td>samja</td>
      <td>komprend</td>
      <td>panim</td>
      <td>faxim</td>
      <td>samja</td>
      <td>understand</td>
    </tr>
    <tr>
      <td>karbi</td>
      <td>bi</td>
      <td>kamper</td>
      <td>barabar</td>
      <td>kompar</td>
      <td>sravniv</td>
      <td>karan</td>
      <td>kampera kompara</td>
      <td>compare</td>
    </tr>
    <tr>
      <td>lanli</td>
      <td>ianjieu</td>
      <td>analaiz</td>
      <td>viclecan</td>
      <td>analiz</td>
      <td>analizirav</td>
      <td>xalal</td>
      <td>- to be proposed -</td>
      <td>analyze</td>
    </tr>
    <tr>
      <td>dasri</td>
      <td>dai</td>
      <td>ribn</td>
      <td>dar</td>
      <td>xiron</td>
      <td>palasa</td>
      <td>carit</td>
      <td>ribna</td>
      <td>ribbon</td>
    </tr>
    <tr>
      <td>maksi</td>
      <td>si</td>
      <td>magnit</td>
      <td>cumbak</td>
      <td>iman</td>
      <td>magnit</td>
      <td>magnatis</td>
      <td>magnita cumbaka</td>
      <td>magnet</td>
    </tr>
    <tr>
      <td>cokcu</td>
      <td>ciceu</td>
      <td>sokap</td>
      <td>coc</td>
      <td>cup</td>
      <td>paglac</td>
      <td>masa</td>
      <td>- to be proposed -</td>
      <td>soak up</td>
    </tr>
    <tr>
      <td>lidne</td>
      <td>lin</td>
      <td>lidr</td>
      <td>neta</td>
      <td>lider</td>
      <td>lidir</td>
      <td>murcid</td>
      <td>lidra murcida</td>
      <td>precede</td>
    </tr>
    <tr>
      <td>jilka</td>
      <td>jian</td>
      <td>alkalai</td>
      <td>kar</td>
      <td>alkalin</td>
      <td>cilacn</td>
      <td>kilua</td>
      <td>- to be proposed -</td>
      <td>alkali</td>
    </tr>
    <tr>
      <td>nejni</td>
      <td>nen</td>
      <td>enrji</td>
      <td>tej</td>
      <td>enerxi</td>
      <td>iniergii</td>
      <td>taka</td>
      <td>- to be proposed -</td>
      <td>energy</td>
    </tr>
    <tr>
      <td>porsi</td>
      <td>si</td>
      <td>ordr</td>
      <td>silsil</td>
      <td>orden</td>
      <td>pariadak</td>
      <td>taba</td>
      <td>silsila ordena</td>
      <td>sequence</td>
    </tr>
    <tr>
      <td>ratni</td>
      <td>iuanzi</td>
      <td>atm</td>
      <td>parmanu</td>
      <td>atom</td>
      <td>atam</td>
      <td>dara</td>
      <td>atma parmanu</td>
      <td>atom</td>
    </tr>
    <tr>
      <td>salci</td>
      <td>cin</td>
      <td>selabreit</td>
      <td>utsav</td>
      <td>solemnis</td>
      <td>spravl</td>
      <td>xafla</td>
      <td>xafla</td>
      <td>celebrate</td>
    </tr>
    <tr>
      <td>snidu</td>
      <td>miau</td>
      <td>seknd</td>
      <td>sekand</td>
      <td>segund</td>
      <td>sikund</td>
      <td>tani</td>
      <td>- to be proposed -</td>
      <td>second</td>
    </tr>
    <tr>
      <td>xalka</td>
      <td>jieujin</td>
      <td>alkaxal</td>
      <td>ailkoxal</td>
      <td>alkol</td>
      <td>alkagol</td>
      <td>kuxul</td>
      <td>alkola</td>
      <td>alcohol</td>
    </tr>
    <tr>
      <td>jgina</td>
      <td>jiiin</td>
      <td>jin</td>
      <td>jin</td>
      <td>xen</td>
      <td>gien</td>
      <td>muarita</td>
      <td>- to be proposed -</td>
      <td>gene</td>
    </tr>
    <tr>
      <td>vlina</td>
      <td>lian</td>
      <td>altrneicn</td>
      <td>vikalp</td>
      <td>alternativ</td>
      <td>altirnativ</td>
      <td>iuad</td>
      <td>- to be proposed -</td>
      <td>alternation</td>
    </tr>
    <tr>
      <td>jarco</td>
      <td>jancu</td>
      <td>co</td>
      <td>pradarcan</td>
      <td>eksib</td>
      <td>vistavl</td>
      <td>ard</td>
      <td>jancu eksiba arda</td>
      <td>show</td>
    </tr>
    <tr>
      <td>dunku</td>
      <td>tunku</td>
      <td>anguic</td>
      <td>duxk</td>
      <td>angusti</td>
      <td>agarcieni</td>
      <td>alam</td>
      <td>tunku</td>
      <td>anguish</td>
    </tr>
    <tr>
      <td>nilce</td>
      <td>cence</td>
      <td>frnic</td>
      <td>farnicar</td>
      <td>mobiliari</td>
      <td>miebil</td>
      <td>mobiliia</td>
      <td>cence</td>
      <td>furniture</td>
    </tr>
    <tr>
      <td>jmaji</td>
      <td>ji</td>
      <td>gadr</td>
      <td>jama</td>
      <td>amas</td>
      <td>sabir</td>
      <td>jama</td>
      <td>gadra</td>
      <td>gather</td>
    </tr>
    <tr>
      <td>jbari</td>
      <td>jiangue</td>
      <td>beri</td>
      <td>badri</td>
      <td>bai</td>
      <td>iagad</td>
      <td>tamar</td>
      <td>badri</td>
      <td>berry</td>
    </tr>
    <tr>
      <td>jipci</td>
      <td>ji</td>
      <td>cikn</td>
      <td>cingan</td>
      <td>poi</td>
      <td>kuris</td>
      <td>dajaj</td>
      <td>cikna cingana</td>
      <td>chicken</td>
    </tr>
    <tr>
      <td>selci</td>
      <td>cibau</td>
      <td>sel</td>
      <td>kocik</td>
      <td>selul</td>
      <td>iicieik</td>
      <td>xali</td>
      <td>- to be proposed -</td>
      <td>cell</td>
    </tr>
    <tr>
      <td>staku</td>
      <td>tau</td>
      <td>saramik</td>
      <td>mritik</td>
      <td>seramik</td>
      <td>kiramicisk</td>
      <td>xazaf</td>
      <td>mritika</td>
      <td>ceramic</td>
    </tr>
    <tr>
      <td>toldi</td>
      <td>die</td>
      <td>batrflai</td>
      <td>titli</td>
      <td>polii</td>
      <td>mol</td>
      <td>ut</td>
      <td>titli</td>
      <td>butterfly</td>
    </tr>
    <tr>
      <td>bidju</td>
      <td>ju</td>
      <td>bid</td>
      <td>mank</td>
      <td>abalor</td>
      <td>bisir</td>
      <td>xaraz</td>
      <td>manka</td>
      <td>bead</td>
    </tr>
    <tr>
      <td>clira</td>
      <td>cian</td>
      <td>rli</td>
      <td>praramb</td>
      <td>tempraner</td>
      <td>ran</td>
      <td>bakir</td>
      <td>- to be proposed -</td>
      <td>early</td>
    </tr>
    <tr>
      <td>livla</td>
      <td>ranliau</td>
      <td>fiul</td>
      <td>jalavan</td>
      <td>kombustibl</td>
      <td>topliv</td>
      <td>uakud</td>
      <td>- to be proposed -</td>
      <td>fuel</td>
    </tr>
    <tr>
      <td>makfa</td>
      <td>fa</td>
      <td>majik</td>
      <td>maia</td>
      <td>maxi</td>
      <td>magii</td>
      <td>sixri</td>
      <td>sixri</td>
      <td>magic</td>
    </tr>
    <tr>
      <td>sazri</td>
      <td>sauzue</td>
      <td>apreit</td>
      <td>parical</td>
      <td>dirix</td>
      <td>abrac</td>
      <td>saiar</td>
      <td>- to be proposed -</td>
      <td>operate</td>
    </tr>
    <tr>
      <td>xajmi</td>
      <td>xuaji</td>
      <td>kamik</td>
      <td>xasia</td>
      <td>komik</td>
      <td>kamicn</td>
      <td>xazli</td>
      <td>xazli</td>
      <td>funny</td>
    </tr>
    <tr>
      <td>tcita</td>
      <td>biaucian</td>
      <td>tag</td>
      <td>cipi</td>
      <td>etiket</td>
      <td>itikietk</td>
      <td>bitaka</td>
      <td>- to be proposed -</td>
      <td>label</td>
    </tr>
    <tr>
      <td>jmina</td>
      <td>jia</td>
      <td>agment</td>
      <td>mila</td>
      <td>anad</td>
      <td>pribavl</td>
      <td>jama</td>
      <td>- to be proposed -</td>
      <td>add</td>
    </tr>
    <tr>
      <td>cecmu</td>
      <td>cecu</td>
      <td>kamiuniti</td>
      <td>samudai</td>
      <td>komunidad</td>
      <td>obcin</td>
      <td>jamai</td>
      <td>- to be proposed -</td>
      <td>community</td>
    </tr>
    <tr>
      <td>cinza</td>
      <td>cian</td>
      <td>tanz</td>
      <td>cimta</td>
      <td>pins</td>
      <td>cipsi</td>
      <td>macik</td>
      <td>tanza cimta pinsa cipsi</td>
      <td>tongs</td>
    </tr>
    <tr>
      <td>ctebi</td>
      <td>cuen</td>
      <td>leibil</td>
      <td>oct</td>
      <td>labi</td>
      <td>guba</td>
      <td>cafa</td>
      <td>octa</td>
      <td>lip</td>
    </tr>
    <tr>
      <td>gundi</td>
      <td>gunie</td>
      <td>indastri</td>
      <td>udiog</td>
      <td>industri</td>
      <td>industri</td>
      <td>sinai</td>
      <td>- to be proposed -</td>
      <td>industry</td>
    </tr>
    <tr>
      <td>jgalu</td>
      <td>jau</td>
      <td>taln</td>
      <td>nakun</td>
      <td>gar</td>
      <td>nogat</td>
      <td>difr</td>
      <td>talna difra</td>
      <td>claw</td>
    </tr>
    <tr>
      <td>nibli</td>
      <td>cibicu</td>
      <td>enteil</td>
      <td>anivaria</td>
      <td>implik</td>
      <td>vavlik</td>
      <td>tatalaba</td>
      <td>- to be proposed -</td>
      <td>necessitate</td>
    </tr>
    <tr>
      <td>panzi</td>
      <td>zi</td>
      <td>prajeni</td>
      <td>apatia</td>
      <td>proxeni</td>
      <td>patomak</td>
      <td>sulala</td>
      <td>prajeni proxeni</td>
      <td>offspring</td>
    </tr>
    <tr>
      <td>bandu</td>
      <td>bau</td>
      <td>difend</td>
      <td>baca</td>
      <td>defend</td>
      <td>abaran</td>
      <td>sana</td>
      <td>- to be proposed -</td>
      <td>defend</td>
    </tr>
    <tr>
      <td>kalsa</td>
      <td>luan</td>
      <td>keias</td>
      <td>astaviast</td>
      <td>kaos</td>
      <td>xaos</td>
      <td>fauda</td>
      <td>- to be proposed -</td>
      <td>chaotic</td>
    </tr>
    <tr>
      <td>maxri</td>
      <td>mai</td>
      <td>xuit</td>
      <td>genxu</td>
      <td>trig</td>
      <td>pcinis</td>
      <td>kamx</td>
      <td>genxu triga kamxa</td>
      <td>wheat</td>
    </tr>
    <tr>
      <td>bridi</td>
      <td>a20a</td>
      <td>broda</td>
      <td>predicate</td>
      <td>var</td>
      <td>1</td>
      <td>o</td>
      <td>broda</td>
      <td>predicate</td>
    </tr>
    <tr>
      <td>gerna</td>
      <td>uenfa</td>
      <td>gramr</td>
      <td>viakarn</td>
      <td>gramatik</td>
      <td>gramatik</td>
      <td>naxua</td>
      <td>- to be proposed -</td>
      <td>grammar</td>
    </tr>
    <tr>
      <td>gletu</td>
      <td>geu</td>
      <td>kapiuleit</td>
      <td>metun</td>
      <td>koit</td>
      <td>savakupl</td>
      <td>safid</td>
      <td>- to be proposed -</td>
      <td>copulate</td>
    </tr>
    <tr>
      <td>sfani</td>
      <td>saniin</td>
      <td>flai</td>
      <td>maki</td>
      <td>mosk</td>
      <td>mux</td>
      <td>dubab</td>
      <td>moska</td>
      <td>fly</td>
    </tr>
    <tr>
      <td>xagji</td>
      <td>ji</td>
      <td>xangr</td>
      <td>buka</td>
      <td>ambr</td>
      <td>golad</td>
      <td>sagib</td>
      <td>- to be proposed -</td>
      <td>hunger</td>
    </tr>
    <tr>
      <td>xatra</td>
      <td>xan</td>
      <td>letr</td>
      <td>patr</td>
      <td>kart</td>
      <td>pismo</td>
      <td>xitab</td>
      <td>letra patra karta pismo</td>
      <td>letter</td>
    </tr>
    <tr>
      <td>zirpu</td>
      <td>zi</td>
      <td>prpl</td>
      <td>bangni</td>
      <td>purpur</td>
      <td>lilav</td>
      <td>firfir</td>
      <td>purpura firfira</td>
      <td>purple</td>
    </tr>
    <tr>
      <td>cunmi</td>
      <td>cu</td>
      <td>milit</td>
      <td>cen</td>
      <td>mix</td>
      <td>pcino</td>
      <td>duxn</td>
      <td>duxna</td>
      <td>millet</td>
    </tr>
    <tr>
      <td>kusru</td>
      <td>ku</td>
      <td>krul</td>
      <td>krur</td>
      <td>kruel</td>
      <td>jistok</td>
      <td>kas</td>
      <td>krula krura</td>
      <td>cruel</td>
    </tr>
    <tr>
      <td>mraji</td>
      <td>xeimai</td>
      <td>rai</td>
      <td>rai</td>
      <td>senten</td>
      <td>roj</td>
      <td>jaudar</td>
      <td>sentena</td>
      <td>rye</td>
    </tr>
    <tr>
      <td>ranji</td>
      <td>ji</td>
      <td>kntiniu</td>
      <td>rax</td>
      <td>kontinu</td>
      <td>pradalj</td>
      <td>istamar</td>
      <td>kontinu</td>
      <td>continue</td>
    </tr>
    <tr>
      <td>mapni</td>
      <td>mian</td>
      <td>katn</td>
      <td>kapans</td>
      <td>algodon</td>
      <td>bumajnai</td>
      <td>kutni</td>
      <td>katna kutni</td>
      <td>cotton</td>
    </tr>
    <tr>
      <td>rimni</td>
      <td>iun</td>
      <td>raim</td>
      <td>tuk</td>
      <td>rim</td>
      <td>rifm</td>
      <td>kafi</td>
      <td>rifma</td>
      <td>rhyme</td>
    </tr>
    <tr>
      <td>runta</td>
      <td>run</td>
      <td>dizalv</td>
      <td>vigatan</td>
      <td>disolv</td>
      <td>rastvar</td>
      <td>taduib</td>
      <td>- to be proposed -</td>
      <td>dissolve</td>
    </tr>
    <tr>
      <td>vikmi</td>
      <td>mi</td>
      <td>ekskrit</td>
      <td>nikal</td>
      <td>ekskret</td>
      <td>vidil</td>
      <td>faraz</td>
      <td>- to be proposed -</td>
      <td>excrete</td>
    </tr>
    <tr>
      <td>kafke</td>
      <td>ke</td>
      <td>kaf</td>
      <td>kas</td>
      <td>tos</td>
      <td>kacil</td>
      <td>sual</td>
      <td>- to be proposed -</td>
      <td>cough</td>
    </tr>
    <tr>
      <td>marxa</td>
      <td>iaxuai</td>
      <td>mac</td>
      <td>maragja</td>
      <td>max</td>
      <td>dav</td>
      <td>masa</td>
      <td>- to be proposed -</td>
      <td>mash</td>
    </tr>
    <tr>
      <td>rapli</td>
      <td>liu</td>
      <td>ripit</td>
      <td>doxara</td>
      <td>repet</td>
      <td>paftar</td>
      <td>karar</td>
      <td>paftara</td>
      <td>repeat</td>
    </tr>
    <tr>
      <td>sirji</td>
      <td>ji</td>
      <td>streit</td>
      <td>sid</td>
      <td>direkt</td>
      <td>priim</td>
      <td>saui</td>
      <td>- to be proposed -</td>
      <td>straight</td>
    </tr>
    <tr>
      <td>natfe</td>
      <td>feu</td>
      <td>dinai</td>
      <td>na</td>
      <td>net</td>
      <td>atris</td>
      <td>nafa</td>
      <td>- to be proposed -</td>
      <td>deny</td>
    </tr>
    <tr>
      <td>tanru</td>
      <td>iiniu</td>
      <td>metafor</td>
      <td>rupak</td>
      <td>metafor</td>
      <td>mitafar</td>
      <td>istiar</td>
      <td>- to be proposed -</td>
      <td>
        <div>
          <div>phrase compound</div>
        </div>
      </td>
    </tr>
    <tr>
      <td>sumti</td>
      <td>ti</td>
      <td>argiumnt</td>
      <td>iukti</td>
      <td>suxet</td>
      <td>dapalnieni</td>
      <td>mubtada</td>
      <td>- to be proposed -</td>
      <td>argument</td>
    </tr>
    <tr>
      <td>zumri</td>
      <td>iumi</td>
      <td>meiz</td>
      <td>marki</td>
      <td>mais</td>
      <td>mais</td>
      <td>dura</td>
      <td>marki</td>
      <td>maize</td>
    </tr>
    <tr>
      <td>tigni</td>
      <td>ian</td>
      <td>prform</td>
      <td>abxinai</td>
      <td>artist</td>
      <td>igr</td>
      <td>xafl</td>
      <td>igra xafla</td>
      <td>perform</td>
    </tr>
    <tr>
      <td>mabla</td>
      <td>bian</td>
      <td>mal</td>
      <td>alpkar</td>
      <td>mal</td>
      <td>umal</td>
      <td>xat</td>
      <td>- to be proposed -</td>
      <td>derogative</td>
    </tr>
    <tr>
      <td>zabna</td>
      <td>zan</td>
      <td>bena</td>
      <td>saxaiak</td>
      <td>bien</td>
      <td>blagaskion</td>
      <td>sabix</td>
      <td>- to be proposed -</td>
      <td>favorable</td>
    </tr>
    <tr>
      <td>morna</td>
      <td>mo</td>
      <td>patrn</td>
      <td>namuna</td>
      <td>disen</td>
      <td>uzor</td>
      <td>namudaj</td>
      <td>- to be proposed -</td>
      <td>pattern</td>
    </tr>
    <tr>
      <td>trati</td>
      <td>lajin</td>
      <td>tat</td>
      <td>prabav</td>
      <td>tirant</td>
      <td>natianut</td>
      <td>tauatur</td>
      <td>prabava</td>
      <td>taut</td>
    </tr>
    <tr>
      <td>fenki</td>
      <td>fen</td>
      <td>frenzi</td>
      <td>sank</td>
      <td>dement</td>
      <td>umalicion</td>
      <td>majnun</td>
      <td>sanka majnuna</td>
      <td>crazy</td>
    </tr>
    <tr>
      <td>zalvi</td>
      <td>za</td>
      <td>palvraiz</td>
      <td>daln</td>
      <td>pulveris</td>
      <td>pazmaliv</td>
      <td>taxan</td>
      <td>dalna</td>
      <td>grind</td>
    </tr>
    <tr>
      <td>cimni</td>
      <td>uuciun</td>
      <td>infanit</td>
      <td>asim</td>
      <td>infinit</td>
      <td>biskaniec</td>
      <td>lanixai</td>
      <td>- to be proposed -</td>
      <td>infinite</td>
    </tr>
    <tr>
      <td>vanci</td>
      <td>uan</td>
      <td>ivnin</td>
      <td>sandia</td>
      <td>anoceser</td>
      <td>viecir</td>
      <td>masa</td>
      <td>ivnina</td>
      <td>evening</td>
    </tr>
    <tr>
      <td>palci</td>
      <td>cie</td>
      <td>malign</td>
      <td>pap</td>
      <td>mal</td>
      <td>zloi</td>
      <td>cirir</td>
      <td>- to be proposed -</td>
      <td>evil</td>
    </tr>
    <tr>
      <td>fancu</td>
      <td>xancu</td>
      <td>fankcn</td>
      <td>falan</td>
      <td>funsion</td>
      <td>funksii</td>
      <td>dala</td>
      <td>xancu</td>
      <td>function</td>
    </tr>
    <tr>
      <td>jgita</td>
      <td>jita</td>
      <td>gitar</td>
      <td>gitar</td>
      <td>gitarist</td>
      <td>gitar</td>
      <td>kitar</td>
      <td>- to be proposed -</td>
      <td>guitar</td>
    </tr>
    <tr>
      <td>zajba</td>
      <td>zaji</td>
      <td>akrabat</td>
      <td>kalabaz</td>
      <td>akrobat</td>
      <td>akrabat</td>
      <td>baxluan</td>
      <td>- to be proposed -</td>
      <td>gymnast</td>
    </tr>
    <tr>
      <td>ciksi</td>
      <td>ci</td>
      <td>iksplein</td>
      <td>viakia</td>
      <td>eksplik</td>
      <td>abiisn</td>
      <td>baian</td>
      <td>- to be proposed -</td>
      <td>explain</td>
    </tr>
    <tr>
      <td>gunse</td>
      <td>e</td>
      <td>gus</td>
      <td>xans</td>
      <td>gans</td>
      <td>gus</td>
      <td>uaza</td>
      <td>xansa gansa</td>
      <td>goose</td>
    </tr>
    <tr>
      <td>jurme</td>
      <td>juen</td>
      <td>jrm</td>
      <td>roganu</td>
      <td>xermen</td>
      <td>baktierii</td>
      <td>jurtum</td>
      <td>xermena jurtuma</td>
      <td>germ</td>
    </tr>
    <tr>
      <td>xalbo</td>
      <td>bo</td>
      <td>frivalas</td>
      <td>xalk</td>
      <td>lixer</td>
      <td>lioxk</td>
      <td>tafif</td>
      <td>xalka</td>
      <td>levity</td>
    </tr>
    <tr>
      <td>dicra</td>
      <td>daca</td>
      <td>distrb</td>
      <td>viram</td>
      <td>interump</td>
      <td>piribiv</td>
      <td>akara</td>
      <td>- to be proposed -</td>
      <td>interrupt</td>
    </tr>
    <tr>
      <td>satci</td>
      <td>cuecie</td>
      <td>prisais</td>
      <td>satik</td>
      <td>eksakt</td>
      <td>toc</td>
      <td>saxix</td>
      <td>- to be proposed -</td>
      <td>exact</td>
    </tr>
    <tr>
      <td>bratu</td>
      <td>bau</td>
      <td>xeil</td>
      <td>ol</td>
      <td>granis</td>
      <td>grat</td>
      <td>barad</td>
      <td>granisa grata</td>
      <td>hail</td>
    </tr>
    <tr>
      <td>crepu</td>
      <td>ceu</td>
      <td>rip</td>
      <td>fasal</td>
      <td>rekox</td>
      <td>jat</td>
      <td>xasad</td>
      <td>- to be proposed -</td>
      <td>harvest</td>
    </tr>
    <tr>
      <td>plana</td>
      <td>pan</td>
      <td>plamp</td>
      <td>mansal</td>
      <td>obes</td>
      <td>poln</td>
      <td>badin</td>
      <td>mansala polna</td>
      <td>plump</td>
    </tr>
    <tr>
      <td>cikre</td>
      <td>cieu</td>
      <td>fiks</td>
      <td>tik</td>
      <td>aregl</td>
      <td>cin</td>
      <td>ratak</td>
      <td>fiksa</td>
      <td>repair</td>
    </tr>
    <tr>
      <td>xaksu</td>
      <td>xau</td>
      <td>knsum</td>
      <td>xarcik</td>
      <td>konsum</td>
      <td>trat</td>
      <td>anfak</td>
      <td>xarcika konsuma trata anfaka</td>
      <td>use up</td>
    </tr>
    <tr>
      <td>binra</td>
      <td>baucian</td>
      <td>incr</td>
      <td>bim</td>
      <td>asegur</td>
      <td>straxav</td>
      <td>tamin</td>
      <td>- to be proposed -</td>
      <td>insure</td>
    </tr>
    <tr>
      <td>detri</td>
      <td>rici</td>
      <td>deit</td>
      <td>tarix</td>
      <td>fec</td>
      <td>dat</td>
      <td>tarix</td>
      <td>- to be proposed -</td>
      <td>date</td>
    </tr>
    <tr>
      <td>frinu</td>
      <td>fencu</td>
      <td>frakcn</td>
      <td>bin</td>
      <td>fraksion</td>
      <td>drop</td>
      <td>kasr</td>
      <td>fencu dropa kasra</td>
      <td>fraction</td>
    </tr>
    <tr>
      <td>jetce</td>
      <td>ce</td>
      <td>jet</td>
      <td>jet</td>
      <td>cor</td>
      <td>struia</td>
      <td>dafka</td>
      <td>dafka</td>
      <td>jet</td>
    </tr>
    <tr>
      <td>kubli</td>
      <td>lifan</td>
      <td>kiub</td>
      <td>gan</td>
      <td>kub</td>
      <td>kubik</td>
      <td>kab</td>
      <td>- to be proposed -</td>
      <td>cube</td>
    </tr>
    <tr>
      <td>romge</td>
      <td>ge</td>
      <td>krom</td>
      <td>krom</td>
      <td>krom</td>
      <td>xrom</td>
      <td>krom</td>
      <td>kroma xroma</td>
      <td>chrome</td>
    </tr>
    <tr>
      <td>xanto</td>
      <td>cian</td>
      <td>elafnt</td>
      <td>xat</td>
      <td>elefant</td>
      <td>slon</td>
      <td>fil</td>
      <td>slona</td>
      <td>elephant</td>
    </tr>
    <tr>
      <td>bliku</td>
      <td>dakuai</td>
      <td>blak</td>
      <td>kund</td>
      <td>blok</td>
      <td>glib</td>
      <td>kurma</td>
      <td>blaka kunda bloka gliba kurma</td>
      <td>block</td>
    </tr>
    <tr>
      <td>critu</td>
      <td>cieu</td>
      <td>atam</td>
      <td>cart</td>
      <td>oton</td>
      <td>osin</td>
      <td>xarif</td>
      <td>carta</td>
      <td>autumn</td>
    </tr>
    <tr>
      <td>kamju</td>
      <td>ju</td>
      <td>kalam</td>
      <td>kamb</td>
      <td>kolumn</td>
      <td>kalon</td>
      <td>amud</td>
      <td>kamba</td>
      <td>column</td>
    </tr>
    <tr>
      <td>lante</td>
      <td>guanteu</td>
      <td>kan</td>
      <td>xib</td>
      <td>lat</td>
      <td>bank</td>
      <td>tanaka</td>
      <td>banka</td>
      <td>can</td>
    </tr>
    <tr>
      <td>risna</td>
      <td>cinzan</td>
      <td>kardiak</td>
      <td>xridai</td>
      <td>korason</td>
      <td>sierts</td>
      <td>kalb</td>
      <td>cinzana kalba</td>
      <td>heart</td>
    </tr>
    <tr>
      <td>xotli</td>
      <td>liuguan</td>
      <td>xotel</td>
      <td>xotal</td>
      <td>otel</td>
      <td>gastinis</td>
      <td>otel</td>
      <td>- to be proposed -</td>
      <td>hotel</td>
    </tr>
    <tr>
      <td>rutni</td>
      <td>rengun</td>
      <td>artaficl</td>
      <td>kritrim</td>
      <td>artifisial</td>
      <td>iskustvin</td>
      <td>istinai</td>
      <td>renguna</td>
      <td>artifact</td>
    </tr>
    <tr>
      <td>gadri</td>
      <td>guanci</td>
      <td>artikl</td>
      <td>upapad</td>
      <td>artikul</td>
      <td>artikl</td>
      <td>adax</td>
      <td>- to be proposed -</td>
      <td>article</td>
    </tr>
    <tr>
      <td>sruma</td>
      <td>ru</td>
      <td>asum</td>
      <td>man</td>
      <td>asum</td>
      <td>dapusk</td>
      <td>fardi</td>
      <td>fardi</td>
      <td>assume</td>
    </tr>
    <tr>
      <td>frumu</td>
      <td>jeumeiteu</td>
      <td>fraun</td>
      <td>brubag</td>
      <td>fruns</td>
      <td>xmur</td>
      <td>jaxuma</td>
      <td>brubaga</td>
      <td>frown</td>
    </tr>
    <tr>
      <td>burna</td>
      <td>ueinan</td>
      <td>imberast</td>
      <td>gabra</td>
      <td>turb</td>
      <td>smuc</td>
      <td>muxraj</td>
      <td>gabra turba smuca</td>
      <td>embarrassed</td>
    </tr>
    <tr>
      <td>cimde</td>
      <td>ciduen</td>
      <td>dimencn</td>
      <td>viman</td>
      <td>dimension</td>
      <td>izmirieni</td>
      <td>bud</td>
      <td>- to be proposed -</td>
      <td>dimension</td>
    </tr>
    <tr>
      <td>cmaci</td>
      <td>cuciue</td>
      <td>matamatiks</td>
      <td>ganit</td>
      <td>matematik</td>
      <td>matimatik</td>
      <td>riada</td>
      <td>- to be proposed -</td>
      <td>mathematics</td>
    </tr>
    <tr>
      <td>datka</td>
      <td>iazi</td>
      <td>dak</td>
      <td>batak</td>
      <td>pat</td>
      <td>utk</td>
      <td>bata</td>
      <td>utka</td>
      <td>duck</td>
    </tr>
    <tr>
      <td>dirgo</td>
      <td>di</td>
      <td>drop</td>
      <td>bund</td>
      <td>got</td>
      <td>kapli</td>
      <td>katar</td>
      <td>dropa bunda kapli</td>
      <td>drop</td>
    </tr>
    <tr>
      <td>kruji</td>
      <td>ruji</td>
      <td>krim</td>
      <td>krim</td>
      <td>krem</td>
      <td>slifk</td>
      <td>krem</td>
      <td>krima krema</td>
      <td>cream</td>
    </tr>
    <tr>
      <td>tenfa</td>
      <td>cenfan</td>
      <td>eksponencl</td>
      <td>gatank</td>
      <td>eksponent</td>
      <td>stiepin</td>
      <td>kua</td>
      <td>cenfana</td>
      <td>exponential</td>
    </tr>
    <tr>
      <td>xanka</td>
      <td>xuan</td>
      <td>ankcas</td>
      <td>vikal</td>
      <td>nervios</td>
      <td>balnav</td>
      <td>kalik</td>
      <td>balnava</td>
      <td>nervous</td>
    </tr>
    <tr>
      <td>draci</td>
      <td>ci</td>
      <td>drama</td>
      <td>natak</td>
      <td>dram</td>
      <td>dram</td>
      <td>drami</td>
      <td>drama drami</td>
      <td>drama</td>
    </tr>
    <tr>
      <td>finpe</td>
      <td>iu</td>
      <td>fic</td>
      <td>min</td>
      <td>pes</td>
      <td>rib</td>
      <td>samak</td>
      <td>- to be proposed -</td>
      <td>fish</td>
    </tr>
    <tr>
      <td>smadi</td>
      <td>sai</td>
      <td>srmaiz</td>
      <td>anuman</td>
      <td>adivin</td>
      <td>gad</td>
      <td>xadas</td>
      <td>- to be proposed -</td>
      <td>guess</td>
    </tr>
    <tr>
      <td>fonmo</td>
      <td>mo</td>
      <td>fom</td>
      <td>fen</td>
      <td>espum</td>
      <td>pien</td>
      <td>raga</td>
      <td>- to be proposed -</td>
      <td>foam</td>
    </tr>
    <tr>
      <td>lanci</td>
      <td>ci</td>
      <td>banr</td>
      <td>jand</td>
      <td>bander</td>
      <td>flak</td>
      <td>alam</td>
      <td>banra janda bandera flaka</td>
      <td>flag</td>
    </tr>
    <tr>
      <td>rigni</td>
      <td>ian</td>
      <td>ripagnnt</td>
      <td>grin</td>
      <td>repugnansi</td>
      <td>atvracieni</td>
      <td>karixa</td>
      <td>grina</td>
      <td>disgusting</td>
    </tr>
    <tr>
      <td>sfubu</td>
      <td>fucun</td>
      <td>suup</td>
      <td>xubak</td>
      <td>buse</td>
      <td>bros</td>
      <td>gasa</td>
      <td>brosa</td>
      <td>dive</td>
    </tr>
    <tr>
      <td>fraxu</td>
      <td>rau</td>
      <td>frgiv</td>
      <td>max</td>
      <td>perdon</td>
      <td>prac</td>
      <td>safax</td>
      <td>perdona praca</td>
      <td>forgive</td>
    </tr>
    <tr>
      <td>pinka</td>
      <td>pin</td>
      <td>kament</td>
      <td>tika</td>
      <td>glos</td>
      <td>primicani</td>
      <td>talika</td>
      <td>glosa</td>
      <td>comment</td>
    </tr>
    <tr>
      <td>misno</td>
      <td>min</td>
      <td>feimas</td>
      <td>nami</td>
      <td>famos</td>
      <td>znaminit</td>
      <td>caxir</td>
      <td>- to be proposed -</td>
      <td>famous</td>
    </tr>
    <tr>
      <td>fanza</td>
      <td>fan</td>
      <td>anoi</td>
      <td>tang</td>
      <td>enox</td>
      <td>razdraj</td>
      <td>azaj</td>
      <td>tanga</td>
      <td>annoy</td>
    </tr>
    <tr>
      <td>lacri</td>
      <td>lai</td>
      <td>rilai</td>
      <td>acrit</td>
      <td>depend</td>
      <td>palag</td>
      <td>auala</td>
      <td>- to be proposed -</td>
      <td>rely</td>
    </tr>
    <tr>
      <td>dimna</td>
      <td>iun</td>
      <td>dum</td>
      <td>kismat</td>
      <td>destin</td>
      <td>ucast</td>
      <td>kisma</td>
      <td>kisma</td>
      <td>fate</td>
    </tr>
    <tr>
      <td>basna</td>
      <td>ciandau</td>
      <td>aksent</td>
      <td>bal</td>
      <td>asent</td>
      <td>aksintirav</td>
      <td>nabara</td>
      <td>- to be proposed -</td>
      <td>emphasize</td>
    </tr>
    <tr>
      <td>bradi</td>
      <td>di</td>
      <td>adverseri</td>
      <td>beri</td>
      <td>adversari</td>
      <td>vrak</td>
      <td>adu</td>
      <td>vraka</td>
      <td>enemy</td>
    </tr>
    <tr>
      <td>dapma</td>
      <td>ma</td>
      <td>dam</td>
      <td>cap</td>
      <td>maldes</td>
      <td>praklin</td>
      <td>catam</td>
      <td>maldesa</td>
      <td>curse</td>
    </tr>
    <tr>
      <td>rinci</td>
      <td>paicie</td>
      <td>drein</td>
      <td>mori</td>
      <td>eskur</td>
      <td>drinirav</td>
      <td>nazaf</td>
      <td>- to be proposed -</td>
      <td>drain</td>
    </tr>
    <tr>
      <td>dukse</td>
      <td>due</td>
      <td>ekses</td>
      <td>adikt</td>
      <td>ekses</td>
      <td>izbitak</td>
      <td>katra</td>
      <td>eksesa katra</td>
      <td>excess</td>
    </tr>
    <tr>
      <td>daplu</td>
      <td>dau</td>
      <td>ail</td>
      <td>tapu</td>
      <td>isl</td>
      <td>ostrav</td>
      <td>jazira</td>
      <td>isla</td>
      <td>island</td>
    </tr>
    <tr>
      <td>jalra</td>
      <td>janlan</td>
      <td>kakroc</td>
      <td>tilcat</td>
      <td>kukarac</td>
      <td>tarakan</td>
      <td>sursur</td>
      <td>janlana tilcata sursura</td>
      <td>cockroach</td>
    </tr>
    <tr>
      <td>jilra</td>
      <td>ji</td>
      <td>jelas</td>
      <td>ircan</td>
      <td>envidi</td>
      <td>rivniv</td>
      <td>gaiur</td>
      <td>ircana envidi rivniva</td>
      <td>jealous</td>
    </tr>
    <tr>
      <td>mifra</td>
      <td>mima</td>
      <td>saifr</td>
      <td>sanketsangra</td>
      <td>sifr</td>
      <td>cifr</td>
      <td>cifra</td>
      <td>sifra cifra</td>
      <td>code</td>
    </tr>
    <tr>
      <td>senta</td>
      <td>sen</td>
      <td>stratm</td>
      <td>star</td>
      <td>estrat</td>
      <td>slo</td>
      <td>tabaka</td>
      <td>stratma stara</td>
      <td>layer</td>
    </tr>
    <tr>
      <td>cinba</td>
      <td>cin</td>
      <td>bas</td>
      <td>cumban</td>
      <td>bes</td>
      <td>silav</td>
      <td>kabal</td>
      <td>cumbana</td>
      <td>kiss</td>
    </tr>
    <tr>
      <td>lerci</td>
      <td>ci</td>
      <td>leit</td>
      <td>der</td>
      <td>tard</td>
      <td>pozn</td>
      <td>auaxir</td>
      <td>tarda pozna</td>
      <td>late</td>
    </tr>
    <tr>
      <td>nivji</td>
      <td>ji</td>
      <td>nit</td>
      <td>bun</td>
      <td>tex</td>
      <td>viiz</td>
      <td>xakt</td>
      <td>xakta</td>
      <td>knit</td>
    </tr>
    <tr>
      <td>runme</td>
      <td>run</td>
      <td>melt</td>
      <td>pigala</td>
      <td>fund</td>
      <td>taiit</td>
      <td>saxar</td>
      <td>melta funda</td>
      <td>melt</td>
    </tr>
    <tr>
      <td>smuni</td>
      <td>uei</td>
      <td>minin</td>
      <td>sucit</td>
      <td>signifik</td>
      <td>znacieni</td>
      <td>manan</td>
      <td>- to be proposed -</td>
      <td>meaning</td>
    </tr>
    <tr>
      <td>tikpa</td>
      <td>ti</td>
      <td>kik</td>
      <td>tukra</td>
      <td>pate</td>
      <td>pin</td>
      <td>rafas</td>
      <td>tukra</td>
      <td>kick</td>
    </tr>
    <tr>
      <td>jijnu</td>
      <td>jijue</td>
      <td>intuit</td>
      <td>saxjajan</td>
      <td>intu</td>
      <td>intuisii</td>
      <td>basira</td>
      <td>intu</td>
      <td>intuit</td>
    </tr>
    <tr>
      <td>juxre</td>
      <td>jue</td>
      <td>akuard</td>
      <td>puxar</td>
      <td>torp</td>
      <td>nilofk</td>
      <td>axrak</td>
      <td>torpa</td>
      <td>clumsy</td>
    </tr>
    <tr>
      <td>cpare</td>
      <td>pa</td>
      <td>klaim</td>
      <td>car</td>
      <td>trep</td>
      <td>liest</td>
      <td>saida</td>
      <td>trepa</td>
      <td>climb</td>
    </tr>
    <tr>
      <td>dugri</td>
      <td>dueicu</td>
      <td>lagaritm</td>
      <td>laguganak</td>
      <td>logaritmik</td>
      <td>lagarifm</td>
      <td>logaritm</td>
      <td>- to be proposed -</td>
      <td>logarithm</td>
    </tr>
    <tr>
      <td>kliti</td>
      <td>nitu</td>
      <td>klei</td>
      <td>miti</td>
      <td>arsii</td>
      <td>glin</td>
      <td>tin</td>
      <td>glina</td>
      <td>clay</td>
    </tr>
    <tr>
      <td>krili</td>
      <td>cueijin</td>
      <td>kristl</td>
      <td>kristal</td>
      <td>kristal</td>
      <td>kristal</td>
      <td>bilaur</td>
      <td>- to be proposed -</td>
      <td>crystal</td>
    </tr>
    <tr>
      <td>lazni</td>
      <td>lan</td>
      <td>leizi</td>
      <td>kaxil</td>
      <td>peres</td>
      <td>liniv</td>
      <td>kaslan</td>
      <td>- to be proposed -</td>
      <td>lazy</td>
    </tr>
    <tr>
      <td>livga</td>
      <td>gan</td>
      <td>livr</td>
      <td>jigar</td>
      <td>igad</td>
      <td>piecin</td>
      <td>kabid</td>
      <td>livra</td>
      <td>liver</td>
    </tr>
    <tr>
      <td>lunsa</td>
      <td>lu</td>
      <td>kndens</td>
      <td>sanganit</td>
      <td>kondens</td>
      <td>kandinsirav</td>
      <td>kataf</td>
      <td>- to be proposed -</td>
      <td>condense</td>
    </tr>
    <tr>
      <td>saclu</td>
      <td>ciaucu</td>
      <td>desaml</td>
      <td>dacmalav</td>
      <td>desimal</td>
      <td>disiiticn</td>
      <td>acri</td>
      <td>acri</td>
      <td>decimal</td>
    </tr>
    <tr>
      <td>steba</td>
      <td>suebai</td>
      <td>frastreicn</td>
      <td>acabang</td>
      <td>frustrasion</td>
      <td>frustasii</td>
      <td>tabat</td>
      <td>- to be proposed -</td>
      <td>frustration</td>
    </tr>
    <tr>
      <td>tarbi</td>
      <td>tai</td>
      <td>fitas</td>
      <td>garb</td>
      <td>fet</td>
      <td>zarodic</td>
      <td>janin</td>
      <td>garba</td>
      <td>embryo</td>
    </tr>
    <tr>
      <td>xasli</td>
      <td>liu</td>
      <td>as</td>
      <td>gadxa</td>
      <td>asn</td>
      <td>asiol</td>
      <td>ximur</td>
      <td>asna</td>
      <td>donkey</td>
    </tr>
    <tr>
      <td>damri</td>
      <td>daji</td>
      <td>dram</td>
      <td>mridan</td>
      <td>tambor</td>
      <td>udar</td>
      <td>tabla</td>
      <td>drama mridana tambora tabla</td>
      <td>drum</td>
    </tr>
    <tr>
      <td>kavbu</td>
      <td>bu</td>
      <td>kac</td>
      <td>pakar</td>
      <td>kaptur</td>
      <td>lav</td>
      <td>asara</td>
      <td>kaptura</td>
      <td>capture</td>
    </tr>
    <tr>
      <td>jersi</td>
      <td>juei</td>
      <td>ceis</td>
      <td>sikar</td>
      <td>perseg</td>
      <td>gna</td>
      <td>laxak</td>
      <td>persega</td>
      <td>chase</td>
    </tr>
    <tr>
      <td>konju</td>
      <td>juei</td>
      <td>kon</td>
      <td>canku</td>
      <td>kon</td>
      <td>konus</td>
      <td>maxrut</td>
      <td>canku</td>
      <td>cone</td>
    </tr>
    <tr>
      <td>rafsi</td>
      <td>sijuei</td>
      <td>afiks</td>
      <td>priai</td>
      <td>afix</td>
      <td>castis</td>
      <td>ilxak</td>
      <td>ilxaka</td>
      <td>affix</td>
    </tr>
    <tr>
      <td>tinbe</td>
      <td>tin</td>
      <td>obei</td>
      <td>paln</td>
      <td>obedes</td>
      <td>patcin</td>
      <td>samia</td>
      <td>palna</td>
      <td>obey</td>
    </tr>
    <tr>
      <td>cidro</td>
      <td>cin</td>
      <td>xaidrojn</td>
      <td>xaidrojan</td>
      <td>idroxen</td>
      <td>vadarod</td>
      <td>xaidrojin</td>
      <td>- to be proposed -</td>
      <td>hydrogen</td>
    </tr>
    <tr>
      <td>dunja</td>
      <td>dun</td>
      <td>friz</td>
      <td>jama</td>
      <td>el</td>
      <td>miorzn</td>
      <td>jamad</td>
      <td>friza</td>
      <td>freeze</td>
    </tr>
    <tr>
      <td>janli</td>
      <td>juan</td>
      <td>kalaid</td>
      <td>sangat</td>
      <td>top</td>
      <td>stalkiv</td>
      <td>sadam</td>
      <td>sangata</td>
      <td>collide</td>
    </tr>
    <tr>
      <td>mucti</td>
      <td>uucin</td>
      <td>imatiril</td>
      <td>amurt</td>
      <td>inmaterial</td>
      <td>niviciestvin</td>
      <td>lamadi</td>
      <td>- to be proposed -</td>
      <td>immaterial</td>
    </tr>
    <tr>
      <td>sitna</td>
      <td>iin</td>
      <td>sait</td>
      <td>ulek</td>
      <td>sit</td>
      <td>sil</td>
      <td>istacxad</td>
      <td>- to be proposed -</td>
      <td>cite</td>
    </tr>
    <tr>
      <td>matli</td>
      <td>ma</td>
      <td>linen</td>
      <td>calti</td>
      <td>lin</td>
      <td>lion</td>
      <td>katan</td>
      <td>calti</td>
      <td>linen</td>
    </tr>
    <tr>
      <td>cfipu</td>
      <td>ciau</td>
      <td>knfiuz</td>
      <td>vikcipt</td>
      <td>konfund</td>
      <td>put</td>
      <td>adxal</td>
      <td>- to be proposed -</td>
      <td>confusing</td>
    </tr>
    <tr>
      <td>mapti</td>
      <td>pei</td>
      <td>mac</td>
      <td>tik</td>
      <td>apt</td>
      <td>saatvietstv</td>
      <td>munasib</td>
      <td>apta</td>
      <td>fit</td>
    </tr>
    <tr>
      <td>flani</td>
      <td>guan</td>
      <td>faif</td>
      <td>vanci</td>
      <td>flaut</td>
      <td>flieit</td>
      <td>flut</td>
      <td>vanci fluta</td>
      <td>flute</td>
    </tr>
    <tr>
      <td>zungi</td>
      <td>zuei</td>
      <td>gilt</td>
      <td>doc</td>
      <td>kompunx</td>
      <td>vina</td>
      <td>mudnib</td>
      <td>gilta mudniba</td>
      <td>guilt</td>
    </tr>
    <tr>
      <td>kanxe</td>
      <td>xe</td>
      <td>and</td>
      <td>ka</td>
      <td>konjunsion</td>
      <td>sacitan</td>
      <td>iktiran</td>
      <td>anda</td>
      <td>conjunction</td>
    </tr>
    <tr>
      <td>xanri</td>
      <td>xuan</td>
      <td>anril</td>
      <td>xaiali</td>
      <td>imaxinari</td>
      <td>vaabrajaim</td>
      <td>xaiali</td>
      <td>anrila</td>
      <td>imaginary</td>
    </tr>
    <tr>
      <td>cumla</td>
      <td>cu</td>
      <td>xiumilati</td>
      <td>namra</td>
      <td>umild</td>
      <td>smirien</td>
      <td>madala</td>
      <td>namra</td>
      <td>humble</td>
    </tr>
    <tr>
      <td>darsi</td>
      <td>xauiisi</td>
      <td>adasati</td>
      <td>saxsi</td>
      <td>audas</td>
      <td>diersk</td>
      <td>jari</td>
      <td>saxsi</td>
      <td>audacity</td>
    </tr>
    <tr>
      <td>civla</td>
      <td>ci</td>
      <td>laus</td>
      <td>cilar</td>
      <td>piox</td>
      <td>voc</td>
      <td>kamla</td>
      <td>kamla</td>
      <td>louse</td>
    </tr>
    <tr>
      <td>clupa</td>
      <td>cuan</td>
      <td>lup</td>
      <td>pac</td>
      <td>las</td>
      <td>lieli</td>
      <td>incuta</td>
      <td>incuta</td>
      <td>loop</td>
    </tr>
    <tr>
      <td>fepri</td>
      <td>fei</td>
      <td>palmneri</td>
      <td>pepar</td>
      <td>pulmon</td>
      <td>lioxk</td>
      <td>ria</td>
      <td>pulmona</td>
      <td>lung</td>
    </tr>
    <tr>
      <td>guzme</td>
      <td>gua</td>
      <td>meln</td>
      <td>buz</td>
      <td>melon</td>
      <td>dini</td>
      <td>camam</td>
      <td>melna</td>
      <td>melon</td>
    </tr>
    <tr>
      <td>lunra</td>
      <td>iue</td>
      <td>lunr</td>
      <td>candra</td>
      <td>lun</td>
      <td>lun</td>
      <td>kamari</td>
      <td>lunra</td>
      <td>lunar</td>
    </tr>
    <tr>
      <td>minli</td>
      <td>iinli</td>
      <td>mail</td>
      <td>mil</td>
      <td>mii</td>
      <td>mili</td>
      <td>mil</td>
      <td>- to be proposed -</td>
      <td>mile</td>
    </tr>
    <tr>
      <td>mentu</td>
      <td>fen</td>
      <td>minat</td>
      <td>minat</td>
      <td>minut</td>
      <td>minut</td>
      <td>dakik</td>
      <td>- to be proposed -</td>
      <td>minute</td>
    </tr>
    <tr>
      <td>nikle</td>
      <td>nie</td>
      <td>nikl</td>
      <td>nikal</td>
      <td>nikel</td>
      <td>nikil</td>
      <td>nikal</td>
      <td>nikla</td>
      <td>nickel</td>
    </tr>
    <tr>
      <td>macnu</td>
      <td>ceugun</td>
      <td>maniul</td>
      <td>xastacalit</td>
      <td>manual</td>
      <td>rucn</td>
      <td>iadaui</td>
      <td>rucna</td>
      <td>manual</td>
    </tr>
    <tr>
      <td>matci</td>
      <td>ci</td>
      <td>mat</td>
      <td>catai</td>
      <td>almoadii</td>
      <td>kovrik</td>
      <td>xasir</td>
      <td>- to be proposed -</td>
      <td>mat</td>
    </tr>
    <tr>
      <td>sluni</td>
      <td>sun</td>
      <td>anian</td>
      <td>palanda</td>
      <td>seboi</td>
      <td>luk</td>
      <td>basal</td>
      <td>- to be proposed -</td>
      <td>onion</td>
    </tr>
    <tr>
      <td>zarci</td>
      <td>ci</td>
      <td>bazar</td>
      <td>bazar</td>
      <td>bazar</td>
      <td>bazar</td>
      <td>suk</td>
      <td>- to be proposed -</td>
      <td>market</td>
    </tr>
    <tr>
      <td>cindu</td>
      <td>cian</td>
      <td>ok</td>
      <td>banzu</td>
      <td>robl</td>
      <td>dub</td>
      <td>sindian</td>
      <td>banzu robla</td>
      <td>oak</td>
    </tr>
    <tr>
      <td>panra</td>
      <td>pincin</td>
      <td>paralel</td>
      <td>semantar</td>
      <td>paralel</td>
      <td>paraliel</td>
      <td>murauaz</td>
      <td>pincina</td>
      <td>parallel</td>
    </tr>
    <tr>
      <td>trano</td>
      <td>dan</td>
      <td>naitro</td>
      <td>cora</td>
      <td>nitr</td>
      <td>azot</td>
      <td>nitrojin</td>
      <td>nitra</td>
      <td>nitrogen</td>
    </tr>
    <tr>
      <td>xalni</td>
      <td>kunxuan</td>
      <td>panik</td>
      <td>taxalk</td>
      <td>panik</td>
      <td>panik</td>
      <td>vala</td>
      <td>- to be proposed -</td>
      <td>panic</td>
    </tr>
    <tr>
      <td>briju</td>
      <td>ju</td>
      <td>biuro</td>
      <td>karialai</td>
      <td>ofisin</td>
      <td>biuro</td>
      <td>dair</td>
      <td>- to be proposed -</td>
      <td>office</td>
    </tr>
    <tr>
      <td>clika</td>
      <td>cian</td>
      <td>laikn</td>
      <td>kai</td>
      <td>liken</td>
      <td>lica</td>
      <td>ucna</td>
      <td>ucna</td>
      <td>mossy</td>
    </tr>
    <tr>
      <td>muzga</td>
      <td>bouuguan</td>
      <td>miuziam</td>
      <td>miuziam</td>
      <td>muse</td>
      <td>muzie</td>
      <td>matxaf</td>
      <td>matxafa</td>
      <td>museum</td>
    </tr>
    <tr>
      <td>zgana</td>
      <td>guan</td>
      <td>abzerv</td>
      <td>mana</td>
      <td>opserv</td>
      <td>nabliud</td>
      <td>laxat</td>
      <td>- to be proposed -</td>
      <td>observe</td>
    </tr>
    <tr>
      <td>funca</td>
      <td>fu</td>
      <td>fortiun</td>
      <td>niati</td>
      <td>fortun</td>
      <td>scast</td>
      <td>xat</td>
      <td>fortuna</td>
      <td>luck</td>
    </tr>
    <tr>
      <td>papri</td>
      <td>mianr</td>
      <td>peij</td>
      <td>patr</td>
      <td>paxin</td>
      <td>stranis</td>
      <td>safxa</td>
      <td>patra safxa</td>
      <td>page</td>
    </tr>
    <tr>
      <td>spali</td>
      <td>salian</td>
      <td>palic</td>
      <td>op</td>
      <td>pul</td>
      <td>palirav</td>
      <td>sakal</td>
      <td>- to be proposed -</td>
      <td>polish</td>
    </tr>
    <tr>
      <td>jgira</td>
      <td>jiau</td>
      <td>praid</td>
      <td>gaurav</td>
      <td>enorguies</td>
      <td>gordast</td>
      <td>naxa</td>
      <td>- to be proposed -</td>
      <td>pride</td>
    </tr>
    <tr>
      <td>tadji</td>
      <td>ji</td>
      <td>metad</td>
      <td>tarik</td>
      <td>metod</td>
      <td>mietad</td>
      <td>tarik</td>
      <td>- to be proposed -</td>
      <td>method</td>
    </tr>
    <tr>
      <td>gismu</td>
      <td>geniuan</td>
      <td>beis</td>
      <td>mul</td>
      <td>rais</td>
      <td>korin</td>
      <td>basit</td>
      <td>- to be proposed -</td>
      <td>root word</td>
    </tr>
    <tr>
      <td>jaspu</td>
      <td>xujau</td>
      <td>pasport</td>
      <td>pasport</td>
      <td>pasaport</td>
      <td>paspart</td>
      <td>basburt</td>
      <td>- to be proposed -</td>
      <td>passport</td>
    </tr>
    <tr>
      <td>perli</td>
      <td>li</td>
      <td>per</td>
      <td>nacpati</td>
      <td>per</td>
      <td>gruc</td>
      <td>injas</td>
      <td>gruca injasa</td>
      <td>pear</td>
    </tr>
    <tr>
      <td>rirni</td>
      <td>ianiu</td>
      <td>rir</td>
      <td>janani</td>
      <td>kri</td>
      <td>raditil</td>
      <td>ualidan</td>
      <td>- to be proposed -</td>
      <td>parent</td>
    </tr>
    <tr>
      <td>setca</td>
      <td>ca</td>
      <td>insrt</td>
      <td>guser</td>
      <td>insert</td>
      <td>fstavl</td>
      <td>aulaj</td>
      <td>- to be proposed -</td>
      <td>insert</td>
    </tr>
    <tr>
      <td>savru</td>
      <td>sau</td>
      <td>klamr</td>
      <td>rav</td>
      <td>ruid</td>
      <td>cum</td>
      <td>saxab</td>
      <td>- to be proposed -</td>
      <td>noise</td>
    </tr>
    <tr>
      <td>mledi</td>
      <td>mei</td>
      <td>mold</td>
      <td>papundi</td>
      <td>ong</td>
      <td>pliesin</td>
      <td>futr</td>
      <td>molda onga futra</td>
      <td>mold</td>
    </tr>
    <tr>
      <td>bilga</td>
      <td>bi</td>
      <td>ablaij</td>
      <td>abadia</td>
      <td>oblig</td>
      <td>dolg</td>
      <td>alzam</td>
      <td>dolga alzama</td>
      <td>obliged</td>
    </tr>
    <tr>
      <td>vitci</td>
      <td>ieuci</td>
      <td>intrmitnt</td>
      <td>viral</td>
      <td>intermitent</td>
      <td>pririvist</td>
      <td>itifaf</td>
      <td>- to be proposed -</td>
      <td>irregular</td>
    </tr>
    <tr>
      <td>racli</td>
      <td>xeli</td>
      <td>racnl</td>
      <td>svastacit</td>
      <td>rasional</td>
      <td>rasudacn</td>
      <td>racad</td>
      <td>- to be proposed -</td>
      <td>sane</td>
    </tr>
    <tr>
      <td>tisna</td>
      <td>tian</td>
      <td>staf</td>
      <td>tus</td>
      <td>ien</td>
      <td>nabiv</td>
      <td>xaca</td>
      <td>stafa</td>
      <td>fill</td>
    </tr>
    <tr>
      <td>sakci</td>
      <td>ci</td>
      <td>sak</td>
      <td>sok</td>
      <td>suksion</td>
      <td>sas</td>
      <td>masas</td>
      <td>- to be proposed -</td>
      <td>suck</td>
    </tr>
    <tr>
      <td>xarnu</td>
      <td>uangu</td>
      <td>stabrn</td>
      <td>xatil</td>
      <td>testarud</td>
      <td>uporn</td>
      <td>anid</td>
      <td>- to be proposed -</td>
      <td>stubborn</td>
    </tr>
    <tr>
      <td>nutli</td>
      <td>junli</td>
      <td>nutrl</td>
      <td>tatac</td>
      <td>neutral</td>
      <td>niitraln</td>
      <td>xiadi</td>
      <td>junli</td>
      <td>neutral</td>
    </tr>
    <tr>
      <td>tcati</td>
      <td>ca</td>
      <td>ti</td>
      <td>cai</td>
      <td>te</td>
      <td>cai</td>
      <td>cai</td>
      <td>- to be proposed -</td>
      <td>tea</td>
    </tr>
    <tr>
      <td>xasne</td>
      <td>xan</td>
      <td>suet</td>
      <td>pasin</td>
      <td>sud</td>
      <td>pot</td>
      <td>arik</td>
      <td>- to be proposed -</td>
      <td>sweat</td>
    </tr>
    <tr>
      <td>zasni</td>
      <td>zan</td>
      <td>tranzint</td>
      <td>astai</td>
      <td>pasaxer</td>
      <td>vriemin</td>
      <td>muakat</td>
      <td>- to be proposed -</td>
      <td>temporary</td>
    </tr>
    <tr>
      <td>tarla</td>
      <td>ta</td>
      <td>tar</td>
      <td>tarkol</td>
      <td>brea</td>
      <td>smala</td>
      <td>katran</td>
      <td>tarkola smala</td>
      <td>tar</td>
    </tr>
    <tr>
      <td>vrici</td>
      <td>ci</td>
      <td>varias</td>
      <td>vivid</td>
      <td>varios</td>
      <td>razlicn</td>
      <td>cata</td>
      <td>- to be proposed -</td>
      <td>miscellaneous</td>
    </tr>
    <tr>
      <td>ckasu</td>
      <td>cau</td>
      <td>skaf</td>
      <td>upxas</td>
      <td>eskarnes</td>
      <td>nasmix</td>
      <td>xaza</td>
      <td>skafa upxasa</td>
      <td>ridicule</td>
    </tr>
    <tr>
      <td>galxe</td>
      <td>xeu</td>
      <td>galat</td>
      <td>gal</td>
      <td>gasnat</td>
      <td>glotk</td>
      <td>xalk</td>
      <td>xalka</td>
      <td>throat</td>
    </tr>
    <tr>
      <td>jursa</td>
      <td>ju</td>
      <td>savir</td>
      <td>sakt</td>
      <td>rigures</td>
      <td>surov</td>
      <td>sarim</td>
      <td>sakta</td>
      <td>severe</td>
    </tr>
    <tr>
      <td>tapla</td>
      <td>uapian</td>
      <td>tail</td>
      <td>tapua</td>
      <td>asulex</td>
      <td>plitk</td>
      <td>balat</td>
      <td>- to be proposed -</td>
      <td>tile</td>
    </tr>
    <tr>
      <td>skapi</td>
      <td>pi</td>
      <td>skin</td>
      <td>kal</td>
      <td>piel</td>
      <td>ckup</td>
      <td>jild</td>
      <td>skina ckupa jilda</td>
      <td>pelt</td>
    </tr>
    <tr>
      <td>jarbu</td>
      <td>jiau</td>
      <td>sabrb</td>
      <td>upanagar</td>
      <td>arrabal</td>
      <td>prigared</td>
      <td>daxia</td>
      <td>- to be proposed -</td>
      <td>suburb</td>
    </tr>
    <tr>
      <td>sliri</td>
      <td>lieu</td>
      <td>salfr</td>
      <td>culvari</td>
      <td>sulfur</td>
      <td>sier</td>
      <td>kibrit</td>
      <td>culvari sulfura</td>
      <td>sulfur</td>
    </tr>
    <tr>
      <td>vimcu</td>
      <td>cu</td>
      <td>rimuv</td>
      <td>viavakaln</td>
      <td>kit</td>
      <td>vicit</td>
      <td>tarax</td>
      <td>- to be proposed -</td>
      <td>remove</td>
    </tr>
    <tr>
      <td>ckabu</td>
      <td>cianjiau</td>
      <td>rabr</td>
      <td>rabar</td>
      <td>kauc</td>
      <td>kaucuk</td>
      <td>kautcuk</td>
      <td>rabra</td>
      <td>rubber</td>
    </tr>
    <tr>
      <td>ctaru</td>
      <td>cau</td>
      <td>taid</td>
      <td>juar</td>
      <td>mare</td>
      <td>atliv</td>
      <td>mad</td>
      <td>atliva</td>
      <td>tide</td>
    </tr>
    <tr>
      <td>margu</td>
      <td>gun</td>
      <td>mrkiuri</td>
      <td>parad</td>
      <td>merkuri</td>
      <td>rtut</td>
      <td>zauk</td>
      <td>merkuri</td>
      <td>mercury</td>
    </tr>
    <tr>
      <td>panka</td>
      <td>iuan</td>
      <td>park</td>
      <td>upavan</td>
      <td>park</td>
      <td>park</td>
      <td>xadikalm</td>
      <td>parka</td>
      <td>park</td>
    </tr>
    <tr>
      <td>pinca</td>
      <td>niau</td>
      <td>pi</td>
      <td>pecab</td>
      <td>orin</td>
      <td>maca</td>
      <td>baul</td>
      <td>- to be proposed -</td>
      <td>urine</td>
    </tr>
    <tr>
      <td>pinji</td>
      <td>iinjin</td>
      <td>pinas</td>
      <td>ling</td>
      <td>pen</td>
      <td>xui</td>
      <td>ari</td>
      <td>linga</td>
      <td>penis</td>
    </tr>
    <tr>
      <td>tamca</td>
      <td>fancie</td>
      <td>tamato</td>
      <td>tamatar</td>
      <td>tomat</td>
      <td>tamat</td>
      <td>tamatim</td>
      <td>- to be proposed -</td>
      <td>tomato</td>
    </tr>
    <tr>
      <td>tamji</td>
      <td>muji</td>
      <td>tam</td>
      <td>anguta</td>
      <td>pulgar</td>
      <td>balcoipalis</td>
      <td>ibxam</td>
      <td>anguta pulgara</td>
      <td>thumb</td>
    </tr>
    <tr>
      <td>tance</td>
      <td>ce</td>
      <td>tan</td>
      <td>rasan</td>
      <td>lengu</td>
      <td>iizik</td>
      <td>lisan</td>
      <td>lengu</td>
      <td>tongue</td>
    </tr>
    <tr>
      <td>tanko</td>
      <td>ian</td>
      <td>tabako</td>
      <td>tambaku</td>
      <td>tabak</td>
      <td>tabak</td>
      <td>tabg</td>
      <td>tambaku tabga</td>
      <td>tobacco</td>
    </tr>
    <tr>
      <td>taske</td>
      <td>ke</td>
      <td>trst</td>
      <td>pias</td>
      <td>sed</td>
      <td>jajd</td>
      <td>atac</td>
      <td>jajda</td>
      <td>thirst</td>
    </tr>
    <tr>
      <td>tcika</td>
      <td>cike</td>
      <td>taim</td>
      <td>kal</td>
      <td>or</td>
      <td>vriemi</td>
      <td>uakat</td>
      <td>- to be proposed -</td>
      <td>time of day</td>
    </tr>
    <tr>
      <td>tinci</td>
      <td>ci</td>
      <td>tin</td>
      <td>tin</td>
      <td>estan</td>
      <td>olav</td>
      <td>tanak</td>
      <td>- to be proposed -</td>
      <td>tin</td>
    </tr>
    <tr>
      <td>tirxu</td>
      <td>xu</td>
      <td>taigr</td>
      <td>cer</td>
      <td>tigr</td>
      <td>tigr</td>
      <td>namir</td>
      <td>tigra</td>
      <td>tiger</td>
    </tr>
    <tr>
      <td>fanva</td>
      <td>fan</td>
      <td>tranzleit</td>
      <td>anuvad</td>
      <td>tradus</td>
      <td>pirivad</td>
      <td>tarjam</td>
      <td>tradusa tarjama</td>
      <td>translate</td>
    </tr>
    <tr>
      <td>tujli</td>
      <td>iindau</td>
      <td>vajaina</td>
      <td>ioni</td>
      <td>vaxin</td>
      <td>blagalic</td>
      <td>maxbil</td>
      <td>- to be proposed -</td>
      <td>tulip</td>
    </tr>
    <tr>
      <td>vidni</td>
      <td>iincian</td>
      <td>vidio</td>
      <td>telivizan</td>
      <td>video</td>
      <td>video</td>
      <td>cacatuard</td>
      <td>- to be proposed -</td>
      <td>video</td>
    </tr>
    <tr>
      <td>vidru</td>
      <td>bindu</td>
      <td>vairus</td>
      <td>vairus</td>
      <td>virus</td>
      <td>virus</td>
      <td>vairus</td>
      <td>bindu</td>
      <td>virus</td>
    </tr>
    <tr>
      <td>xruki</td>
      <td>xueji</td>
      <td>trki</td>
      <td>piru</td>
      <td>pav</td>
      <td>indiuk</td>
      <td>dikrum</td>
      <td>- to be proposed -</td>
      <td>turkey</td>
    </tr>
    <tr>
      <td>jinku</td>
      <td>jiejun</td>
      <td>inakiuleicn</td>
      <td>tika</td>
      <td>inokulasion</td>
      <td>privifka</td>
      <td>lakax</td>
      <td>- to be proposed -</td>
      <td>vaccine</td>
    </tr>
    <tr>
      <td>stagi</td>
      <td>sai</td>
      <td>vejtabl</td>
      <td>sag</td>
      <td>ortalis</td>
      <td>ovac</td>
      <td>bakira</td>
      <td>- to be proposed -</td>
      <td>vegetable</td>
    </tr>
    <tr>
      <td>bacru</td>
      <td>facu</td>
      <td>atr</td>
      <td>bar</td>
      <td>profer</td>
      <td>praiznas</td>
      <td>nabas</td>
      <td>atra profera</td>
      <td>utter</td>
    </tr>
    <tr>
      <td>junta</td>
      <td>jun</td>
      <td>ueit</td>
      <td>taul</td>
      <td>pesantes</td>
      <td>vies</td>
      <td>tikal</td>
      <td>- to be proposed -</td>
      <td>weight</td>
    </tr>
    <tr>
      <td>lumci</td>
      <td>ci</td>
      <td>uac</td>
      <td>snan</td>
      <td>limpi</td>
      <td>umiv</td>
      <td>gasal</td>
      <td>snana limpi</td>
      <td>wash</td>
    </tr>
    <tr>
      <td>marde</td>
      <td>de</td>
      <td>marlz</td>
      <td>acarn</td>
      <td>moral</td>
      <td>maral</td>
      <td>xulki</td>
      <td>xulki</td>
      <td>morals</td>
    </tr>
    <tr>
      <td>vamtu</td>
      <td>tu</td>
      <td>vamit</td>
      <td>vaman</td>
      <td>vomit</td>
      <td>rvat</td>
      <td>ka</td>
      <td>- to be proposed -</td>
      <td>vomit</td>
    </tr>
    <tr>
      <td>viknu</td>
      <td>nun</td>
      <td>tik</td>
      <td>sian</td>
      <td>viskos</td>
      <td>viask</td>
      <td>katif</td>
      <td>- to be proposed -</td>
      <td>viscous</td>
    </tr>
    <tr>
      <td>cpana</td>
      <td>can</td>
      <td>an</td>
      <td>par</td>
      <td>en</td>
      <td>na</td>
      <td>inda</td>
      <td>inda</td>
      <td>upon</td>
    </tr>
    <tr>
      <td>tabra</td>
      <td>laba</td>
      <td>bras</td>
      <td>turia</td>
      <td>metales</td>
      <td>truba</td>
      <td>nafir</td>
      <td>brasa truba</td>
      <td>trumpet</td>
    </tr>
    <tr>
      <td>betri</td>
      <td>bei</td>
      <td>trajik</td>
      <td>maxavipad</td>
      <td>traxik</td>
      <td>tragicn</td>
      <td>trajidi</td>
      <td>trajika traxika trajidi</td>
      <td>tragedy</td>
    </tr>
    <tr>
      <td>navni</td>
      <td>nai</td>
      <td>nian</td>
      <td>nian</td>
      <td>neon</td>
      <td>nion</td>
      <td>niun</td>
      <td>- to be proposed -</td>
      <td>neon</td>
    </tr>
    <tr>
      <td>bunda</td>
      <td>ban</td>
      <td>paund</td>
      <td>paund</td>
      <td>libr</td>
      <td>funt</td>
      <td>baund</td>
      <td>libra funta</td>
      <td>pound</td>
    </tr>
    <tr>
      <td>jakne</td>
      <td>xuejian</td>
      <td>rakit</td>
      <td>raket</td>
      <td>koet</td>
      <td>rakiet</td>
      <td>sarux</td>
      <td>- to be proposed -</td>
      <td>rocket</td>
    </tr>
    <tr>
      <td>jivbu</td>
      <td>ji</td>
      <td>uiv</td>
      <td>buna</td>
      <td>tex</td>
      <td>plisti</td>
      <td>xaka</td>
      <td>- to be proposed -</td>
      <td>weave</td>
    </tr>
    <tr>
      <td>latna</td>
      <td>c06b</td>
      <td>pandi</td>
      <td>36.67</td>
      <td>punctuate</td>
      <td>o</td>
      <td>1.56</td>
      <td>pandi</td>
      <td>lotus</td>
    </tr>
    <tr>
      <td>ransu</td>
      <td>cintun</td>
      <td>branz</td>
      <td>kans</td>
      <td>brons</td>
      <td>bronz</td>
      <td>bronz</td>
      <td>cintuna kansa</td>
      <td>bronze</td>
    </tr>
    <tr>
      <td>respa</td>
      <td>pacun</td>
      <td>reptail</td>
      <td>sarisrip</td>
      <td>reptil</td>
      <td>prismikaiuci</td>
      <td>zauaxif</td>
      <td>reptila</td>
      <td>reptile</td>
    </tr>
    <tr>
      <td>rismi</td>
      <td>mi</td>
      <td>rais</td>
      <td>vrixi</td>
      <td>aros</td>
      <td>ris</td>
      <td>tuman</td>
      <td>vrixi</td>
      <td>rice</td>
    </tr>
    <tr>
      <td>salta</td>
      <td>sela</td>
      <td>salad</td>
      <td>salad</td>
      <td>ensalad</td>
      <td>salat</td>
      <td>salata</td>
      <td>- to be proposed -</td>
      <td>salad</td>
    </tr>
    <tr>
      <td>sunga</td>
      <td>suna</td>
      <td>garlik</td>
      <td>laxsun</td>
      <td>axo</td>
      <td>cisnak</td>
      <td>tum</td>
      <td>garlika laxsuna</td>
      <td>garlic</td>
    </tr>
    <tr>
      <td>zinki</td>
      <td>cin</td>
      <td>zink</td>
      <td>zink</td>
      <td>zink</td>
      <td>sink</td>
      <td>zink</td>
      <td>zinka sinka</td>
      <td>zinc</td>
    </tr>
    <tr>
      <td>curve</td>
      <td>cuen</td>
      <td>piur</td>
      <td>cudva</td>
      <td>pur</td>
      <td>cist</td>
      <td>saf</td>
      <td>cudva cista</td>
      <td>pure</td>
    </tr>
    <tr>
      <td>dirce</td>
      <td>ce</td>
      <td>reidieit</td>
      <td>vikirn</td>
      <td>radi</td>
      <td>izluc</td>
      <td>alak</td>
      <td>izluca</td>
      <td>radiate</td>
    </tr>
    <tr>
      <td>gutra</td>
      <td>zigun</td>
      <td>iutras</td>
      <td>garbacai</td>
      <td>uter</td>
      <td>matka</td>
      <td>raxim</td>
      <td>matka</td>
      <td>womb</td>
    </tr>
    <tr>
      <td>mebri</td>
      <td>mei</td>
      <td>brau</td>
      <td>bru</td>
      <td>frent</td>
      <td>lop</td>
      <td>jabin</td>
      <td>- to be proposed -</td>
      <td>brow</td>
    </tr>
    <tr>
      <td>nupre</td>
      <td>nue</td>
      <td>pramis</td>
      <td>pratinia</td>
      <td>promet</td>
      <td>abec</td>
      <td>ida</td>
      <td>pramisa prometa</td>
      <td>promise</td>
    </tr>
    <tr>
      <td>patlu</td>
      <td>malincu</td>
      <td>pateit</td>
      <td>alu</td>
      <td>pap</td>
      <td>kartofil</td>
      <td>batata</td>
      <td>- to be proposed -</td>
      <td>potato</td>
    </tr>
    <tr>
      <td>rivbi</td>
      <td>bi</td>
      <td>iveid</td>
      <td>parixar</td>
      <td>eskiv</td>
      <td>izbig</td>
      <td>janab</td>
      <td>- to be proposed -</td>
      <td>avoid</td>
    </tr>
    <tr>
      <td>xruti</td>
      <td>xuei</td>
      <td>ritrn</td>
      <td>lauta</td>
      <td>retorn</td>
      <td>vazvrac</td>
      <td>raja</td>
      <td>- to be proposed -</td>
      <td>return</td>
    </tr>
    <tr>
      <td>dilcu</td>
      <td>cu</td>
      <td>divijn</td>
      <td>labdi</td>
      <td>division</td>
      <td>del</td>
      <td>xarij</td>
      <td>labdi</td>
      <td>quotient</td>
    </tr>
    <tr>
      <td>vanbi</td>
      <td>xuanjin</td>
      <td>ambint</td>
      <td>vatavarn</td>
      <td>ambient</td>
      <td>akrujieni</td>
      <td>bia</td>
      <td>- to be proposed -</td>
      <td>environment</td>
    </tr>
    <tr>
      <td>cilce</td>
      <td>iecen</td>
      <td>uaild</td>
      <td>vaxaci</td>
      <td>silvestr</td>
      <td>dik</td>
      <td>xuci</td>
      <td>- to be proposed -</td>
      <td>wild</td>
    </tr>
    <tr>
      <td>surla</td>
      <td>sun</td>
      <td>rilaks</td>
      <td>dila</td>
      <td>relax</td>
      <td>aslabl</td>
      <td>arxa</td>
      <td>arxa</td>
      <td>relax</td>
    </tr>
    <tr>
      <td>curnu</td>
      <td>cun</td>
      <td>uurm</td>
      <td>kencua</td>
      <td>lombris</td>
      <td>cerv</td>
      <td>dud</td>
      <td>cerva</td>
      <td>worm</td>
    </tr>
    <tr>
      <td>snuji</td>
      <td>sanminji</td>
      <td>sanuic</td>
      <td>senduic</td>
      <td>sanduic</td>
      <td>butirbrot</td>
      <td>sanduij</td>
      <td>- to be proposed -</td>
      <td>sandwich</td>
    </tr>
    <tr>
      <td>lafti</td>
      <td>ti</td>
      <td>lift</td>
      <td>unati</td>
      <td>levant</td>
      <td>padnim</td>
      <td>rafa</td>
      <td>lifta padnima</td>
      <td>lift</td>
    </tr>
    <tr>
      <td>venfu</td>
      <td>fu</td>
      <td>avenj</td>
      <td>pratikar</td>
      <td>veng</td>
      <td>mst</td>
      <td>nakim</td>
      <td>venga</td>
      <td>revenge</td>
    </tr>
    <tr>
      <td>dembi</td>
      <td>deu</td>
      <td>bin</td>
      <td>sem</td>
      <td>abicol</td>
      <td>bob</td>
      <td>lubia</td>
      <td>- to be proposed -</td>
      <td>bean</td>
    </tr>
    <tr>
      <td>vipsi</td>
      <td>si</td>
      <td>vais</td>
      <td>up</td>
      <td>vis</td>
      <td>visi</td>
      <td>naib</td>
      <td>- to be proposed -</td>
      <td>deputy</td>
    </tr>
    <tr>
      <td>xagri</td>
      <td>xuang</td>
      <td>rid</td>
      <td>nafiri</td>
      <td>lenguet</td>
      <td>sviriel</td>
      <td>mizmar</td>
      <td>- to be proposed -</td>
      <td>reed</td>
    </tr>
    <tr>
      <td>clite</td>
      <td>li</td>
      <td>palait</td>
      <td>cict</td>
      <td>kortes</td>
      <td>viejliv</td>
      <td>lutf</td>
      <td>cicta kortesa lutfa</td>
      <td>polite</td>
    </tr>
    <tr>
      <td>pulji</td>
      <td>jin</td>
      <td>palis</td>
      <td>pulis</td>
      <td>polisi</td>
      <td>palisii</td>
      <td>bulis</td>
      <td>- to be proposed -</td>
      <td>police</td>
    </tr>
    <tr>
      <td>pindi</td>
      <td>pin</td>
      <td>indijnt</td>
      <td>nirdan</td>
      <td>indixent</td>
      <td>biedn</td>
      <td>mudim</td>
      <td>nirdana</td>
      <td>poor</td>
    </tr>
    <tr>
      <td>pipno</td>
      <td>jianpan</td>
      <td>piano</td>
      <td>piano</td>
      <td>pian</td>
      <td>pian</td>
      <td>biano</td>
      <td>- to be proposed -</td>
      <td>piano</td>
    </tr>
    <tr>
      <td>derxi</td>
      <td>duei</td>
      <td>xip</td>
      <td>der</td>
      <td>rimer</td>
      <td>kip</td>
      <td>kadas</td>
      <td>- to be proposed -</td>
      <td>heap</td>
    </tr>
    <tr>
      <td>sombo</td>
      <td>bo</td>
      <td>so</td>
      <td>bona</td>
      <td>sembr</td>
      <td>zasiv</td>
      <td>zara</td>
      <td>- to be proposed -</td>
      <td>sow</td>
    </tr>
    <tr>
      <td>minra</td>
      <td>jin</td>
      <td>mirr</td>
      <td>aina</td>
      <td>espex</td>
      <td>zierkal</td>
      <td>mira</td>
      <td>- to be proposed -</td>
      <td>reflect</td>
    </tr>
    <tr>
      <td>manri</td>
      <td>an</td>
      <td>standrd</td>
      <td>manak</td>
      <td>kriteri</td>
      <td>miril</td>
      <td>miiar</td>
      <td>kriteri</td>
      <td>reference</td>
    </tr>
    <tr>
      <td>kecti</td>
      <td>keci</td>
      <td>piti</td>
      <td>ked</td>
      <td>sent</td>
      <td>jal</td>
      <td>asif</td>
      <td>senta</td>
      <td>pity</td>
    </tr>
    <tr>
      <td>guska</td>
      <td>gua</td>
      <td>skreip</td>
      <td>gis</td>
      <td>rask</td>
      <td>skabl</td>
      <td>xaka</td>
      <td>raska</td>
      <td>scrape</td>
    </tr>
    <tr>
      <td>fanta</td>
      <td>fan</td>
      <td>pravent</td>
      <td>tal</td>
      <td>evit</td>
      <td>pridatvrac</td>
      <td>mana</td>
      <td>- to be proposed -</td>
      <td>prevent</td>
    </tr>
    <tr>
      <td>ritli</td>
      <td>li</td>
      <td>rait</td>
      <td>riti</td>
      <td>rit</td>
      <td>ritual</td>
      <td>marasim</td>
      <td>- to be proposed -</td>
      <td>rite</td>
    </tr>
    <tr>
      <td>spuda</td>
      <td>da</td>
      <td>rispand</td>
      <td>utar</td>
      <td>respond</td>
      <td>atvic</td>
      <td>rada</td>
      <td>- to be proposed -</td>
      <td>reply</td>
    </tr>
    <tr>
      <td>canci</td>
      <td>cian</td>
      <td>vanic</td>
      <td>antargan</td>
      <td>desvanes</td>
      <td>isciz</td>
      <td>tauara</td>
      <td>- to be proposed -</td>
      <td>vanish</td>
    </tr>
    <tr>
      <td>caxno</td>
      <td>cian</td>
      <td>calo</td>
      <td>cical</td>
      <td>bax</td>
      <td>mielk</td>
      <td>daxl</td>
      <td>daxla</td>
      <td>shallow</td>
    </tr>
    <tr>
      <td>datni</td>
      <td>tunji</td>
      <td>data</td>
      <td>sankikia</td>
      <td>estadistik</td>
      <td>dani</td>
      <td>ixsa</td>
      <td>tunji ixsa</td>
      <td>data</td>
    </tr>
    <tr>
      <td>jalna</td>
      <td>jian</td>
      <td>starc</td>
      <td>kalaf</td>
      <td>almidon</td>
      <td>kraxmal</td>
      <td>naca</td>
      <td>- to be proposed -</td>
      <td>starch</td>
    </tr>
    <tr>
      <td>janco</td>
      <td>jian</td>
      <td>coldr</td>
      <td>kand</td>
      <td>ombr</td>
      <td>plico</td>
      <td>mankib</td>
      <td>kanda plico mankiba</td>
      <td>shoulder</td>
    </tr>
    <tr>
      <td>jukni</td>
      <td>ju</td>
      <td>araknid</td>
      <td>makri</td>
      <td>araknid</td>
      <td>pauk</td>
      <td>ankabut</td>
      <td>makri</td>
      <td>spider</td>
    </tr>
    <tr>
      <td>jutsi</td>
      <td>jun</td>
      <td>spisiz</td>
      <td>jati</td>
      <td>espesi</td>
      <td>vit</td>
      <td>fasil</td>
      <td>spisiza</td>
      <td>species</td>
    </tr>
    <tr>
      <td>rijno</td>
      <td>iin</td>
      <td>arjent</td>
      <td>rajat</td>
      <td>arxentos</td>
      <td>siribro</td>
      <td>fida</td>
      <td>- to be proposed -</td>
      <td>silver</td>
    </tr>
    <tr>
      <td>sanso</td>
      <td>jian</td>
      <td>sas</td>
      <td>salan</td>
      <td>sals</td>
      <td>sous</td>
      <td>salsa</td>
      <td>salsa</td>
      <td>sauce</td>
    </tr>
    <tr>
      <td>senci</td>
      <td>penti</td>
      <td>sniz</td>
      <td>cik</td>
      <td>estornud</td>
      <td>cix</td>
      <td>atas</td>
      <td>penti sniza</td>
      <td>sneeze</td>
    </tr>
    <tr>
      <td>since</td>
      <td>ce</td>
      <td>sneik</td>
      <td>sanp</td>
      <td>sierp</td>
      <td>zmii</td>
      <td>tuban</td>
      <td>sanpa</td>
      <td>snake</td>
    </tr>
    <tr>
      <td>slaka</td>
      <td>iinjie</td>
      <td>silabl</td>
      <td>akcar</td>
      <td>silab</td>
      <td>slok</td>
      <td>makta</td>
      <td>akcara sloka makta</td>
      <td>syllable</td>
    </tr>
    <tr>
      <td>sodna</td>
      <td>na</td>
      <td>sodiam</td>
      <td>sodiam</td>
      <td>sod</td>
      <td>natri</td>
      <td>sodium</td>
      <td>natri</td>
      <td>sodium</td>
    </tr>
    <tr>
      <td>tinsa</td>
      <td>iin</td>
      <td>stif</td>
      <td>sakt</td>
      <td>ties</td>
      <td>jiostk</td>
      <td>salib</td>
      <td>stifa sakta</td>
      <td>stiff</td>
    </tr>
    <tr>
      <td>tsani</td>
      <td>tian</td>
      <td>skai</td>
      <td>asman</td>
      <td>siel</td>
      <td>nieb</td>
      <td>sama</td>
      <td>- to be proposed -</td>
      <td>sky</td>
    </tr>
    <tr>
      <td>tunba</td>
      <td>cuen</td>
      <td>vernl</td>
      <td>vasant</td>
      <td>primaver</td>
      <td>visna</td>
      <td>rabia</td>
      <td>visna</td>
      <td>sibling</td>
    </tr>
    <tr>
      <td>tcini</td>
      <td>cin</td>
      <td>steit</td>
      <td>stiti</td>
      <td>situasion</td>
      <td>sastaiani</td>
      <td>kaif</td>
      <td>stiti</td>
      <td>situation</td>
    </tr>
    <tr>
      <td>cinje</td>
      <td>je</td>
      <td>rinkl</td>
      <td>cikan</td>
      <td>arug</td>
      <td>morc</td>
      <td>jada</td>
      <td>morca</td>
      <td>wrinkle</td>
    </tr>
    <tr>
      <td>citsi</td>
      <td>ci</td>
      <td>sizn</td>
      <td>ritu</td>
      <td>esatsion</td>
      <td>sizon</td>
      <td>fasl</td>
      <td>sizna fasla</td>
      <td>season</td>
    </tr>
    <tr>
      <td>jicla</td>
      <td>jiau</td>
      <td>str</td>
      <td>cala</td>
      <td>axit</td>
      <td>mic</td>
      <td>kalab</td>
      <td>- to be proposed -</td>
      <td>stir</td>
    </tr>
    <tr>
      <td>mansa</td>
      <td>man</td>
      <td>satisfai</td>
      <td>prasan</td>
      <td>satisfas</td>
      <td>udavlitvar</td>
      <td>akna</td>
      <td>prasana akna</td>
      <td>satisfy</td>
    </tr>
    <tr>
      <td>rebla</td>
      <td>ueiba</td>
      <td>teil</td>
      <td>langul</td>
      <td>rab</td>
      <td>xvost</td>
      <td>danal</td>
      <td>langula</td>
      <td>tail</td>
    </tr>
    <tr>
      <td>boxfo</td>
      <td>bo</td>
      <td>foil</td>
      <td>tav</td>
      <td>ox</td>
      <td>folg</td>
      <td>uarak</td>
      <td>folga</td>
      <td>sheet</td>
    </tr>
    <tr>
      <td>sarlu</td>
      <td>lue</td>
      <td>spairl</td>
      <td>sarpil</td>
      <td>espiral</td>
      <td>spiral</td>
      <td>laulab</td>
      <td>sarpila spirala</td>
      <td>spiral</td>
    </tr>
    <tr>
      <td>tadni</td>
      <td>ianjieu</td>
      <td>stadi</td>
      <td>adiai</td>
      <td>estudi</td>
      <td>studient</td>
      <td>talib</td>
      <td>stadi</td>
      <td>study</td>
    </tr>
    <tr>
      <td>tunta</td>
      <td>tun</td>
      <td>stab</td>
      <td>bonk</td>
      <td>puns</td>
      <td>talk</td>
      <td>tana</td>
      <td>staba bonka punsa talka</td>
      <td>poke</td>
    </tr>
    <tr>
      <td>stati</td>
      <td>sai</td>
      <td>talnt</td>
      <td>pratib</td>
      <td>talent</td>
      <td>talant</td>
      <td>nabig</td>
      <td>pratiba</td>
      <td>talent</td>
    </tr>
    <tr>
      <td>kruca</td>
      <td>ca</td>
      <td>kras</td>
      <td>kras</td>
      <td>krus</td>
      <td>kriest</td>
      <td>salib</td>
      <td>krasa krusa</td>
      <td>intersect</td>
    </tr>
    <tr>
      <td>jalge</td>
      <td>jiegue</td>
      <td>rizalt</td>
      <td>pal</td>
      <td>result</td>
      <td>slietstvi</td>
      <td>najam</td>
      <td>- to be proposed -</td>
      <td>result</td>
    </tr>
    <tr>
      <td>cribe</td>
      <td>cien</td>
      <td>ber</td>
      <td>ric</td>
      <td>os</td>
      <td>medvet</td>
      <td>dub</td>
      <td>medveta</td>
      <td>bear</td>
    </tr>
    <tr>
      <td>gunma</td>
      <td>gun</td>
      <td>mas</td>
      <td>der</td>
      <td>mas</td>
      <td>mas</td>
      <td>jamai</td>
      <td>- to be proposed -</td>
      <td>jointly</td>
    </tr>
    <tr>
      <td>kandi</td>
      <td>an</td>
      <td>dim</td>
      <td>mand</td>
      <td>opskur</td>
      <td>tuskl</td>
      <td>kamid</td>
      <td>manda</td>
      <td>dim</td>
    </tr>
    <tr>
      <td>plibu</td>
      <td>iinbu</td>
      <td>piub</td>
      <td>iaungrant</td>
      <td>xenital</td>
      <td>palavi</td>
      <td>tanasuli</td>
      <td>- to be proposed -</td>
      <td>pubic</td>
    </tr>
    <tr>
      <td>ractu</td>
      <td>tu</td>
      <td>rabit</td>
      <td>cac</td>
      <td>liebr</td>
      <td>krolik</td>
      <td>arnab</td>
      <td>krolika arnaba</td>
      <td>rabbit</td>
    </tr>
    <tr>
      <td>sufti</td>
      <td>ti</td>
      <td>xuf</td>
      <td>sum</td>
      <td>pesuni</td>
      <td>kapit</td>
      <td>dilab</td>
      <td>- to be proposed -</td>
      <td>hoof</td>
    </tr>
    <tr>
      <td>vlagi</td>
      <td>gangan</td>
      <td>levr</td>
      <td>utolak</td>
      <td>palank</td>
      <td>ricag</td>
      <td>rafia</td>
      <td>gangana levra</td>
      <td>vulva</td>
    </tr>
    <tr>
      <td>klesi</td>
      <td>lei</td>
      <td>klas</td>
      <td>varg</td>
      <td>klas</td>
      <td>klas</td>
      <td>sinaf</td>
      <td>klasa varga</td>
      <td>class</td>
    </tr>
    <tr>
      <td>cecla</td>
      <td>ce</td>
      <td>lanc</td>
      <td>cala</td>
      <td>ec</td>
      <td>stril</td>
      <td>kadafa</td>
      <td>lanca</td>
      <td>launcher</td>
    </tr>
    <tr>
      <td>cliva</td>
      <td>li</td>
      <td>liv</td>
      <td>calan</td>
      <td>va</td>
      <td>it</td>
      <td>daxab</td>
      <td>- to be proposed -</td>
      <td>leave</td>
    </tr>
    <tr>
      <td>mirli</td>
      <td>mi</td>
      <td>dir</td>
      <td>mrig</td>
      <td>sierv</td>
      <td>alien</td>
      <td>aial</td>
      <td>mriga</td>
      <td>deer</td>
    </tr>
    <tr>
      <td>makcu</td>
      <td>cu</td>
      <td>matiur</td>
      <td>pak</td>
      <td>madur</td>
      <td>matior</td>
      <td>iktimal</td>
      <td>- to be proposed -</td>
      <td>mature</td>
    </tr>
    <tr>
      <td>notci</td>
      <td>cin</td>
      <td>not</td>
      <td>not</td>
      <td>not</td>
      <td>mimarandum</td>
      <td>mudakir</td>
      <td>- to be proposed -</td>
      <td>message</td>
    </tr>
    <tr>
      <td>benji</td>
      <td>ji</td>
      <td>send</td>
      <td>bej</td>
      <td>envi</td>
      <td>pasl</td>
      <td>arsal</td>
      <td>senda envi pasla arsala</td>
      <td>transfer</td>
    </tr>
    <tr>
      <td>zdani</td>
      <td>fan</td>
      <td>den</td>
      <td>nir</td>
      <td>nid</td>
      <td>gnizdo</td>
      <td>uakr</td>
      <td>- to be proposed -</td>
      <td>nest</td>
    </tr>
    <tr>
      <td>kantu</td>
      <td>guan</td>
      <td>kuant</td>
      <td>kan</td>
      <td>kuant</td>
      <td>kvant</td>
      <td>alkam</td>
      <td>alkama</td>
      <td>quantum</td>
    </tr>
    <tr>
      <td>karni</td>
      <td>kan</td>
      <td>jrnl</td>
      <td>patrik</td>
      <td>diari</td>
      <td>jurnal</td>
      <td>jarid</td>
      <td>jurnala</td>
      <td>journal</td>
    </tr>
    <tr>
      <td>grana</td>
      <td>gan</td>
      <td>rad</td>
      <td>danda</td>
      <td>vara</td>
      <td>prut</td>
      <td>asa</td>
      <td>danda pruta</td>
      <td>rod</td>
    </tr>
    <tr>
      <td>pilka</td>
      <td>pi</td>
      <td>pil</td>
      <td>kal</td>
      <td>piel</td>
      <td>kaj</td>
      <td>jild</td>
      <td>jilda</td>
      <td>crust</td>
    </tr>
    <tr>
      <td>girzu</td>
      <td>zu</td>
      <td>grup</td>
      <td>set</td>
      <td>grup</td>
      <td>grup</td>
      <td>firk</td>
      <td>grupa firka</td>
      <td>group</td>
    </tr>
    <tr>
      <td>patxu</td>
      <td>xu</td>
      <td>pat</td>
      <td>patr</td>
      <td>pot</td>
      <td>katiol</td>
      <td>kitli</td>
      <td>patra kitli</td>
      <td>pot</td>
    </tr>
    <tr>
      <td>cfine</td>
      <td>cie</td>
      <td>uej</td>
      <td>fan</td>
      <td>kun</td>
      <td>klin</td>
      <td>isfin</td>
      <td>klina</td>
      <td>wedge</td>
    </tr>
    <tr>
      <td>ckunu</td>
      <td>cieugue</td>
      <td>kon</td>
      <td>canku</td>
      <td>kon</td>
      <td>cick</td>
      <td>kuz</td>
      <td>canku cicka</td>
      <td>conifer</td>
    </tr>
    <tr>
      <td>jinto</td>
      <td>jin</td>
      <td>sprin</td>
      <td>kuan</td>
      <td>font</td>
      <td>istoc</td>
      <td>bir</td>
      <td>fonta</td>
      <td>well</td>
    </tr>
    <tr>
      <td>labno</td>
      <td>lan</td>
      <td>lupain</td>
      <td>xundar</td>
      <td>lob</td>
      <td>volk</td>
      <td>dinab</td>
      <td>xundara volka</td>
      <td>wolf</td>
    </tr>
    <tr>
      <td>lorxu</td>
      <td>xu</td>
      <td>faks</td>
      <td>lomri</td>
      <td>zor</td>
      <td>lisa</td>
      <td>talab</td>
      <td>faksa lomri</td>
      <td>fox</td>
    </tr>
    <tr>
      <td>cerda</td>
      <td>jicen</td>
      <td>er</td>
      <td>daid</td>
      <td>xered</td>
      <td>naslied</td>
      <td>uarit</td>
      <td>- to be proposed -</td>
      <td>heir</td>
    </tr>
    <tr>
      <td>cigla</td>
      <td>cian</td>
      <td>gland</td>
      <td>granti</td>
      <td>glandul</td>
      <td>jiliza</td>
      <td>guda</td>
      <td>- to be proposed -</td>
      <td>gland</td>
    </tr>
    <tr>
      <td>danti</td>
      <td>dan</td>
      <td>balistik</td>
      <td>astra</td>
      <td>balistik</td>
      <td>balisticesk</td>
      <td>kadif</td>
      <td>- to be proposed -</td>
      <td>projectile</td>
    </tr>
    <tr>
      <td>desku</td>
      <td>deu</td>
      <td>ceik</td>
      <td>xilan</td>
      <td>sakud</td>
      <td>triisti</td>
      <td>xaz</td>
      <td>- to be proposed -</td>
      <td>shake</td>
    </tr>
    <tr>
      <td>figre</td>
      <td>uuxuague</td>
      <td>fig</td>
      <td>anjir</td>
      <td>xig</td>
      <td>fig</td>
      <td>tina</td>
      <td>anjira</td>
      <td>fig</td>
    </tr>
    <tr>
      <td>jbera</td>
      <td>jeu</td>
      <td>spindl</td>
      <td>duri</td>
      <td>exe</td>
      <td>cpindil</td>
      <td>mixuar</td>
      <td>- to be proposed -</td>
      <td>borrow</td>
    </tr>
    <tr>
      <td>jinru</td>
      <td>jin</td>
      <td>imrs</td>
      <td>nimjit</td>
      <td>inmersion</td>
      <td>pagruj</td>
      <td>gatas</td>
      <td>nimjita</td>
      <td>immerse</td>
    </tr>
    <tr>
      <td>kojna</td>
      <td>jiau</td>
      <td>kornr</td>
      <td>kona</td>
      <td>rinkon</td>
      <td>ugal</td>
      <td>kurna</td>
      <td>rinkona kurna</td>
      <td>corner</td>
    </tr>
    <tr>
      <td>pulni</td>
      <td>xualun</td>
      <td>puli</td>
      <td>girni</td>
      <td>pole</td>
      <td>ckif</td>
      <td>tanbur</td>
      <td>girni ckifa tanbura</td>
      <td>pulley</td>
    </tr>
    <tr>
      <td>ranxi</td>
      <td>fanxua</td>
      <td>airni</td>
      <td>viangia</td>
      <td>ironi</td>
      <td>ironi</td>
      <td>taxakum</td>
      <td>- to be proposed -</td>
      <td>irony</td>
    </tr>
    <tr>
      <td>tengu</td>
      <td>jiegeu</td>
      <td>tekscr</td>
      <td>gatan</td>
      <td>tekstur</td>
      <td>straien</td>
      <td>tarkib</td>
      <td>tarkiba</td>
      <td>texture</td>
    </tr>
    <tr>
      <td>vitke</td>
      <td>ke</td>
      <td>vizit</td>
      <td>atiti</td>
      <td>visit</td>
      <td>gost</td>
      <td>daif</td>
      <td>gosta</td>
      <td>guest</td>
    </tr>
    <tr>
      <td>xadba</td>
      <td>ban</td>
      <td>xaf</td>
      <td>ada</td>
      <td>mitad</td>
      <td>pal</td>
      <td>nisfu</td>
      <td>nisfu</td>
      <td>half</td>
    </tr>
    <tr>
      <td>xedja</td>
      <td>xe</td>
      <td>ja</td>
      <td>jabra</td>
      <td>kixad</td>
      <td>cielivst</td>
      <td>fak</td>
      <td>jabra</td>
      <td>jaw</td>
    </tr>
    <tr>
      <td>xenru</td>
      <td>xen</td>
      <td>ru</td>
      <td>pacatap</td>
      <td>sent</td>
      <td>jaliet</td>
      <td>taxasar</td>
      <td>senta</td>
      <td>regret</td>
    </tr>
    <tr>
      <td>catra</td>
      <td>ca</td>
      <td>slatr</td>
      <td>xatia</td>
      <td>mat</td>
      <td>trav</td>
      <td>katal</td>
      <td>trava</td>
      <td>kill</td>
    </tr>
    <tr>
      <td>cfari</td>
      <td>fa</td>
      <td>start</td>
      <td>aramb</td>
      <td>prinsipi</td>
      <td>nacin</td>
      <td>cara</td>
      <td>- to be proposed -</td>
      <td>initiate</td>
    </tr>
    <tr>
      <td>cmoni</td>
      <td>ceniin</td>
      <td>mon</td>
      <td>karax</td>
      <td>gem</td>
      <td>ston</td>
      <td>unin</td>
      <td>stona</td>
      <td>moan</td>
    </tr>
    <tr>
      <td>cpina</td>
      <td>cin</td>
      <td>piknt</td>
      <td>tikcna</td>
      <td>pikante</td>
      <td>pikantn</td>
      <td>xadi</td>
      <td>- to be proposed -</td>
      <td>pungent</td>
    </tr>
    <tr>
      <td>jipno</td>
      <td>jian</td>
      <td>tip</td>
      <td>nok</td>
      <td>punt</td>
      <td>koncik</td>
      <td>taraf</td>
      <td>punta koncika</td>
      <td>tip</td>
    </tr>
    <tr>
      <td>tonga</td>
      <td>iingau</td>
      <td>ton</td>
      <td>tan</td>
      <td>ton</td>
      <td>visata</td>
      <td>tanak</td>
      <td>- to be proposed -</td>
      <td>tone</td>
    </tr>
    <tr>
      <td>xabju</td>
      <td>ju</td>
      <td>inxabit</td>
      <td>nivas</td>
      <td>xabit</td>
      <td>abit</td>
      <td>xal</td>
      <td>- to be proposed -</td>
      <td>dwell</td>
    </tr>
    <tr>
      <td>stodi</td>
      <td>din</td>
      <td>steibl</td>
      <td>stir</td>
      <td>konstant</td>
      <td>stoik</td>
      <td>mustamir</td>
      <td>stira</td>
      <td>constant</td>
    </tr>
    <tr>
      <td>talsa</td>
      <td>tiaujan</td>
      <td>calnj</td>
      <td>lalkar</td>
      <td>desafi</td>
      <td>aspariv</td>
      <td>taxada</td>
      <td>lalkara</td>
      <td>challenge</td>
    </tr>
    <tr>
      <td>mokca</td>
      <td>ca</td>
      <td>momnt</td>
      <td>kcan</td>
      <td>moment</td>
      <td>mik</td>
      <td>xunixa</td>
      <td>- to be proposed -</td>
      <td>point</td>
    </tr>
    <tr>
      <td>tsapi</td>
      <td>tiauueipin</td>
      <td>spais</td>
      <td>masala</td>
      <td>alin</td>
      <td>spietsi</td>
      <td>tabil</td>
      <td>- to be proposed -</td>
      <td>seasoning</td>
    </tr>
    <tr>
      <td>randa</td>
      <td>cian</td>
      <td>srendr</td>
      <td>man</td>
      <td>rend</td>
      <td>sdav</td>
      <td>atmara</td>
      <td>renda atmara</td>
      <td>yield</td>
    </tr>
    <tr>
      <td>vitno</td>
      <td>iun</td>
      <td>itrnl</td>
      <td>nitia</td>
      <td>eterno</td>
      <td>viecn</td>
      <td>tabit</td>
      <td>- to be proposed -</td>
      <td>permanent</td>
    </tr>
    <tr>
      <td>pikci</td>
      <td>ci</td>
      <td>saplikeit</td>
      <td>bik</td>
      <td>suplik</td>
      <td>upraciv</td>
      <td>istajda</td>
      <td>- to be proposed -</td>
      <td>beg</td>
    </tr>
    <tr>
      <td>skuro</td>
      <td>sau</td>
      <td>fro</td>
      <td>kunr</td>
      <td>surk</td>
      <td>rof</td>
      <td>xandak</td>
      <td>kunra surka xandaka</td>
      <td>groove</td>
    </tr>
    <tr>
      <td>dekpu</td>
      <td>deu</td>
      <td>pek</td>
      <td>pudi</td>
      <td>kuartii</td>
      <td>boutilk</td>
      <td>ardeb</td>
      <td>ardeba</td>
      <td>gallon</td>
    </tr>
    <tr>
      <td>kramu</td>
      <td>mu</td>
      <td>eikr</td>
      <td>kaunie</td>
      <td>are</td>
      <td>deklatin</td>
      <td>fedan</td>
      <td>- to be proposed -</td>
      <td>acre</td>
    </tr>
    <tr>
      <td>gutci</td>
      <td>ci</td>
      <td>fut</td>
      <td>guz</td>
      <td>pie</td>
      <td>fut</td>
      <td>guz</td>
      <td>- to be proposed -</td>
      <td>cubit</td>
    </tr>
    <tr>
      <td>cidni</td>
      <td>ci</td>
      <td>ni</td>
      <td>gutna</td>
      <td>rodiia</td>
      <td>kaliena</td>
      <td>rukba</td>
      <td>gutna</td>
      <td>knee</td>
    </tr>
    <tr>
      <td>dinju</td>
      <td>jianju</td>
      <td>bildin</td>
      <td>imarat</td>
      <td>edifisi</td>
      <td>zdanii</td>
      <td>bina</td>
      <td>bildina</td>
      <td>building</td>
    </tr>
    <tr>
      <td>dizlo</td>
      <td>di</td>
      <td>lo</td>
      <td>nica</td>
      <td>baxo</td>
      <td>nizk</td>
      <td>uati</td>
      <td>- to be proposed -</td>
      <td>low</td>
    </tr>
    <tr>
      <td>kenra</td>
      <td>aijen</td>
      <td>kansr</td>
      <td>kensar</td>
      <td>kanser</td>
      <td>rak</td>
      <td>saratan</td>
      <td>kensara kansera</td>
      <td>cancer</td>
    </tr>
    <tr>
      <td>kijno</td>
      <td>ian</td>
      <td>aksijn</td>
      <td>oksijan</td>
      <td>oksixen</td>
      <td>kislarot</td>
      <td>okijen</td>
      <td>- to be proposed -</td>
      <td>oxygen</td>
    </tr>
    <tr>
      <td>xlura</td>
      <td>xua</td>
      <td>influans</td>
      <td>prabav</td>
      <td>influ</td>
      <td>vliian</td>
      <td>atara</td>
      <td>prabava</td>
      <td>influence</td>
    </tr>
    <tr>
      <td>zivle</td>
      <td>teuzi</td>
      <td>invest</td>
      <td>nivec</td>
      <td>invert</td>
      <td>vlaj</td>
      <td>istatmar</td>
      <td>vlaja</td>
      <td>invest</td>
    </tr>
    <tr>
      <td>cando</td>
      <td>cian</td>
      <td>aidl</td>
      <td>canti</td>
      <td>osio</td>
      <td>prazdn</td>
      <td>kaslan</td>
      <td>canti</td>
      <td>idle</td>
    </tr>
    <tr>
      <td>gapru</td>
      <td>gau</td>
      <td>ap</td>
      <td>upar</td>
      <td>ariba</td>
      <td>navirxu</td>
      <td>fauk</td>
      <td>- to be proposed -</td>
      <td>above</td>
    </tr>
    <tr>
      <td>jibri</td>
      <td>jiie</td>
      <td>job</td>
      <td>nakri</td>
      <td>trabax</td>
      <td>profies</td>
      <td>mansib</td>
      <td>nakri trabaxa mansiba</td>
      <td>job</td>
    </tr>
    <tr>
      <td>lunbe</td>
      <td>lue</td>
      <td>ber</td>
      <td>cunia</td>
      <td>desnudo</td>
      <td>gol</td>
      <td>muxrad</td>
      <td>- to be proposed -</td>
      <td>bare</td>
    </tr>
    <tr>
      <td>nobli</td>
      <td>gueizu</td>
      <td>nobl</td>
      <td>kulin</td>
      <td>noble</td>
      <td>dvarianin</td>
      <td>nabil</td>
      <td>nobla noble</td>
      <td>noble</td>
    </tr>
    <tr>
      <td>tunlo</td>
      <td>tun</td>
      <td>sualo</td>
      <td>lol</td>
      <td>trag</td>
      <td>glot</td>
      <td>izdarad</td>
      <td>traga glota</td>
      <td>swallow</td>
    </tr>
    <tr>
      <td>xusra</td>
      <td>xuan</td>
      <td>asrt</td>
      <td>balpurvak</td>
      <td>deklar</td>
      <td>zaiavl</td>
      <td>sarax</td>
      <td>- to be proposed -</td>
      <td>assert</td>
    </tr>
    <tr>
      <td>jinzi</td>
      <td>neizai</td>
      <td>ineit</td>
      <td>janmajat</td>
      <td>inat</td>
      <td>vrajdion</td>
      <td>jilki</td>
      <td>jilki</td>
      <td>innate</td>
    </tr>
    <tr>
      <td>ranmi</td>
      <td>cuanci</td>
      <td>mit</td>
      <td>puran</td>
      <td>mit</td>
      <td>mif</td>
      <td>jurafa</td>
      <td>- to be proposed -</td>
      <td>myth</td>
    </tr>
    <tr>
      <td>sabji</td>
      <td>ji</td>
      <td>saplai</td>
      <td>sambaran</td>
      <td>abastes</td>
      <td>abispiec</td>
      <td>jaxaz</td>
      <td>- to be proposed -</td>
      <td>provide</td>
    </tr>
    <tr>
      <td>jmifa</td>
      <td>jiau</td>
      <td>rif</td>
      <td>cicala</td>
      <td>baxi</td>
      <td>miel</td>
      <td>fauj</td>
      <td>- to be proposed -</td>
      <td>shoal</td>
    </tr>
    <tr>
      <td>skicu</td>
      <td>miaucu</td>
      <td>diskraib</td>
      <td>kinc</td>
      <td>deskrib</td>
      <td>opic</td>
      <td>rasam</td>
      <td>kinca</td>
      <td>describe</td>
    </tr>
    <tr>
      <td>cfila</td>
      <td>cia</td>
      <td>fla</td>
      <td>truti</td>
      <td>falt</td>
      <td>nidastat</td>
      <td>jalal</td>
      <td>truti falta</td>
      <td>flaw</td>
    </tr>
    <tr>
      <td>cedra</td>
      <td>cidai</td>
      <td>era</td>
      <td>sanvat</td>
      <td>era</td>
      <td>era</td>
      <td>asar</td>
      <td>sanvata</td>
      <td>era</td>
    </tr>
    <tr>
      <td>crida</td>
      <td>cian</td>
      <td>feri</td>
      <td>pari</td>
      <td>ada</td>
      <td>damav</td>
      <td>marid</td>
      <td>- to be proposed -</td>
      <td>fairy</td>
    </tr>
    <tr>
      <td>donri</td>
      <td>ri</td>
      <td>deitaim</td>
      <td>din</td>
      <td>di</td>
      <td>dien</td>
      <td>naxar</td>
      <td>- to be proposed -</td>
      <td>daytime</td>
    </tr>
    <tr>
      <td>nimre</td>
      <td>ninmen</td>
      <td>sitr</td>
      <td>nimbu</td>
      <td>sidr</td>
      <td>limon</td>
      <td>-</td>
      <td>ninmena sitra nimbu sidra</td>
      <td>citrus</td>
    </tr>
    <tr>
      <td>vrude</td>
      <td>de</td>
      <td>vrtiu</td>
      <td>- to be proposed -</td>
      <td>virtud</td>
      <td>dabradietil</td>
      <td>afifun</td>
      <td>virtuda</td>
      <td>virtue</td>
    </tr>
    <tr>
      <td>cicna</td>
      <td>cin</td>
      <td>saian</td>
      <td>- to be proposed -</td>
      <td>- to be proposed -</td>
      <td>sian</td>
      <td>sian</td>
      <td>- to be proposed -</td>
      <td>cyan</td>
    </tr>
    <tr>
      <td>lanbi</td>
      <td>danbai</td>
      <td>albiumin</td>
      <td>lavan</td>
      <td>albumin</td>
      <td>bilok</td>
      <td>zulalun</td>
      <td>- to be proposed -</td>
      <td>protein</td>
    </tr>
    <tr>
      <td>marna</td>
      <td>ma</td>
      <td>merauana</td>
      <td>caras</td>
      <td>kaniam</td>
      <td>marixuan</td>
      <td>kinab</td>
      <td>- to be proposed -</td>
      <td>hemp</td>
    </tr>
    <tr>
      <td>nukni</td>
      <td>ianxun</td>
      <td>fuksin</td>
      <td>bagani</td>
      <td>fuksi</td>
      <td>fuksin</td>
      <td>kirmiz</td>
      <td>fuksina fuksi kirmiza</td>
      <td>magenta</td>
    </tr>
    <tr>
      <td>tamne</td>
      <td>tan</td>
      <td>kazn</td>
      <td>mamer</td>
      <td>prim</td>
      <td>rodstven</td>
      <td>ami</td>
      <td>kazna prima</td>
      <td>cousin</td>
    </tr>
    <tr>
      <td>xruba</td>
      <td>daxuan</td>
      <td>rubarb</td>
      <td>- to be proposed -</td>
      <td>ruibarb</td>
      <td>gricix</td>
      <td>ribas</td>
      <td>gricixa</td>
      <td>buckwheat</td>
    </tr>
    <tr>
      <td>famti</td>
      <td>fumu</td>
      <td>ant</td>
      <td>mama</td>
      <td>ti</td>
      <td>tiotia</td>
      <td>am</td>
      <td>anta</td>
      <td>aunt or uncle</td>
    </tr>
    <tr>
      <td>jdika</td>
      <td>jian</td>
      <td>dikris</td>
      <td>kam</td>
      <td>dekres</td>
      <td>uminc</td>
      <td>ankas</td>
      <td>ankasa</td>
      <td>decrease</td>
    </tr>
    <tr>
      <td>kobli</td>
      <td>baisai</td>
      <td>kol</td>
      <td>gobi</td>
      <td>kol</td>
      <td>kapust</td>
      <td>kurunb</td>
      <td>- to be proposed -</td>
      <td>cabbage</td>
    </tr>
    <tr>
      <td>dzena</td>
      <td>zen</td>
      <td>grandpernt</td>
      <td>nana</td>
      <td>abol</td>
      <td>died</td>
      <td>salaf</td>
      <td>- to be proposed -</td>
      <td>elder</td>
    </tr>
    <tr>
      <td>rorci</td>
      <td>cin</td>
      <td>prokrieit</td>
      <td>krti</td>
      <td>prokre</td>
      <td>rod</td>
      <td>taualud</td>
      <td>- to be proposed -</td>
      <td>procreate</td>
    </tr>
    <tr>
      <td>murse</td>
      <td>muse</td>
      <td>glimer</td>
      <td>bramamuxurt</td>
      <td>penumbr</td>
      <td>sumirki</td>
      <td>nurul</td>
      <td>glimera</td>
      <td>glimmering</td>
    </tr>
    <tr>
      <td>samcu</td>
      <td>cu</td>
      <td>iam</td>
      <td>sabudan</td>
      <td>niam</td>
      <td>iams</td>
      <td>iam</td>
      <td>- to be proposed -</td>
      <td>cassava</td>
    </tr>
  </tbody>
</table>
    </div>
  </div>
)

export default Comp;



// WEBPACK FOOTER //
// ./client/components/liberated.js